/**
 * A function to create a log object for the 'uButtonClickedFromScreenWithInput' event (evid: 5)
 *
 * Event description: When user clicks on a button from a screen in which he filled input information
 *
 * @param {uButtonClickedFromScreenWithInputParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - unique hype user id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - current screen/tab/specific description of location
 * @property {GUID} uouSessionId - uou_session_id
 * @property {string} cycleName - the cycle that the user chose
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {string} buttonName - the name of the button
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} inputJson - json of all fields and the chosen values
 * @property {number} sale - discount percentage
 * @property {string} packageId - package_id
 * @property {string} packageName - elite, ultimate, essential
 * @return {LogObject<uButtonClickedFromScreenWithInputParams>} LogObject<uButtonClickedFromScreenWithInputParams>
 */
export function uButtonClickedFromScreenWithInput(params) {
    return { evid: 5, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uApiMethodCalled' event (evid: 65)
 *
 * Event description: when user api method is called
 *
 * @param {uApiMethodCalledParams} params - The parameters for this event
 * @property {string} apiMethodArgs - api method args
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} apiMethodName - api method name
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uApiMethodCalledParams>} LogObject<uApiMethodCalledParams>
 */
export function uApiMethodCalled(params) {
    return { evid: 65, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumSuccessDismiss' event (evid: 85)
 *
 * Event description: When the premium purchase successes
 *
 * @param {premiumSuccessDismissParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {string} cycleName - the cycle the user chose
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {string} buttonName - done/dismiss
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} inputJson - inputJson
 * @property {string} packageName - elite, ultimate, essential
 * @property {string} packageId - package_id
 * @property {number} sale - discountPercentage
 * @return {LogObject<premiumSuccessDismissParams>} LogObject<premiumSuccessDismissParams>
 */
export function premiumSuccessDismiss(params) {
    return { evid: 85, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumFlowStarted' event (evid: 86)
 *
 * Event description: when the premium flows started
 *
 * @param {premiumFlowStartedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} triggerFeature - trigger feature
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {string} contextType - context type
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} violatedFeatures - violated feature
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {string} buttonName - button name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} inputJson - json of all fields and the chosen values
 * @return {LogObject<premiumFlowStartedParams>} LogObject<premiumFlowStartedParams>
 */
export function premiumFlowStarted(params) {
    return { evid: 86, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantChatContentView' event (evid: 2710)
 *
 * Event description: chat content view
 *
 * @param {aiAssistantChatContentViewParams} params - The parameters for this event
 * @property {string} provider - 'user' | 'assistant'
 * @property {string} platformName - hardcoded as 'dashboard' (BM)
 * @property {string} contentVersion - 'text' for text messages, widget name for widgets
 * @property {string} contentType - 'text' | 'widget'
 * @property {string} origin - your vertical/team name
 * @property {GUID} conversationId - unique id of a conversation
 * @property {string} content - raw message content
 * @property {number} orderIndex - order index of the message
 * @property {string} referenceId - the ID of the skill/spi/assistant
 * @property {string} referenceType - the type of the assistant: skill/spi/assistant
 * @property {string} attachments - all the attachment files in this message
 * @property {string} additionalData - additional data for verticals usage
 * @property {string} domainId - domainId
 * @property {string} pageUrl - url of the current page where the message is shown
 * @property {string} wixRequestId - request id of the request created the message
 * @property {GUID} previousConversationId - only if the chat message sent from chat history
 * @property {string} widgetDescription - a meaningful name of the widget
 * @property {string} widgetType - the type of the widget: SINGLE_SELECT_WIDGET, MULTI_SELECT_WIDGET...
 * @return {LogObject<aiAssistantChatContentViewParams>} LogObject<aiAssistantChatContentViewParams>
 */
export function aiAssistantChatContentView(params) {
    return { evid: 2710, src: 171, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantActionsInTypingConsoleSrc171Evid2711' event (evid: 2711)
 *
 * Event description: AI Assistant - Actions In Typing Console
 *
 * @param {aiAssistantActionsInTypingConsoleSrc171Evid2711Params} params - The parameters for this event
 * @property {string} platformName - hardcoded as 'dashboard' (BM)
 * @property {string} section - 'header' | 'console'
 * @property {string} previousQuestionContent - last message content
 * @property {string} origin - your vertical/team name
 * @property {GUID} conversationId - unique id of a conversation
 * @property {number} orderIndex - the index of the last message
 * @property {string} value - for action="answer" – the answer that the user typed
 * @property {string} action - 'close' | 'clear' | 'type' | 'answer'| 'generate'
 * @property {string} referenceId - the ID of the skill/spi/assistant
 * @property {string} referenceType - the type of the assistant: skill/spi/assistant
 * @property {string} additionalData - more data
 * @property {string} domainId - domainId
 * @property {string} wixRequestId - the request id that created the chat response, relevant only for chat messages
 * @return {LogObject<aiAssistantActionsInTypingConsoleSrc171Evid2711Params>} LogObject<aiAssistantActionsInTypingConsoleSrc171Evid2711Params>
 */
export function aiAssistantActionsInTypingConsoleSrc171Evid2711(params) {
    return { evid: 2711, src: 171, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantGeneralClicksSrc171Evid2712' event (evid: 2712)
 *
 * Event description: AI Assistant - General Clicks
 *
 * @param {aiAssistantGeneralClicksSrc171Evid2712Params} params - The parameters for this event
 * @property {string} platformName - platform name
 * @property {boolean} isAnswer - hardcoded as 'true'
 * @property {string} targetUrl - target_url
 * @property {string} assistantName - The assistant name
 * @property {string} contentVersion - widget name
 * @property {string} previousQuestionContent - previous message content
 * @property {string} origin - your vertical/team name
 * @property {GUID} conversationId - unique id of a conversation
 * @property {number} orderIndex - order index of the message
 * @property {string} answer - The full answer
 * @property {string} value - any data related to some action inside widget
 * @property {string} action - action name of event happened inside widget
 * @property {string} referenceId - the ID of the skill/spi/assistant
 * @property {string} referenceType - the type of the assistant: skill/spi/assistant
 * @property {string} additionalData - additional data for verticals usage
 * @property {string} domainId - domainId
 * @property {string} wixRequestId - the request id that created the chat response, relevant only for chat messages
 * @property {string} widgetType - the type of the widget
 * @property {string} widgetDescription - a meaningful name of the widget
 * @return {LogObject<aiAssistantGeneralClicksSrc171Evid2712Params>} LogObject<aiAssistantGeneralClicksSrc171Evid2712Params>
 */
export function aiAssistantGeneralClicksSrc171Evid2712(params) {
    return { evid: 2712, src: 171, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantPlatformOpenSrc171Evid2720' event (evid: 2720)
 *
 * Event description: AI Assistant - Platform Open
 *
 * @param {aiAssistantPlatformOpenSrc171Evid2720Params} params - The parameters for this event
 * @property {string} uuid - user id
 * @property {string} platformName - hardcoded as 'dashboard' (BM)
 * @property {GUID} conversationID - unique id of a conversation
 * @property {string} origin - your vertical/team name
 * @property {string} pageName - page name where your 'Open Assistant' button is located
 * @property {GUID} msid - metasite id
 * @property {string} referenceId - the ID of the skill/spi/assistant
 * @property {string} referenceType - the type of the assistant: skill/spi/assistant
 * @property {string} additionalData - more data
 * @property {string} domainId - domainId
 * @property {string} entryPointRefrenceId - refrence id of the entry point to the chat (when entering the unified from dedicated entry points)
 * @property {string} pageUrl - url of the current page where the message is shown
 * @return {LogObject<aiAssistantPlatformOpenSrc171Evid2720Params>} LogObject<aiAssistantPlatformOpenSrc171Evid2720Params>
 */
export function aiAssistantPlatformOpenSrc171Evid2720(params) {
    return { evid: 2720, src: 171, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantPlatformViewedSrc171Evid2721' event (evid: 2721)
 *
 * Event description: AI Assistant - Platform Viewed
 *
 * @param {aiAssistantPlatformViewedSrc171Evid2721Params} params - The parameters for this event
 * @property {string} uuid - user id
 * @property {string} platformName - hardcoded as 'dashboard' (BM)
 * @property {GUID} conversationID - unique id of a conversation
 * @property {string} origin - your vertical/team name
 * @property {string} pageName - page name where your 'Open Assistant' button is located
 * @property {GUID} msid - metasite id
 * @property {string} referenceId - the ID of the skill/spi/assistant
 * @property {string} referenceType - the type of the assistant: skill/spi/assistant
 * @property {string} additionalData - additional data for verticals usage
 * @property {string} domainId - domainId
 * @property {string} entryPointRefrenceId - refrence id of the entry point to the chat (when entering the unified from dedicated entry points)
 * @property {string} pageUrl - url of the current page where the message is shown
 * @return {LogObject<aiAssistantPlatformViewedSrc171Evid2721Params>} LogObject<aiAssistantPlatformViewedSrc171Evid2721Params>
 */
export function aiAssistantPlatformViewedSrc171Evid2721(params) {
    return { evid: 2721, src: 171, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantAssetShownOnDashboardSrc171Evid2730' event (evid: 2730)
 *
 * Event description: AI Assistant - Asset Shown On Dashboard
 *
 * @param {aiAssistantAssetShownOnDashboardSrc171Evid2730Params} params - The parameters for this event
 * @property {string} assetId - asset_id
 * @property {string} section - place name on the page where your 'Open Assistant' button is located
 * @property {string} origin - your vertical/team name
 * @property {string} referenceId - the ID of the skill/spi/assistant
 * @property {string} referenceType - the type of the assistant: skill/spi/assistant
 * @property {string} additionalData - more data
 * @property {string} domainId - domainId
 * @property {string} pageName - the page where the component was shown at
 * @property {string} buttonName - button name of the entry point that was presented
 * @return {LogObject<aiAssistantAssetShownOnDashboardSrc171Evid2730Params>} LogObject<aiAssistantAssetShownOnDashboardSrc171Evid2730Params>
 */
export function aiAssistantAssetShownOnDashboardSrc171Evid2730(params) {
    return { evid: 2730, src: 171, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantClickInDashboardAssetSrc171Evid2731' event (evid: 2731)
 *
 * Event description: AI Assistant - Click In Dashboard Asset
 *
 * @param {aiAssistantClickInDashboardAssetSrc171Evid2731Params} params - The parameters for this event
 * @property {string} section - place name on the page where your 'Open Assistant' button is located
 * @property {string} origin - your vertical/team name
 * @property {string} buttonName - id of your 'Open Assistant' button
 * @property {string} referenceId - the ID of the skill/spi/assistant
 * @property {string} referenceType - the type of the assistant: skill/spi/assistant
 * @property {string} additionalData - more data
 * @property {string} domainId - unique domainId
 * @property {string} pageName - the page where the component was clicked at
 * @return {LogObject<aiAssistantClickInDashboardAssetSrc171Evid2731Params>} LogObject<aiAssistantClickInDashboardAssetSrc171Evid2731Params>
 */
export function aiAssistantClickInDashboardAssetSrc171Evid2731(params) {
    return { evid: 2731, src: 171, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantErrorShownSrc171Evid2732' event (evid: 2732)
 *
 * Event description: AI Assistant - Error Shown
 *
 * @param {aiAssistantErrorShownSrc171Evid2732Params} params - The parameters for this event
 * @property {string} provider - 'user' | 'assistant'
 * @property {string} platformName - hardcoded as 'dashboard' (BM) or 'admin-app'
 * @property {string} errorMessage - the error message
 * @property {string} origin - your vertical/team name
 * @property {GUID} conversationId - unique id of a conversation
 * @property {string} content - raw message content
 * @property {number} orderIndex - order index of the message
 * @property {string} type - error type
 * @property {string} referenceId - the ID of the skill/spi/assistant
 * @property {string} referenceType - the type of the assistant: skill/spi/assistant
 * @property {string} additionalData - more data
 * @property {string} domainId - domainId
 * @return {LogObject<aiAssistantErrorShownSrc171Evid2732Params>} LogObject<aiAssistantErrorShownSrc171Evid2732Params>
 */
export function aiAssistantErrorShownSrc171Evid2732(params) {
    return { evid: 2732, src: 171, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantUserFeedbackHoverSrc171Evid2750' event (evid: 2750)
 *
 * Event description: when the user hovers over feedback icon
 *
 * @param {aiAssistantUserFeedbackHoverSrc171Evid2750Params} params - The parameters for this event
 * @property {string} origin - your vertical/team name
 * @property {GUID} conversationId - unique id of a conversation
 * @property {string} content - raw message content
 * @property {number} orderIndex - order index of the message
 * @property {string} referenceId - the ID of the skill/spi/assistant
 * @property {string} referenceType - the type of the assistant: skill/spi/assistant
 * @property {string} section - console / header
 * @property {string} value - the message
 * @property {string} action - the action the user hovered over
 * @property {string} domainId - domainId
 * @return {LogObject<aiAssistantUserFeedbackHoverSrc171Evid2750Params>} LogObject<aiAssistantUserFeedbackHoverSrc171Evid2750Params>
 */
export function aiAssistantUserFeedbackHoverSrc171Evid2750(params) {
    return { evid: 2750, src: 171, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantModalOpenedSrc171Evid2751' event (evid: 2751)
 *
 * Event description: modal opened
 *
 * @param {aiAssistantModalOpenedSrc171Evid2751Params} params - The parameters for this event
 * @property {string} origin - your vertical/team name
 * @property {GUID} conversationId - unique id of a conversation
 * @property {number} orderIndex - order index of the message that lead to the modal
 * @property {string} referenceId - the ID of the skill/spi/assistant
 * @property {string} referenceType - the type of the assistant: skill/spi/assistant
 * @property {string} modalName - the name of the modal
 * @property {string} domainId - domainId
 * @return {LogObject<aiAssistantModalOpenedSrc171Evid2751Params>} LogObject<aiAssistantModalOpenedSrc171Evid2751Params>
 */
export function aiAssistantModalOpenedSrc171Evid2751(params) {
    return { evid: 2751, src: 171, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantModalClickedSrc171Evid2752' event (evid: 2752)
 *
 * Event description: modal clicked
 *
 * @param {aiAssistantModalClickedSrc171Evid2752Params} params - The parameters for this event
 * @property {string} origin - your vertical/team name
 * @property {GUID} conversationId - unique id of a conversation
 * @property {number} orderIndex - order index of the message that lead to the modal
 * @property {string} referenceId - the ID of the skill/spi/assistant
 * @property {string} referenceType - the type of the assistant: skill/spi/assistant
 * @property {string} modalName - the name of the modal
 * @property {string} action - the action: main cta/card/exit
 * @property {string} value - the name of the action/the chosen card
 * @property {string} text - the text the user wrote and save
 * @property {string} domainId - domainId
 * @return {LogObject<aiAssistantModalClickedSrc171Evid2752Params>} LogObject<aiAssistantModalClickedSrc171Evid2752Params>
 */
export function aiAssistantModalClickedSrc171Evid2752(params) {
    return { evid: 2752, src: 171, endpoint: '', params };
}
/**
 * A function to create a log object for the 'genericAgentServiceErrorEventOldDeprecated' event (evid: 3101)
 *
 * Event description: Error Event
 *
 * @param {genericAgentServiceErrorEventOldDeprecatedParams} params - The parameters for this event
 * @property {string} errorMessage - error_message
 * @property {string} errorId - error id
 * @property {string} conversationId - conversation_id
 * @property {string} agentName - agent_name
 * @property {string} additionalInfo - additional_info
 * @property {string} generateId - generate_id
 * @property {string} level - level - 'warn' | 'error'
 * @return {LogObject<genericAgentServiceErrorEventOldDeprecatedParams>} LogObject<genericAgentServiceErrorEventOldDeprecatedParams>
 */
export function genericAgentServiceErrorEventOldDeprecated(params) {
    return { evid: 3101, src: 171, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixelHomePageStartLoadingSrc181Evid100' event (evid: 100)
 *
 * Event description: Wixel Home Page started loading
 *
 * @param {wixelHomePageStartLoadingSrc181Evid100Params} params - The parameters for this event
 * @property {Url} referral_url - from where the user was referred
 * @property {string} platform - platform
 * @property {string} session_id - session id for each visit
 * @property {string} current_page_name - page_name
 * @property {string} mobile_view - mobile_app / mobile_browser
 * @property {string} working_mode - desktop/mobile
 * @return {LogObject<wixelHomePageStartLoadingSrc181Evid100Params>} LogObject<wixelHomePageStartLoadingSrc181Evid100Params>
 */
export function wixelHomePageStartLoadingSrc181Evid100(params) {
    return { evid: 100, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixelHomePageFinishLoadingSrc181Evid101' event (evid: 101)
 *
 * Event description: Wixel Home Page finished loading
 *
 * @param {wixelHomePageFinishLoadingSrc181Evid101Params} params - The parameters for this event
 * @property {Url} referral_url - from where the user was referred
 * @property {string} current_page_name - which page was loaded
 * @property {number} loading_time - in ms
 * @property {string} platform - platform
 * @property {string} session_id - session id for each visit
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app / mobile_browser
 * @return {LogObject<wixelHomePageFinishLoadingSrc181Evid101Params>} LogObject<wixelHomePageFinishLoadingSrc181Evid101Params>
 */
export function wixelHomePageFinishLoadingSrc181Evid101(params) {
    return { evid: 101, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixelHomePageRecentProjectsViewSrc181Evid110' event (evid: 110)
 *
 * Event description: recent projects loaded - each project separately
 *
 * @param {wixelHomePageRecentProjectsViewSrc181Evid110Params} params - The parameters for this event
 * @property {number} order_index - order on the page from left to right
 * @property {string} platform - platform
 * @property {string} session_id - session id for each visit
 * @property {string} current_page_name - page_name
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app / mobile_browser
 * @property {string} project_id - project_id
 * @return {LogObject<wixelHomePageRecentProjectsViewSrc181Evid110Params>} LogObject<wixelHomePageRecentProjectsViewSrc181Evid110Params>
 */
export function wixelHomePageRecentProjectsViewSrc181Evid110(params) {
    return { evid: 110, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixelHomePageRecentProjectsActionsSrc181Evid111' event (evid: 111)
 *
 * Event description: recent projects actions - each project separately
 *
 * @param {wixelHomePageRecentProjectsActionsSrc181Evid111Params} params - The parameters for this event
 * @property {number} order_index - order on the page from left to right
 * @property {string} action - action took
 * @property {string} platform - platform
 * @property {string} session_id - session id for each visit
 * @property {string} current_page_name - page_name
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app / mobile_browser
 * @property {string} project_id - project_id
 * @return {LogObject<wixelHomePageRecentProjectsActionsSrc181Evid111Params>} LogObject<wixelHomePageRecentProjectsActionsSrc181Evid111Params>
 */
export function wixelHomePageRecentProjectsActionsSrc181Evid111(params) {
    return { evid: 111, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixelHomePageMainActionsClicksSrc181Evid142' event (evid: 142)
 *
 * Event description: Wixel Home Page clicks on main actions
 *
 * @param {wixelHomePageMainActionsClicksSrc181Evid142Params} params - The parameters for this event
 * @property {string} current_page_name - which page was loaded
 * @property {string} button_name - on which button user clicked
 * @property {string} platform - platform
 * @property {string} session_id - session id for each visit
 * @property {string} origin - where the click was done from
 * @property {string} section - sections of the button's location
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app / mobile_browser
 * @return {LogObject<wixelHomePageMainActionsClicksSrc181Evid142Params>} LogObject<wixelHomePageMainActionsClicksSrc181Evid142Params>
 */
export function wixelHomePageMainActionsClicksSrc181Evid142(params) {
    return { evid: 142, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openPanelOnWixelDashboardSrc181Evid180' event (evid: 180)
 *
 * Event description: Open panel on Wixel Dashboard
 *
 * @param {openPanelOnWixelDashboardSrc181Evid180Params} params - The parameters for this event
 * @property {string} current_page_name - which page was loaded
 * @property {string} platform - platform
 * @property {string} session_id - session id for each visit
 * @property {string} component - type of component panel is related to
 * @property {string} component_id - id of the component panel is related to
 * @property {string} panel_name - name of the opened panel
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<openPanelOnWixelDashboardSrc181Evid180Params>} LogObject<openPanelOnWixelDashboardSrc181Evid180Params>
 */
export function openPanelOnWixelDashboardSrc181Evid180(params) {
    return { evid: 180, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickInsidePanelOnWixelDashboardSrc181Evid181' event (evid: 181)
 *
 * Event description: Click inside panel on Wixel Dashboard
 *
 * @param {clickInsidePanelOnWixelDashboardSrc181Evid181Params} params - The parameters for this event
 * @property {string} current_page_name - which page was loaded
 * @property {string} platform - platform
 * @property {string} session_id - session id for each visit
 * @property {string} component - type of component panel is related to
 * @property {string} component_id - id of the component panel is related to
 * @property {string} panel_name - name of the opened panel
 * @property {string} target - what user clicked on the panel
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<clickInsidePanelOnWixelDashboardSrc181Evid181Params>} LogObject<clickInsidePanelOnWixelDashboardSrc181Evid181Params>
 */
export function clickInsidePanelOnWixelDashboardSrc181Evid181(params) {
    return { evid: 181, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'projectsActionsOnWixelDashboardSrc181Evid182' event (evid: 182)
 *
 * Event description: Projects actions on Wixel dashboard
 *
 * @param {projectsActionsOnWixelDashboardSrc181Evid182Params} params - The parameters for this event
 * @property {string} current_page_name - which page was loaded
 * @property {string} platform - platform
 * @property {string} session_id - session id for each visit
 * @property {string} project_id - project_id of the project
 * @property {string} target - action
 * @property {string} origin - where the action was done from
 * @property {string} msid - msid of the site created under the hood
 * @property {string} origin_project_id - project id of duplicated project
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<projectsActionsOnWixelDashboardSrc181Evid182Params>} LogObject<projectsActionsOnWixelDashboardSrc181Evid182Params>
 */
export function projectsActionsOnWixelDashboardSrc181Evid182(params) {
    return { evid: 182, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openMenuOnWixelDashboardSrc181Evid183' event (evid: 183)
 *
 * Event description: Open menu on Wixel Dashboard
 *
 * @param {openMenuOnWixelDashboardSrc181Evid183Params} params - The parameters for this event
 * @property {string} current_page_name - which page was loaded
 * @property {string} platform - platform
 * @property {string} session_id - session id for each visit
 * @property {string} menu_name - menu that was opened
 * @property {string} component - type of component menu is related to
 * @property {string} component_id - id of the component menu is related to
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<openMenuOnWixelDashboardSrc181Evid183Params>} LogObject<openMenuOnWixelDashboardSrc181Evid183Params>
 */
export function openMenuOnWixelDashboardSrc181Evid183(params) {
    return { evid: 183, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnMenuOnWixelDashboardSrc181Evid184' event (evid: 184)
 *
 * Event description: Click on menu on Wixel Dashboard
 *
 * @param {clickOnMenuOnWixelDashboardSrc181Evid184Params} params - The parameters for this event
 * @property {string} current_page_name - which page was loaded
 * @property {string} platform - platform
 * @property {string} session_id - session id for each visit
 * @property {string} menu_name - menu that was opened
 * @property {string} component - type of component menu is related to
 * @property {string} component_id - id of the component menu is related to
 * @property {string} target - what user clicked on
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<clickOnMenuOnWixelDashboardSrc181Evid184Params>} LogObject<clickOnMenuOnWixelDashboardSrc181Evid184Params>
 */
export function clickOnMenuOnWixelDashboardSrc181Evid184(params) {
    return { evid: 184, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'errorOnWixelDashboardSrc181Evid185' event (evid: 185)
 *
 * Event description: Error on Wixel dashboard
 *
 * @param {errorOnWixelDashboardSrc181Evid185Params} params - The parameters for this event
 * @property {string} current_page_name - which page was loaded
 * @property {string} platform - platform
 * @property {string} session_id - session id for each visit
 * @property {string} error_name - name of the error
 * @property {string} error_info - all additional information that we know about the error
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<errorOnWixelDashboardSrc181Evid185Params>} LogObject<errorOnWixelDashboardSrc181Evid185Params>
 */
export function errorOnWixelDashboardSrc181Evid185(params) {
    return { evid: 185, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmDashboardAssetShownSrc181Evid190' event (evid: 190)
 *
 * Event description: asset shown from dealer
 *
 * @param {bmDashboardAssetShownSrc181Evid190Params} params - The parameters for this event
 * @property {string} origin - when the banner was shown for example: dashboard
 * @property {string} asset_campaign_guid - Placement Id from dealer
 * @property {GUID} offering_id - offering_id from dealer
 * @property {string} asset_campaign_id - the content of the campaign
 * @property {string} asset_campaign_location_on_page - for example: header / footer
 * @property {string} promotion_asset_type - for example: premium_banner
 * @property {string} item_mode - open / in_progress / completed
 * @property {GUID} project_id - project id
 * @property {string} session_id - session id
 * @property {string} current_page_name - page_name
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<bmDashboardAssetShownSrc181Evid190Params>} LogObject<bmDashboardAssetShownSrc181Evid190Params>
 */
export function bmDashboardAssetShownSrc181Evid190(params) {
    return { evid: 190, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmDashboardAssetClickSrc181Evid191' event (evid: 191)
 *
 * Event description: asset shown from dealer
 *
 * @param {bmDashboardAssetClickSrc181Evid191Params} params - The parameters for this event
 * @property {string} origin - when the banner was shown for example: dashboard
 * @property {string} asset_campaign_guid - Placement Id from dealer
 * @property {GUID} offering_id - offering_id from dealer
 * @property {string} asset_campaign_id - the content of the campaign
 * @property {string} asset_campaign_location_on_page - for example: header / footer
 * @property {string} promotion_asset_type - for example: premium_banner
 * @property {string} item_mode - open / in_progress / completed
 * @property {GUID} project_id - project id
 * @property {string} session_id - session id
 * @property {string} button_name - what action the user took on the asset
 * @property {string} current_page_name - page_name
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<bmDashboardAssetClickSrc181Evid191Params>} LogObject<bmDashboardAssetClickSrc181Evid191Params>
 */
export function bmDashboardAssetClickSrc181Evid191(params) {
    return { evid: 191, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPagePageViewSrc181Evid201' event (evid: 201)
 *
 * Event description: Page fully loaded on Wixel Templates Page
 *
 * @param {templatesPagePageViewSrc181Evid201Params} params - The parameters for this event
 * @property {number} loading_time - in ms
 * @property {Url} referral_url - referral url
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} prefilled_info - whether the search bar was prefilled or not, and with which value
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {string} screen_name - template page / viewer
 * @property {string} session_id - session id for each visit
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @property {string} page_name - which page the user saw - home / category / no results
 * @return {LogObject<templatesPagePageViewSrc181Evid201Params>} LogObject<templatesPagePageViewSrc181Evid201Params>
 */
export function templatesPagePageViewSrc181Evid201(params) {
    return { evid: 201, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageHoverTemplateSrc181Evid212' event (evid: 212)
 *
 * Event description: hover over a template on templates page
 *
 * @param {templatesPageHoverTemplateSrc181Evid212Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category of the page
 * @property {string} sub_category - sub_category of the page
 * @property {string} micro_category - micro_category of the page
 * @property {string} template_id - id of the template being hovered
 * @property {string} screen_name - template page / viewer
 * @property {boolean} is_pro - is the template pro or not
 * @property {string} page_name - page name
 * @property {string} search_term - last search term the user had
 * @property {string} session_id - session id for each visit
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @property {number} position_index - position_index
 * @property {number} json_id - json.  id
 * @return {LogObject<templatesPageHoverTemplateSrc181Evid212Params>} LogObject<templatesPageHoverTemplateSrc181Evid212Params>
 */
export function templatesPageHoverTemplateSrc181Evid212(params) {
    return { evid: 212, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageViewTemplateSrc181Evid214' event (evid: 214)
 *
 * Event description: click view a template on templates page
 *
 * @param {templatesPageViewTemplateSrc181Evid214Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {string} template_id - template id
 * @property {string} origin - origin
 * @property {string} screen_name - template page / viewer
 * @property {boolean} is_pro - is the template pro or not
 * @property {string} page_name - page name
 * @property {number} json_id - json id
 * @property {number} position_index - position_index
 * @property {string} search_term - last search term the user had
 * @property {string} session_id - session id for each visit
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<templatesPageViewTemplateSrc181Evid214Params>} LogObject<templatesPageViewTemplateSrc181Evid214Params>
 */
export function templatesPageViewTemplateSrc181Evid214(params) {
    return { evid: 214, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageEditTemplateSrc181Evid215' event (evid: 215)
 *
 * Event description: click edit a template on templates page
 *
 * @param {templatesPageEditTemplateSrc181Evid215Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {string} template_id - template id
 * @property {string} origin - origin
 * @property {string} screen_name - template page / viewer
 * @property {boolean} is_pro - is the template pro or not
 * @property {string} page_name - page name
 * @property {number} json_id - json id
 * @property {number} position_index - position_index
 * @property {string} search_term - last search term the user had
 * @property {string} session_id - session id for each visit
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<templatesPageEditTemplateSrc181Evid215Params>} LogObject<templatesPageEditTemplateSrc181Evid215Params>
 */
export function templatesPageEditTemplateSrc181Evid215(params) {
    return { evid: 215, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageSearchSrc181Evid224' event (evid: 224)
 *
 * Event description: Searches on the templates page
 *
 * @param {templatesPageSearchSrc181Evid224Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {string} source - where the search was conducted
 * @property {string} criteria - the text input of the search
 * @property {string} search_type - free text / prefilled info
 * @property {string} screen_name - template page / viewer
 * @property {string} page_name - page name
 * @property {string} session_id - session id for each visit
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<templatesPageSearchSrc181Evid224Params>} LogObject<templatesPageSearchSrc181Evid224Params>
 */
export function templatesPageSearchSrc181Evid224(params) {
    return { evid: 224, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageMenuInteractionsSrc181Evid225' event (evid: 225)
 *
 * Event description: interactions with the categories menu
 *
 * @param {templatesPageMenuInteractionsSrc181Evid225Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {string} button_name - button_name
 * @property {string} screen_name - template page / viewer
 * @property {string} page_name - page name
 * @property {string} session_id - session id for each visit
 * @property {string} button_type - button type
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<templatesPageMenuInteractionsSrc181Evid225Params>} LogObject<templatesPageMenuInteractionsSrc181Evid225Params>
 */
export function templatesPageMenuInteractionsSrc181Evid225(params) {
    return { evid: 225, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageFilterInteractionsSrc181Evid226' event (evid: 226)
 *
 * Event description: interactions with the filters on Wixel Templates Page
 *
 * @param {templatesPageFilterInteractionsSrc181Evid226Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {string} click_type - click_type
 * @property {string} filter - on which filter user clicked
 * @property {string} value - chosen value / existing value
 * @property {string} screen_name - template page / viewer
 * @property {string} page_name - page name
 * @property {string} session_id - session id for each visit
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<templatesPageFilterInteractionsSrc181Evid226Params>} LogObject<templatesPageFilterInteractionsSrc181Evid226Params>
 */
export function templatesPageFilterInteractionsSrc181Evid226(params) {
    return { evid: 226, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageViewerViewerLoadedSrc181Evid230' event (evid: 230)
 *
 * Event description: viewer successfully loaded
 *
 * @param {templatesPageViewerViewerLoadedSrc181Evid230Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {string} screen_name - template page / viewer / saved_template
 * @property {number} position_index - position index
 * @property {string} session_id - session id for each visit
 * @property {GUID} template_id - template id
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<templatesPageViewerViewerLoadedSrc181Evid230Params>} LogObject<templatesPageViewerViewerLoadedSrc181Evid230Params>
 */
export function templatesPageViewerViewerLoadedSrc181Evid230(params) {
    return { evid: 230, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageViewerViewerGeneralActionsSrc181Evid231' event (evid: 231)
 *
 * Event description: viewer successfully loaded
 *
 * @param {templatesPageViewerViewerGeneralActionsSrc181Evid231Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {string} screen_name - template page / viewer
 * @property {string} template_type - type
 * @property {string} template_id - template_id
 * @property {string} action - action
 * @property {number} position_index - position index
 * @property {string} session_id - session id for each visit
 * @property {boolean} is_pro - is pro
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<templatesPageViewerViewerGeneralActionsSrc181Evid231Params>} LogObject<templatesPageViewerViewerGeneralActionsSrc181Evid231Params>
 */
export function templatesPageViewerViewerGeneralActionsSrc181Evid231(params) {
    return { evid: 231, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageGeneralActionSrc181Evid242' event (evid: 242)
 *
 * Event description: general actions on the Templates Page
 *
 * @param {templatesPageGeneralActionSrc181Evid242Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {string} section - section
 * @property {string} action - action
 * @property {string} location - location
 * @property {string} screen_name - template page / viewer
 * @property {string} session_id - session id for each visit
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @property {number} position_index - position_index
 * @property {string} template_id - template_id
 * @return {LogObject<templatesPageGeneralActionSrc181Evid242Params>} LogObject<templatesPageGeneralActionSrc181Evid242Params>
 */
export function templatesPageGeneralActionSrc181Evid242(params) {
    return { evid: 242, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageAboveTheFoldImpressionSrc181Evid252' event (evid: 252)
 *
 * Event description: When user saw a certain template on templates page
 *
 * @param {templatesPageAboveTheFoldImpressionSrc181Evid252Params} params - The parameters for this event
 * @property {string} book - book
 * @property {string} category - category
 * @property {number} page_index - page index
 * @property {string} Platform - platform
 * @property {string} template_id - template_id
 * @property {string} search_term - last search term the user had
 * @property {string} session_id - session id for each visit
 * @property {boolean} is_pro - is pro template
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @property {string} sub_category - subcat
 * @property {string} micro_category - microcat
 * @property {number} position_index - position_index
 * @property {number} json_id - json_id
 * @property {string} fold_name - fold_name
 * @property {string} page_name - page_name
 * @return {LogObject<templatesPageAboveTheFoldImpressionSrc181Evid252Params>} LogObject<templatesPageAboveTheFoldImpressionSrc181Evid252Params>
 */
export function templatesPageAboveTheFoldImpressionSrc181Evid252(params) {
    return { evid: 252, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageNavigationSrc181Evid254' event (evid: 254)
 *
 * Event description: navigation on the templates page
 *
 * @param {templatesPageNavigationSrc181Evid254Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {string} value - value
 * @property {string} screen_name - template page / viewer
 * @property {string} session_id - session id for each visit
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @property {string} section - on which section the navigation was conducted. examples: popular categories, breadcrumbs
 * @return {LogObject<templatesPageNavigationSrc181Evid254Params>} LogObject<templatesPageNavigationSrc181Evid254Params>
 */
export function templatesPageNavigationSrc181Evid254(params) {
    return { evid: 254, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPagePaginationSrc181Evid255' event (evid: 255)
 *
 * Event description: Pagination on Templates Page
 *
 * @param {templatesPagePaginationSrc181Evid255Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {number} page_clicked - target page
 * @property {string} campagins_data - example: button
 * @property {string} screen_name - template page / viewer
 * @property {string} session_id - session id for each visit
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<templatesPagePaginationSrc181Evid255Params>} LogObject<templatesPagePaginationSrc181Evid255Params>
 */
export function templatesPagePaginationSrc181Evid255(params) {
    return { evid: 255, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixelOnboardingStartFlowSrc181Evid500' event (evid: 500)
 *
 * Event description: Start Flow
 *
 * @param {wixelOnboardingStartFlowSrc181Evid500Params} params - The parameters for this event
 * @property {string} flow - flow
 * @property {string} screen_name - screen name
 * @property {string} screen_version - screen version
 * @property {string} platform - platform
 * @property {Url} referral_url - ref url
 * @property {string} session_id - session id for each visit
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<wixelOnboardingStartFlowSrc181Evid500Params>} LogObject<wixelOnboardingStartFlowSrc181Evid500Params>
 */
export function wixelOnboardingStartFlowSrc181Evid500(params) {
    return { evid: 500, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixelOnboardingScreenViewSrc181Evid501' event (evid: 501)
 *
 * Event description: Start Flow
 *
 * @param {wixelOnboardingScreenViewSrc181Evid501Params} params - The parameters for this event
 * @property {string} flow - flow
 * @property {string} screen_name - screen name
 * @property {string} screen_version - screen version
 * @property {string} platform - platform
 * @property {string} session_id - session id for each visit
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<wixelOnboardingScreenViewSrc181Evid501Params>} LogObject<wixelOnboardingScreenViewSrc181Evid501Params>
 */
export function wixelOnboardingScreenViewSrc181Evid501(params) {
    return { evid: 501, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixelOnboardingScreenAnswerSrc181Evid527' event (evid: 527)
 *
 * Event description: Start Flow
 *
 * @param {wixelOnboardingScreenAnswerSrc181Evid527Params} params - The parameters for this event
 * @property {string} flow - flow
 * @property {string} screen_name - screen name
 * @property {string} screen_version - screen version
 * @property {string} platform - platform
 * @property {string} answer - answer
 * @property {string} session_id - session id for each visit
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<wixelOnboardingScreenAnswerSrc181Evid527Params>} LogObject<wixelOnboardingScreenAnswerSrc181Evid527Params>
 */
export function wixelOnboardingScreenAnswerSrc181Evid527(params) {
    return { evid: 527, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixelOnboardingRoutingAttemptSrc181Evid555' event (evid: 555)
 *
 * Event description: routing
 *
 * @param {wixelOnboardingRoutingAttemptSrc181Evid555Params} params - The parameters for this event
 * @property {Url} referral_url - ref
 * @property {Url} target_url - target
 * @property {boolean} is_required_signup - if user had to go through signup
 * @property {string} session_id - session id for each visit
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<wixelOnboardingRoutingAttemptSrc181Evid555Params>} LogObject<wixelOnboardingRoutingAttemptSrc181Evid555Params>
 */
export function wixelOnboardingRoutingAttemptSrc181Evid555(params) {
    return { evid: 555, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixelOnboardingFinishFlowSrc181Evid599' event (evid: 599)
 *
 * Event description: Start Flow
 *
 * @param {wixelOnboardingFinishFlowSrc181Evid599Params} params - The parameters for this event
 * @property {string} flow - flow
 * @property {string} screen_name - screen name
 * @property {string} screen_version - screen version
 * @property {string} platform - platform
 * @property {Url} target_url - target_url
 * @property {string} session_id - session id for each visit
 * @property {string} working_mode - desktop/mobile
 * @property {string} mobile_view - mobile_app/mobile_browser
 * @return {LogObject<wixelOnboardingFinishFlowSrc181Evid599Params>} LogObject<wixelOnboardingFinishFlowSrc181Evid599Params>
 */
export function wixelOnboardingFinishFlowSrc181Evid599(params) {
    return { evid: 599, src: 181, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteBriefModalAnswerSrc2Evid1' event (evid: 1)
 *
 * Event description: Site Brief - Modal answer
 *
 * @param {siteBriefModalAnswerSrc2Evid1Params} params - The parameters for this event
 * @property {string} button_name - button_name, e.g. close/done/slide
 * @property {string} modal_version_name - modal_version_name
 * @property {string} modal_name - modal_name
 * @property {string} screenName - screen_name
 * @property {string} flow - flow
 * @property {string} answer - answer
 * @property {string} profileId - the Id of the user session
 * @property {string} screenVersion - screen version
 * @property {string} location - site brief, mockup
 * @return {LogObject<siteBriefModalAnswerSrc2Evid1Params>} LogObject<siteBriefModalAnswerSrc2Evid1Params>
 */
export function siteBriefModalAnswerSrc2Evid1(params) {
    return { evid: 1, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'errorEvent' event (evid: 10)
 *
 * Event description: error event.
 *
 * @param {errorEventParams} params - The parameters for this event
 * @property {string} dsc - dsc
 * @property {number} response_time - Time in ms from load to error
 * @property {boolean} is_rollout - is_rollout
 * @property {string} initiator_name - initiator_name
 * @property {string} builderType - builder_type
 * @property {string} errscp - error scope
 * @property {GUID} site_id - changed from did -> site_id on Oct 03, 2013
 * @property {string} errn - error name
 * @property {string} p4 - 4st extra parameter
 * @property {string} majorver - the major version of html editor
 * @property {string} trgt - target name, api call or class
 * @property {boolean} isLiveEditor - is_live_editor
 * @property {number} ts - Time in ms from load to error
 * @property {string} playerVersion - player_version
 * @property {string} artifactVersion - artifact_version
 * @property {number} usersOnPageCount - users_on_page_count
 * @property {string} viewmode - viewmode
 * @property {string} error_description_short - error_description_short
 * @property {string} data_center - data_center
 * @property {string} screenResolution - screen_resolution
 * @property {string} p3 - 3rd extra parameter
 * @property {GUID} did - changed from did -> site_id on Oct 03, 2013
 * @property {boolean} isSg - is_sg
 * @property {string} dsOrigin - ds_origin
 * @property {string} p2 - 2nd extra parameter
 * @property {string} token - token
 * @property {string} sessionId - session_id
 * @property {number} errc - error code
 * @property {string} stack - stacktrace
 * @property {string} viewerName - viewer_name
 * @property {string} app_id - app_id
 * @property {number} sev - severity of the error
 * @property {GUID} esi - esi
 * @property {number} cat - category id
 * @property {string} errormsg - dsc
 * @property {number} usersOnSiteCount - users_on_site_count
 * @property {string} p1 - 1st extra parameter
 * @property {GUID} msid - msid
 * @property {number} base_version - base_version
 * @property {number} iss - issue (sub-category)
 * @return {LogObject<errorEventParams>} LogObject<errorEventParams>
 */
export function errorEvent(params) {
    return { evid: 10, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageWebVitalsMetrics' event (evid: 100)
 *
 * Event description: Measures of page performance
 *
 * @param {templatesPageWebVitalsMetricsParams} params - The parameters for this event
 * @property {number} metric_value - The current value of the metric
 * @property {number} page_index - page_index
 * @property {string} id - A unique ID representing this particular metric that's specific to the current page. This ID can be used by an analytics tool to dedupe multiple values sent for the same metric, or to group multiple deltas together and calculate a total
 * @property {string} metric_name - The name of the metric (in acronym form: 'CLS' | 'FCP' | 'FID' | 'LCP' | 'TTFB')
 * @property {boolean} is_final - `false` if the value of the metric may change in the future, for the current page
 * @property {number} delta - The delta between the current value and the last-reported value. On the first report, `delta` and `value` will always be the same.
 * @property {string} platform - platform
 * @property {string} product - product
 * @return {LogObject<templatesPageWebVitalsMetricsParams>} LogObject<templatesPageWebVitalsMetricsParams>
 */
export function templatesPageWebVitalsMetrics(params) {
    return { evid: 100, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesStickyHeader' event (evid: 101)
 *
 * Event description: Fires every time the header changes to its sticky version or back to normal
 *
 * @param {templatesStickyHeaderParams} params - The parameters for this event
 * @property {string} sub_category - current  subcategory
 * @property {string} event_data - json with template list: returns all templates in the page loaded and their locations
 * @property {number} galleryDocsPerPage - number of templates in current page
 * @property {number} page_index - page_index
 * @property {string} header_type - header changed to sticky/default version
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} category - current category, "search" for search results
 * @property {string} platform - platform
 * @property {string} product - product
 * @return {LogObject<templatesStickyHeaderParams>} LogObject<templatesStickyHeaderParams>
 */
export function templatesStickyHeader(params) {
    return { evid: 101, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickAdiBannerInTemplatesPage' event (evid: 103)
 *
 * Event description: User clicks the banner in the templates page that leads to adi intro flow.
 *
 * @param {clickAdiBannerInTemplatesPageParams} params - The parameters for this event
 * @property {number} page_index - page_index
 * @property {string} banner_name - name of banner: adi, package picker, editor x, etc
 * @property {string} platform - platform
 * @property {string} product - product
 * @return {LogObject<clickAdiBannerInTemplatesPageParams>} LogObject<clickAdiBannerInTemplatesPageParams>
 */
export function clickAdiBannerInTemplatesPage(params) {
    return { evid: 103, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sort' event (evid: 104)
 *
 * Event description: Sort.
 *
 * @param {sortParams} params - The parameters for this event
 * @property {number} page_index - page_index
 * @property {string} criteria - business term, if search
 * @property {string} subcategory - sub category slug
 * @property {string} actionName - expand or execute
 * @property {string} category - category slug
 * @property {string} values - Sorting category slug or "recommended" for default sorting.
 * @property {string} platform - platform
 * @property {string} product - product
 * @return {LogObject<sortParams>} LogObject<sortParams>
 */
export function sort(params) {
    return { evid: 104, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickSaveMobileTemplatesPage' event (evid: 105)
 *
 * Event description: user clicks save template in mobile flow
 *
 * @param {clickSaveMobileTemplatesPageParams} params - The parameters for this event
 * @property {number} page_index - page_index
 * @property {string} subcategory - template subcat
 * @property {GUID} metasiteid - metasite id
 * @property {string} category - template category
 * @property {GUID} esi - editor session id
 * @property {string} platform - platform
 * @property {string} imageUrl - image url
 * @property {number} page_number - page number of the template
 * @property {string} template_id - siteId
 * @property {string} product - product
 * @return {LogObject<clickSaveMobileTemplatesPageParams>} LogObject<clickSaveMobileTemplatesPageParams>
 */
export function clickSaveMobileTemplatesPage(params) {
    return { evid: 105, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thankYouPageActionMobileTemplatesPage' event (evid: 106)
 *
 * Event description: User clicks one of the CTAs in the thank you page of the templates page mobile flow
 *
 * @param {thankYouPageActionMobileTemplatesPageParams} params - The parameters for this event
 * @property {string} action_name - "close" or "back-to-gallery"
 * @property {number} page_index - page_index
 * @property {string} platform - platform
 * @property {string} product - product
 * @return {LogObject<thankYouPageActionMobileTemplatesPageParams>} LogObject<thankYouPageActionMobileTemplatesPageParams>
 */
export function thankYouPageActionMobileTemplatesPage(params) {
    return { evid: 106, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickInstallAppInMobileTemplatePage' event (evid: 107)
 *
 * Event description: Users clicks to download wix app in the mobile templates page. For now there can be 2 entry points: mobile flow; email.
 *
 * @param {clickInstallAppInMobileTemplatePageParams} params - The parameters for this event
 * @property {number} page_index - page_index
 * @property {GUID} tpsi - tpsi
 * @property {string} entry_point - "mobile_flow" or "email"
 * @property {string} platform - platform
 * @property {string} product - product
 * @return {LogObject<clickInstallAppInMobileTemplatePageParams>} LogObject<clickInstallAppInMobileTemplatePageParams>
 */
export function clickInstallAppInMobileTemplatePage(params) {
    return { evid: 107, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesActionInViewerSideBar' event (evid: 108)
 *
 * Event description: This events is build to track all actions inside the viewer side bar. For now the only action name is "change color".
 *
 * @param {templatesActionInViewerSideBarParams} params - The parameters for this event
 * @property {number} page_index - page_index
 * @property {string} answerName - answer name
 * @property {GUID} tpsi - tpsi
 * @property {string} actionName - action name
 * @property {GUID} esi - editor session id
 * @property {string} platform - platform
 * @property {string} product - product
 * @return {LogObject<templatesActionInViewerSideBarParams>} LogObject<templatesActionInViewerSideBarParams>
 */
export function templatesActionInViewerSideBar(params) {
    return { evid: 108, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'websitePageTemplatesGeneralClick' event (evid: 109)
 *
 * Event description: Website Page Templates General Click
 *
 * @param {websitePageTemplatesGeneralClickParams} params - The parameters for this event
 * @property {number} page_index - page_index
 * @property {string} button_name - button_name
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} product - product
 * @return {LogObject<websitePageTemplatesGeneralClickParams>} LogObject<websitePageTemplatesGeneralClickParams>
 */
export function websitePageTemplatesGeneralClick(params) {
    return { evid: 109, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'categoryInHp' event (evid: 110)
 *
 * Event description: Category in HP
 *
 * @param {categoryInHpParams} params - The parameters for this event
 * @property {string} structureId - structure_id
 * @property {string} location - Top, Bottom, Left etc' - Used in case of multiple buttons with the same name
 * @property {string} screen_version - screen version
 * @property {string} screenName - screen name
 * @property {number} page_index - page_index
 * @property {string} industryId - industry_id
 * @property {string} businessType - business_type
 * @property {string} segment - segment
 * @property {string} main_industry - main_industry
 * @property {string} subcat - business_term
 * @property {string} flow - flow
 * @property {string} subIndustry - sub_industry
 * @property {string} sourceScreen - new/vertical or new/intro or second/intro
 * @property {string} target_flow - The target flow for this user in the intro
 * @property {string} platform - platform
 * @property {string} cat - postreg
 * @property {string} action - action
 * @property {string} product - product
 * @return {LogObject<categoryInHpParams>} LogObject<categoryInHpParams>
 */
export function categoryInHp(params) {
    return { evid: 110, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'productPageGeneralClickTemplatesViewerSrc2Evid111' event (evid: 111)
 *
 * Event description: Product Page - General Click (Templates Viewer)
 *
 * @param {productPageGeneralClickTemplatesViewerSrc2Evid111Params} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {GUID} msid - msid
 * @property {string} button_name - which button was clicked
 * @property {string} location - where on the page the button is located
 * @property {string} platform - wix or studio
 * @property {string} template_id - the id of the viewed template
 * @property {string} cms_template_id - the id of the viewed template according to cms
 * @return {LogObject<productPageGeneralClickTemplatesViewerSrc2Evid111Params>} LogObject<productPageGeneralClickTemplatesViewerSrc2Evid111Params>
 */
export function productPageGeneralClickTemplatesViewerSrc2Evid111(params) {
    return { evid: 111, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainStepPromoLabelDisplayedSrc2Evid112' event (evid: 112)
 *
 * Event description: Track a true impression of the promo label when it is actually visible to the user in the Connect Domain step.
 *
 * @param {domainStepPromoLabelDisplayedSrc2Evid112Params} params - The parameters for this event
 * @property {string} searchTerm - searched domain name
 * @property {GUID} msid - msid
 * @return {LogObject<domainStepPromoLabelDisplayedSrc2Evid112Params>} LogObject<domainStepPromoLabelDisplayedSrc2Evid112Params>
 */
export function domainStepPromoLabelDisplayedSrc2Evid112(params) {
    return { evid: 112, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesSearchLoadingTimeSrc2Evid113' event (evid: 113)
 *
 * Event description: templates -> search loading time
 *
 * @param {templatesSearchLoadingTimeSrc2Evid113Params} params - The parameters for this event
 * @property {number} totalPages - total_pages
 * @property {number} currentPage - current_page
 * @property {string} source - the source of the search query
 * @property {string} previous_sub_category - a sub category in which the search was performed
 * @property {string} click_source - Main Header/Sticky Header
 * @property {number} page_index - page_index
 * @property {string} criteria - criteria
 * @property {number} numberOfTemplatesInCurrentPage - templates_cnt
 * @property {string} book - book
 * @property {string} features - list of selected features
 * @property {string} selectedStructureId - structure_id of the selected term (if taken from ADI)
 * @property {string} searchType - search_type
 * @property {string} styles - list of selected styles
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} layouts - list of selected layouts
 * @property {string} colors - list of selected colors
 * @property {GUID} search_guid - Unique GUID of search
 * @property {string} sorting - selected sorting
 * @property {string} category - category = search
 * @property {string} selectedIndustryId - industry_id of the selected term (if taken from ADI)
 * @property {string} platform - platform
 * @property {string} previous_category - category in which the search was performed
 * @property {string} product - product
 * @property {number} loading_time - loading time after search
 * @return {LogObject<templatesSearchLoadingTimeSrc2Evid113Params>} LogObject<templatesSearchLoadingTimeSrc2Evid113Params>
 */
export function templatesSearchLoadingTimeSrc2Evid113(params) {
    return { evid: 113, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantPlatformOpenMsidSrc2Evid114' event (evid: 114)
 *
 * Event description: AI Assistant - Platform Opened
 *
 * @param {aiAssistantPlatformOpenMsidSrc2Evid114Params} params - The parameters for this event
 * @property {string} uuid - user id
 * @property {string} platformName - hardcoded as 'dashboard' (BM)
 * @property {string} pageName - page name where your 'Open Assistant' button is located
 * @property {GUID} msid - metasite id
 * @return {LogObject<aiAssistantPlatformOpenMsidSrc2Evid114Params>} LogObject<aiAssistantPlatformOpenMsidSrc2Evid114Params>
 */
export function aiAssistantPlatformOpenMsidSrc2Evid114(params) {
    return { evid: 114, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesOpenModalTemplateSrc2Evid115' event (evid: 115)
 *
 * Event description: templates -> open modal template
 *
 * @param {templatesOpenModalTemplateSrc2Evid115Params} params - The parameters for this event
 * @property {number} index - gallerydocindex
 * @property {boolean} is_search_result - Is result from suggestion ("like you")
 * @property {number} search_rank - External ("like you") suggestion ranking
 * @property {string} sub_category - List of subcategory filters
 * @property {number} total_search_results - total search results from external ("like you") search suggestion
 * @property {boolean} is_recommended - is_recommended
 * @property {Url} openingBrowserUrl - openingbrowserurl
 * @property {string} score_vespa - vespa score
 * @property {number} page_index - page_index
 * @property {string} book - book
 * @property {string} features - list of selected features
 * @property {boolean} videoThumbnail - template shows a video when hovering on the thumbnail (TRUE/FALSE)
 * @property {string} button_name - button name
 * @property {number} gallerydocsperpage - gallerydocsperpage
 * @property {string} styles - list of selected styles
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} layouts - list of selected layouts
 * @property {number} screen_width - Width of client device screen
 * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
 * @property {string} colors - list of selected colors
 * @property {GUID} search_guid - (optional) If from search results, GUID of matching search
 * @property {number} window_width - Initial width of client window
 * @property {string} sorting - selected sorting
 * @property {number} galleryDocIndex - gallerydocindex
 * @property {string} origin - origin
 * @property {number} siteType - site_type
 * @property {number} pageNumber - pagination
 * @property {string} screen_type - the type of page in which the action was performed: category / search_results / main / home
 * @property {number} screen_height - Height of client device screen
 * @property {string} category - the create page category
 * @property {Url} http_referrer - http_referrer
 * @property {number} window_height - Initial height of client window
 * @property {string} platform - platform
 * @property {boolean} btn - is_button
 * @property {GUID} openingSiteID - template_id
 * @property {number} avail_height - Returns the amount of vertical space in pixels available to the window
 * @property {string} product - product
 * @property {string} micro_category - micro_category
 * @return {LogObject<templatesOpenModalTemplateSrc2Evid115Params>} LogObject<templatesOpenModalTemplateSrc2Evid115Params>
 */
export function templatesOpenModalTemplateSrc2Evid115(params) {
    return { evid: 115, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesNavigateTemplateModalSrc2Evid116' event (evid: 116)
 *
 * Event description: templates -> navigate template modal
 *
 * @param {templatesNavigateTemplateModalSrc2Evid116Params} params - The parameters for this event
 * @property {string} direction - left / right
 * @property {string} version - modal_preview
 * @property {string} fromTemplateId - template id
 * @property {string} toTemplateId - template id
 * @property {number} fromTemplateIndex - template index
 * @property {number} toTemplateIndex - template index
 * @return {LogObject<templatesNavigateTemplateModalSrc2Evid116Params>} LogObject<templatesNavigateTemplateModalSrc2Evid116Params>
 */
export function templatesNavigateTemplateModalSrc2Evid116(params) {
    return { evid: 116, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesCloseTemplateModalSrc2Evid117' event (evid: 117)
 *
 * Event description: templates -> close template modal
 *
 * @param {templatesCloseTemplateModalSrc2Evid117Params} params - The parameters for this event
 * @property {string} version - modal_preview
 * @property {string} templateID - template_id
 * @return {LogObject<templatesCloseTemplateModalSrc2Evid117Params>} LogObject<templatesCloseTemplateModalSrc2Evid117Params>
 */
export function templatesCloseTemplateModalSrc2Evid117(params) {
    return { evid: 117, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesHoverOnTemplate' event (evid: 12)
 *
 * Event description: when user hover on a template
 *
 * @param {templatesHoverOnTemplateParams} params - The parameters for this event
 * @property {GUID} template_id - template id
 * @property {number} index - gallery doc index
 * @property {string} sub_category - List of subcategory filters
 * @property {number} galleryDocsPerPage - gallery doc page
 * @property {number} page_index - page_index
 * @property {string} book - book
 * @property {string} features - list of selected features
 * @property {boolean} videoThumbnail - template shows a video when hovering on the thumbnail (TRUE/FALSE)
 * @property {string} styles - list of selected styles
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} layouts - list of selected layouts
 * @property {number} screen_width - Width of client device screen
 * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
 * @property {number} video_full_duration - the full duration of this video in seconds (not how long it played by the user)
 * @property {string} colors - list of selected colors
 * @property {number} hover_ms - hover duration in ms
 * @property {number} window_width - Initial width of client window
 * @property {string} sorting - selected sorting
 * @property {DateTime} video_end_time - thumbnail video end timestamp
 * @property {number} galleryDocIndex - gallery doc index
 * @property {string} origin - origin
 * @property {Url} openingbrowserurl - opening browse url
 * @property {number} siteType - site type
 * @property {string} screen_type - the type of page in which the action was performed: category / search_results / main / home
 * @property {number} screen_height - Height of client device screen
 * @property {string} category - category
 * @property {string} video_status - 'have_nothing', 'have_metadata', 'have_current_data', 'have_future_data', 'have_enough_data'
 * @property {number} window_height - Initial height of client window
 * @property {string} platform - platform
 * @property {DateTime} video_start_time - thumbnail video start timestamp
 * @property {number} video_playback_position - The position (timecode) in which the video was stopped, counting from the beginning or from the last looping of the video (in seconds)
 * @property {boolean} btn - is button
 * @property {GUID} openingSiteID - template id
 * @property {number} avail_height - Returns the amount of horizontal space in pixels vertical to the window
 * @property {string} product - product
 * @return {LogObject<templatesHoverOnTemplateParams>} LogObject<templatesHoverOnTemplateParams>
 */
export function templatesHoverOnTemplate(params) {
    return { evid: 12, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myAccountSelectSiteFromSiteListPopup' event (evid: 129)
 *
 * Event description: my account -> select site from site-list popup.
 *
 * @param {myAccountSelectSiteFromSiteListPopupParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} view_type - view_type
 * @property {string} sub_view - sub_view
 * @property {GUID} c1 - msid
 * @property {number} i1 - site_type
 * @property {number} num_selected_sites - num_selected_sites
 * @property {string} origin - origin
 * @property {string} place - place
 * @property {string} platform - platform
 * @property {string} hosting - hosting
 * @property {GUID} msid - msid
 * @property {string} view - view
 * @return {LogObject<myAccountSelectSiteFromSiteListPopupParams>} LogObject<myAccountSelectSiteFromSiteListPopupParams>
 */
export function myAccountSelectSiteFromSiteListPopup(params) {
    return { evid: 129, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesViewTemplate' event (evid: 14)
 *
 * Event description: templates -> view template.
 *
 * @param {templatesViewTemplateParams} params - The parameters for this event
 * @property {number} index - gallerydocindex
 * @property {boolean} is_search_result - Is result from suggestion ("like you")
 * @property {number} search_rank - External ("like you") suggestion ranking
 * @property {string} sub_category - List of subcategory filters
 * @property {number} total_search_results - total search results from external ("like you") search suggestion
 * @property {boolean} is_recommended - is_recommended
 * @property {Url} openingBrowserUrl - openingbrowserurl
 * @property {string} score_vespa - vespa score
 * @property {number} page_index - page_index
 * @property {string} book - book
 * @property {string} features - list of selected features
 * @property {boolean} videoThumbnail - template shows a video when hovering on the thumbnail (TRUE/FALSE)
 * @property {string} button_name - button name
 * @property {number} gallerydocsperpage - gallerydocsperpage
 * @property {string} styles - list of selected styles
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} layouts - list of selected layouts
 * @property {number} screen_width - Width of client device screen
 * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
 * @property {string} colors - list of selected colors
 * @property {GUID} search_guid - (optional) If from search results, GUID of matching search
 * @property {number} window_width - Initial width of client window
 * @property {string} sorting - selected sorting
 * @property {number} galleryDocIndex - gallerydocindex
 * @property {string} origin - origin
 * @property {number} siteType - site_type
 * @property {number} pageNumber - pagination
 * @property {string} screen_type - the type of page in which the action was performed: category / search_results / main / home
 * @property {number} screen_height - Height of client device screen
 * @property {string} category - the create page category
 * @property {Url} http_referrer - http_referrer
 * @property {number} window_height - Initial height of client window
 * @property {string} platform - platform
 * @property {boolean} btn - is_button
 * @property {GUID} openingSiteID - template_id
 * @property {number} avail_height - Returns the amount of vertical space in pixels available to the window
 * @property {string} product - product
 * @property {string} micro_category - micro_category
 * @property {string} previewType - new_tab / modal
 * @return {LogObject<templatesViewTemplateParams>} LogObject<templatesViewTemplateParams>
 */
export function templatesViewTemplate(params) {
    return { evid: 14, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesOpenEditor' event (evid: 15)
 *
 * Event description: Event fires every time that the user clicks edit in the templates page. disregard the entry point.
 *
 * @param {templatesOpenEditorParams} params - The parameters for this event
 * @property {GUID} template_id - template_id
 * @property {number} index - gallerydocindex
 * @property {boolean} is_search_result - Is result from suggestion ("like you")
 * @property {number} search_rank - External ("like you") suggestion ranking
 * @property {string} __cookies_prefix__wixsession - authentication token. if the session exists, then the user is logged in.
 * @property {string} sub_category - List of subcategory filters
 * @property {number} total_search_results - total search results from external ("like you") search suggestion
 * @property {boolean} is_recommended - is_recommended
 * @property {Url} openingBrowserUrl - openingbrowserurl
 * @property {string} template_type - ADI template or Editor template
 * @property {string} score_vespa - vespa score
 * @property {number} page_index - page_index
 * @property {Url} originappurl - only html template viewer send this property
 * @property {GUID} sub_category_id - Sub Category ID
 * @property {string} book - book
 * @property {string} features - list of selected features
 * @property {boolean} videoThumbnail - template shows a video when hovering on the thumbnail (TRUE/FALSE)
 * @property {number} gallerydocsperpage - gallerydocsperpage
 * @property {string} styles - list of selected styles
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} layouts - list of selected layouts
 * @property {number} screen_width - Width of client device screen
 * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
 * @property {string} colors - list of selected colors
 * @property {GUID} search_guid - If from search results, GUID of matching search
 * @property {number} window_width - Initial width of client window
 * @property {string} sorting - selected sorting
 * @property {number} galleryDocIndex - gallerydocindex
 * @property {string} origin - origin  page of edit template click
 * @property {number} siteType - 1=flash, 2=html, 3=mobile, 4=facebook html, 5 = facebook flash, 6=blog(old)
 * @property {GUID} metasiteid - msid
 * @property {string} screen_type - the type of page in which the action was performed: category / search_results / main / home
 * @property {number} screen_height - Height of client device screen
 * @property {string} category - the create page category
 * @property {GUID} category_id - Category ID
 * @property {Url} http_referrer - http_referrer
 * @property {number} window_height - Initial height of client window
 * @property {GUID} esi - Editor Session Id from templates page (new for every "view" and "edit" click))
 * @property {string} platform - platform
 * @property {boolean} btn - is_button
 * @property {GUID} openingSiteID - template_id
 * @property {number} avail_height - Returns the amount of vertical space in pixels available to the window
 * @property {number} page_number - pagination
 * @property {string} product - product
 * @property {string} micro_category - micro_category
 * @return {LogObject<templatesOpenEditorParams>} LogObject<templatesOpenEditorParams>
 */
export function templatesOpenEditor(params) {
    return { evid: 15, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'landingPageViewTemplate' event (evid: 16)
 *
 * Event description: landing page > view template.
 *
 * @param {landingPageViewTemplateParams} params - The parameters for this event
 * @property {number} page_index - the category index of the template
 * @property {string} landing_url - landing_url
 * @property {number} gallerydocsperpage - gallerydocsperpage
 * @property {number} galleryDocIndex - a zero-based index of the template on the page
 * @property {Url} openingbrowserurl - openingbrowserurl
 * @property {number} siteType - site_type
 * @property {string} platform - platform
 * @property {GUID} openingSiteID - template_id
 * @property {string} product - product
 * @return {LogObject<landingPageViewTemplateParams>} LogObject<landingPageViewTemplateParams>
 */
export function landingPageViewTemplate(params) {
    return { evid: 16, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardSettigsListSocialConnectionsFailed' event (evid: 168)
 *
 * Event description: dashboard settigs -> list_social_connections_failed.
 *
 * @param {dashboardSettigsListSocialConnectionsFailedParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSettigsListSocialConnectionsFailedParams>} LogObject<dashboardSettigsListSocialConnectionsFailedParams>
 */
export function dashboardSettigsListSocialConnectionsFailed(params) {
    return { evid: 168, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardSettigsListSocialConnectionsSuccess' event (evid: 169)
 *
 * Event description: dashboard settigs -> list_social_connections_success.
 *
 * @param {dashboardSettigsListSocialConnectionsSuccessParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSettigsListSocialConnectionsSuccessParams>} LogObject<dashboardSettigsListSocialConnectionsSuccessParams>
 */
export function dashboardSettigsListSocialConnectionsSuccess(params) {
    return { evid: 169, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardSettigsSocialNetworkAuthFailed' event (evid: 172)
 *
 * Event description: dashboard settigs -> social_network_auth_failed.
 *
 * @param {dashboardSettigsSocialNetworkAuthFailedParams} params - The parameters for this event
 * @property {string} reason - reason
 * @property {string} c1 - provider_id
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSettigsSocialNetworkAuthFailedParams>} LogObject<dashboardSettigsSocialNetworkAuthFailedParams>
 */
export function dashboardSettigsSocialNetworkAuthFailed(params) {
    return { evid: 172, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardSettigsSocialNetworkAuthSuccess' event (evid: 173)
 *
 * Event description: dashboard settigs -> social_network_auth_success.
 *
 * @param {dashboardSettigsSocialNetworkAuthSuccessParams} params - The parameters for this event
 * @property {boolean} interactive - is_interactive
 * @property {string} c1 - provider_id
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSettigsSocialNetworkAuthSuccessParams>} LogObject<dashboardSettigsSocialNetworkAuthSuccessParams>
 */
export function dashboardSettigsSocialNetworkAuthSuccess(params) {
    return { evid: 173, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardSettigsSocialNetworkConnectFailed' event (evid: 174)
 *
 * Event description: dashboard settigs -> social_network_connect_failed.
 *
 * @param {dashboardSettigsSocialNetworkConnectFailedParams} params - The parameters for this event
 * @property {string} c1 - provider_id
 * @property {string} error_message - error message
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSettigsSocialNetworkConnectFailedParams>} LogObject<dashboardSettigsSocialNetworkConnectFailedParams>
 */
export function dashboardSettigsSocialNetworkConnectFailed(params) {
    return { evid: 174, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardSettigsSocialNetworkDisconnectFailed' event (evid: 175)
 *
 * Event description: dashboard settigs -> social_network_disconnect_failed.
 *
 * @param {dashboardSettigsSocialNetworkDisconnectFailedParams} params - The parameters for this event
 * @property {string} c1 - provider_id
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSettigsSocialNetworkDisconnectFailedParams>} LogObject<dashboardSettigsSocialNetworkDisconnectFailedParams>
 */
export function dashboardSettigsSocialNetworkDisconnectFailed(params) {
    return { evid: 175, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardSettigsSocialNetworkConnectSuccess' event (evid: 176)
 *
 * Event description: dashboard settigs -> social_network_connect_success.
 *
 * @param {dashboardSettigsSocialNetworkConnectSuccessParams} params - The parameters for this event
 * @property {string} c1 - provider_id
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSettigsSocialNetworkConnectSuccessParams>} LogObject<dashboardSettigsSocialNetworkConnectSuccessParams>
 */
export function dashboardSettigsSocialNetworkConnectSuccess(params) {
    return { evid: 176, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardSettigsSocialNetworkDisconnectSuccess' event (evid: 177)
 *
 * Event description: dashboard settigs -> social_network_disconnect_success.
 *
 * @param {dashboardSettigsSocialNetworkDisconnectSuccessParams} params - The parameters for this event
 * @property {string} c1 - provider_id
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSettigsSocialNetworkDisconnectSuccessParams>} LogObject<dashboardSettigsSocialNetworkDisconnectSuccessParams>
 */
export function dashboardSettigsSocialNetworkDisconnectSuccess(params) {
    return { evid: 177, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'homePageStartNowButton' event (evid: 18)
 *
 * Event description: home page -> start now button.
 *
 * @param {homePageStartNowButtonParams} params - The parameters for this event
 * @property {string} dest - dest
 * @property {number} page_index - page_index
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @property {string} product - product
 * @return {LogObject<homePageStartNowButtonParams>} LogObject<homePageStartNowButtonParams>
 */
export function homePageStartNowButton(params) {
    return { evid: 18, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesReadMore' event (evid: 19)
 *
 * Event description: templates -> read more.
 *
 * @param {templatesReadMoreParams} params - The parameters for this event
 * @property {Url} http_referrer - app_url
 * @property {number} page_index - the category index of the template
 * @property {Url} originappurl - only html template viewer send this property
 * @property {number} galleryDocIndex - gallerydocindex
 * @property {number} siteType - site_type
 * @property {string} category - the create page category
 * @property {string} platform - platform
 * @property {GUID} openingSiteID - template_id
 * @property {string} product - create page product filter
 * @return {LogObject<templatesReadMoreParams>} LogObject<templatesReadMoreParams>
 */
export function templatesReadMore(params) {
    return { evid: 19, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'homePageClickOnTemplate' event (evid: 21)
 *
 * Event description: home page -> click on template.
 *
 * @param {homePageClickOnTemplateParams} params - The parameters for this event
 * @property {number} page_index - page_index
 * @property {GUID} context - template_id
 * @property {string} platform - platform
 * @property {string} product - product
 * @return {LogObject<homePageClickOnTemplateParams>} LogObject<homePageClickOnTemplateParams>
 */
export function homePageClickOnTemplate(params) {
    return { evid: 21, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageViewerIFrameStartLoadingSrc2Evid2141' event (evid: 2141)
 *
 * Event description: start loading the iFrame on the viewer
 *
 * @param {templatesPageViewerIFrameStartLoadingSrc2Evid2141Params} params - The parameters for this event
 * @property {string} template_id - the id of the template we are starting to load
 * @return {LogObject<templatesPageViewerIFrameStartLoadingSrc2Evid2141Params>} LogObject<templatesPageViewerIFrameStartLoadingSrc2Evid2141Params>
 */
export function templatesPageViewerIFrameStartLoadingSrc2Evid2141(params) {
    return { evid: 2141, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageViewerIFrameFinishLoadingSrc2Evid2142' event (evid: 2142)
 *
 * Event description: start loading the iFrame on the viewer
 *
 * @param {templatesPageViewerIFrameFinishLoadingSrc2Evid2142Params} params - The parameters for this event
 * @property {string} template_id - the id of the template we are starting to load
 * @property {number} loading_time - loading time in ms
 * @return {LogObject<templatesPageViewerIFrameFinishLoadingSrc2Evid2142Params>} LogObject<templatesPageViewerIFrameFinishLoadingSrc2Evid2142Params>
 */
export function templatesPageViewerIFrameFinishLoadingSrc2Evid2142(params) {
    return { evid: 2142, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesStartedLoadingThePage' event (evid: 22)
 *
 * Event description: templates -> started loading the page.
 *
 * @param {templatesStartedLoadingThePageParams} params - The parameters for this event
 * @property {string} referralInfo - -
 * @property {string} interaction_type - Type of templates page interaction
 * @property {string} sub_category - List of subcategory filters
 * @property {string} event_data - data about templates loaded
 * @property {number} galleryDocsPerPage - gallerydocsperpage
 * @property {number} page_index - the category index of the template
 * @property {string} book - book
 * @property {string} features - list of selected features
 * @property {string} styles - list of selected styles
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} layouts - list of selected layouts
 * @property {string} colors - list of selected colors
 * @property {string} sorting - selected sorting
 * @property {string} origin - origin page
 * @property {string} category - the create page category
 * @property {Url} http_referrer - http_referrer
 * @property {string} platform - platform
 * @property {string} product - create page product filter
 * @return {LogObject<templatesStartedLoadingThePageParams>} LogObject<templatesStartedLoadingThePageParams>
 */
export function templatesStartedLoadingThePage(params) {
    return { evid: 22, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fwSuggestAdditionalDomainsClickSrc2Evid222' event (evid: 222)
 *
 * Event description: User clicked on Suggest Additional Domains in the Domain step
 *
 * @param {fwSuggestAdditionalDomainsClickSrc2Evid222Params} params - The parameters for this event
 * @return {LogObject<fwSuggestAdditionalDomainsClickSrc2Evid222Params>} LogObject<fwSuggestAdditionalDomainsClickSrc2Evid222Params>
 */
export function fwSuggestAdditionalDomainsClickSrc2Evid222(params) {
    return { evid: 222, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fwSuggestDomainsSeeMoreOptionsClickSrc2Evid223' event (evid: 223)
 *
 * Event description: User clicked on See more options for domains in the Domain step
 *
 * @param {fwSuggestDomainsSeeMoreOptionsClickSrc2Evid223Params} params - The parameters for this event
 * @return {LogObject<fwSuggestDomainsSeeMoreOptionsClickSrc2Evid223Params>} LogObject<fwSuggestDomainsSeeMoreOptionsClickSrc2Evid223Params>
 */
export function fwSuggestDomainsSeeMoreOptionsClickSrc2Evid223(params) {
    return { evid: 223, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fwSuggestDomainClickSrc2Evid224' event (evid: 224)
 *
 * Event description: User clicked on a specific suggested domain
 *
 * @param {fwSuggestDomainClickSrc2Evid224Params} params - The parameters for this event
 * @property {number} index - index of the domain
 * @property {string} value - domain name
 * @return {LogObject<fwSuggestDomainClickSrc2Evid224Params>} LogObject<fwSuggestDomainClickSrc2Evid224Params>
 */
export function fwSuggestDomainClickSrc2Evid224(params) {
    return { evid: 224, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fwSuggestDomainsIsShownSrc2Evid225' event (evid: 225)
 *
 * Event description: Suggest Additional Domains is shown in the domain step
 *
 * @param {fwSuggestDomainsIsShownSrc2Evid225Params} params - The parameters for this event
 * @return {LogObject<fwSuggestDomainsIsShownSrc2Evid225Params>} LogObject<fwSuggestDomainsIsShownSrc2Evid225Params>
 */
export function fwSuggestDomainsIsShownSrc2Evid225(params) {
    return { evid: 225, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesFinishedLoadingThePage' event (evid: 23)
 *
 * Event description: templates -> finished loading the page.
 *
 * @param {templatesFinishedLoadingThePageParams} params - The parameters for this event
 * @property {string} interaction_type - Type of templates page interaction
 * @property {string} sub_category - List of subcategory filters
 * @property {string} event_data - json with template list: returns all templates in the page loaded and their locations
 * @property {number} galleryDocsPerPage - gallerydocsperpage
 * @property {number} page_index - the category index of the template
 * @property {string} book - book
 * @property {string} features - list of selected features
 * @property {string} styles - list of selected styles
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} layouts - list of selected layouts
 * @property {string} colors - list of selected colors
 * @property {string} sorting - selected sorting
 * @property {number} loadingTime - time to load the page
 * @property {string} origin - origin page
 * @property {string} category - the create page category
 * @property {Url} http_referrer - http_referrer
 * @property {string} platform - platform
 * @property {string} product - create page product filter
 * @return {LogObject<templatesFinishedLoadingThePageParams>} LogObject<templatesFinishedLoadingThePageParams>
 */
export function templatesFinishedLoadingThePage(params) {
    return { evid: 23, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesClickedDescription' event (evid: 24)
 *
 * Event description: templates -> clicked description.
 *
 * @param {templatesClickedDescriptionParams} params - The parameters for this event
 * @property {number} galleryDocsPerPage - gallery docs per page
 * @property {number} page_index - page_index
 * @property {GUID} tpsi - Templates Page Session ID
 * @property {string} platform - platform
 * @property {string} product - product
 * @return {LogObject<templatesClickedDescriptionParams>} LogObject<templatesClickedDescriptionParams>
 */
export function templatesClickedDescription(params) {
    return { evid: 24, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesClosedDescription' event (evid: 25)
 *
 * Event description: templates -> closed description.
 *
 * @param {templatesClosedDescriptionParams} params - The parameters for this event
 * @property {number} galleryDocsPerPage - gallery docs per page
 * @property {number} page_index - page_index
 * @property {GUID} tpsi - Templates Page Session ID
 * @property {string} closed_from - "x button"- user clicked on x, "hover out" - user hovered out  of description
 * @property {string} platform - platform
 * @property {string} product - product
 * @return {LogObject<templatesClosedDescriptionParams>} LogObject<templatesClosedDescriptionParams>
 */
export function templatesClosedDescription(params) {
    return { evid: 25, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revisionsPageStart' event (evid: 250)
 *
 * Event description: (revisions) page start.
 *
 * @param {revisionsPageStartParams} params - The parameters for this event
 * @property {number} c2 -  0- dash, 1 - editor
 * @property {number} g1 - ts
 * @property {string} version - version
 * @property {GUID} c1 - site_id
 * @property {GUID} i1 - msid
 * @property {string} sessionId - session id generated when the page starts loading
 * @property {GUID} msid - msid
 * @return {LogObject<revisionsPageStartParams>} LogObject<revisionsPageStartParams>
 */
export function revisionsPageStart(params) {
    return { evid: 250, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revisionsPageCompleteLoad' event (evid: 251)
 *
 * Event description: when the site history page is loaded
 *
 * @param {revisionsPageCompleteLoadParams} params - The parameters for this event
 * @property {number} g1 - revisionsAJAXLoadTime
 * @property {number} editorRevisions - how many editor revisions loaded
 * @property {string} version - version
 * @property {GUID} c1 - site_id
 * @property {GUID} i1 - msid
 * @property {string} sessionId - session id generated when the page starts loading
 * @property {number} loadTime - how long the page was loading
 * @property {GUID} msid - msid
 * @property {number} adiRevisions - how many ADI revisions loaded
 * @return {LogObject<revisionsPageCompleteLoadParams>} LogObject<revisionsPageCompleteLoadParams>
 */
export function revisionsPageCompleteLoad(params) {
    return { evid: 251, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revisionsViewClick' event (evid: 252)
 *
 * Event description: view revision click
 *
 * @param {revisionsViewClickParams} params - The parameters for this event
 * @property {number} c2 - referrer_type
 * @property {number} g1 - revision_id
 * @property {string} version - version
 * @property {GUID} c1 - site_id
 * @property {GUID} i1 - msid
 * @property {string} sessionId - session id generated when the page starts loading
 * @property {DateTime} revisionDateCreated - revision creation datetime
 * @property {string} revision_builder - adi , editor
 * @property {GUID} msid - msid
 * @property {number} active_revision - the current active site revision
 * @return {LogObject<revisionsViewClickParams>} LogObject<revisionsViewClickParams>
 */
export function revisionsViewClick(params) {
    return { evid: 252, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revisionsRestoreClick' event (evid: 253)
 *
 * Event description: (revisions) restore click.
 *
 * @param {revisionsRestoreClickParams} params - The parameters for this event
 * @property {number} c2 - referrer_type
 * @property {string} popup_type - adi to editor, editor to adi, regular restore
 * @property {number} g1 - revision_id
 * @property {string} version - version
 * @property {GUID} c1 - site_id
 * @property {GUID} i1 - msid
 * @property {string} sessionId - session id generated when the page starts loading
 * @property {DateTime} revisionDateCreated - revision creation datetime
 * @property {string} revision_builder - adi, editor
 * @property {GUID} msid - msid
 * @return {LogObject<revisionsRestoreClickParams>} LogObject<revisionsRestoreClickParams>
 */
export function revisionsRestoreClick(params) {
    return { evid: 253, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revisionsRestorePopupCancel' event (evid: 254)
 *
 * Event description: (revisions) restore popup cancel.
 *
 * @param {revisionsRestorePopupCancelParams} params - The parameters for this event
 * @property {number} c2 - referrer_type
 * @property {string} popup_type - adi to editor, editor to adi, regular restore
 * @property {number} g1 - revision_id
 * @property {string} version - version
 * @property {GUID} c1 - site_id
 * @property {GUID} i1 - msid
 * @property {string} sessionId - session id generated when the page starts loading
 * @property {DateTime} revisionDateCreated - revision creation datetime
 * @property {string} revision_builder - adi, editor
 * @property {GUID} msid - msid
 * @return {LogObject<revisionsRestorePopupCancelParams>} LogObject<revisionsRestorePopupCancelParams>
 */
export function revisionsRestorePopupCancel(params) {
    return { evid: 254, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revisionsRestorePopupConfirm' event (evid: 255)
 *
 * Event description: (revisions) restore popup confirm.
 *
 * @param {revisionsRestorePopupConfirmParams} params - The parameters for this event
 * @property {number} c2 - referrer_type
 * @property {string} popup_type - adi to editor, editor to adi, regular restore
 * @property {number} g1 - revision_id
 * @property {string} version - version
 * @property {GUID} c1 - site_id
 * @property {GUID} i1 - msid
 * @property {string} sessionId - session id generated when the page starts loading
 * @property {DateTime} revisionDateCreated - revision creation datetime
 * @property {string} revision_builder - adi, editor
 * @property {GUID} msid - msid
 * @return {LogObject<revisionsRestorePopupConfirmParams>} LogObject<revisionsRestorePopupConfirmParams>
 */
export function revisionsRestorePopupConfirm(params) {
    return { evid: 255, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revisionsRestoreSuccessGoToEditor' event (evid: 256)
 *
 * Event description: (revisions) restore success go to editor.
 *
 * @param {revisionsRestoreSuccessGoToEditorParams} params - The parameters for this event
 * @property {number} c2 - referrer_type
 * @property {number} g1 - revision_id
 * @property {string} version - version
 * @property {GUID} c1 - site_id
 * @property {GUID} i1 - msid
 * @property {string} sessionId - session id generated when the page starts loading
 * @property {DateTime} revisionDateCreated - revision creation datetime
 * @property {GUID} msid - msid
 * @return {LogObject<revisionsRestoreSuccessGoToEditorParams>} LogObject<revisionsRestoreSuccessGoToEditorParams>
 */
export function revisionsRestoreSuccessGoToEditor(params) {
    return { evid: 256, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revisionsRestoreSuccessStayInPage' event (evid: 257)
 *
 * Event description: (revisions) restore success stay in page.
 *
 * @param {revisionsRestoreSuccessStayInPageParams} params - The parameters for this event
 * @property {number} c2 - referrer_type
 * @property {number} g1 - revision_id
 * @property {string} version - version
 * @property {GUID} c1 - site_id
 * @property {GUID} i1 - msid
 * @property {string} sessionId - session id generated when the page starts loading
 * @property {DateTime} revisionDateCreated - revision creation datetime
 * @property {GUID} msid - msid
 * @return {LogObject<revisionsRestoreSuccessStayInPageParams>} LogObject<revisionsRestoreSuccessStayInPageParams>
 */
export function revisionsRestoreSuccessStayInPage(params) {
    return { evid: 257, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revisionsRestoreFailed' event (evid: 258)
 *
 * Event description: restoring to a revision failed
 *
 * @param {revisionsRestoreFailedParams} params - The parameters for this event
 * @property {number} c2 - referrer_type
 * @property {number} g1 - revision_id
 * @property {string} version - version
 * @property {GUID} c1 - site_id
 * @property {GUID} i1 - msid
 * @property {string} sessionId - session id generated when the page starts loading
 * @property {boolean} switch_builder - true if restoring to a different builder
 * @property {DateTime} revisionDateCreated - revision creation datetime
 * @property {string} revision_builder - adi, editor
 * @property {GUID} msid - msid
 * @return {LogObject<revisionsRestoreFailedParams>} LogObject<revisionsRestoreFailedParams>
 */
export function revisionsRestoreFailed(params) {
    return { evid: 258, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesSearch' event (evid: 26)
 *
 * Event description: templates -> search.
 *
 * @param {templatesSearchParams} params - The parameters for this event
 * @property {number} totalPages - total_pages
 * @property {number} currentPage - current_page
 * @property {string} source - the source of the search query
 * @property {string} previous_sub_category - a sub category in which the search was performed
 * @property {string} click_source - Main Header/Sticky Header
 * @property {number} page_index - page_index
 * @property {string} criteria - criteria
 * @property {number} numberOfTemplatesInCurrentPage - templates_cnt
 * @property {string} book - book
 * @property {string} features - list of selected features
 * @property {string} selectedStructureId - structure_id of the selected term (if taken from ADI)
 * @property {string} searchType - search_type
 * @property {string} styles - list of selected styles
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} layouts - list of selected layouts
 * @property {string} colors - list of selected colors
 * @property {GUID} search_guid - Unique GUID of search
 * @property {string} sorting - selected sorting
 * @property {string} category - category = search
 * @property {string} selectedIndustryId - industry_id of the selected term (if taken from ADI)
 * @property {string} platform - platform
 * @property {string} previous_category - category in which the search was performed
 * @property {string} product - product
 * @return {LogObject<templatesSearchParams>} LogObject<templatesSearchParams>
 */
export function templatesSearch(params) {
    return { evid: 26, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revisionsMinimizeSidebar' event (evid: 263)
 *
 * Event description: (revisions) minimize sidebar.
 *
 * @param {revisionsMinimizeSidebarParams} params - The parameters for this event
 * @property {number} c2 - referrer_type
 * @property {number} g1 - revision_id
 * @property {string} version - version
 * @property {GUID} c1 - site_id
 * @property {GUID} i1 - msid
 * @property {string} sessionId - session id generated when the page starts loading
 * @property {GUID} msid - msid
 * @return {LogObject<revisionsMinimizeSidebarParams>} LogObject<revisionsMinimizeSidebarParams>
 */
export function revisionsMinimizeSidebar(params) {
    return { evid: 263, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revisionsMaximizeSidebar' event (evid: 264)
 *
 * Event description: (revisions) maximize sidebar.
 *
 * @param {revisionsMaximizeSidebarParams} params - The parameters for this event
 * @property {number} c2 - referrer_type
 * @property {number} g1 - revision_id
 * @property {string} version - version
 * @property {GUID} c1 - site_id
 * @property {GUID} i1 - msid
 * @property {string} sessionId - session id generated when the page starts loading
 * @property {GUID} msid - msid
 * @return {LogObject<revisionsMaximizeSidebarParams>} LogObject<revisionsMaximizeSidebarParams>
 */
export function revisionsMaximizeSidebar(params) {
    return { evid: 264, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revisionsFlagRevision' event (evid: 265)
 *
 * Event description: star a revision
 *
 * @param {revisionsFlagRevisionParams} params - The parameters for this event
 * @property {number} c2 - referrer_type
 * @property {number} g1 - revision_id
 * @property {string} version - version
 * @property {GUID} c1 - site_id
 * @property {GUID} i1 - msid
 * @property {string} sessionId - session id generated when the page starts loading
 * @property {DateTime} revisionDateCreated - revision creation datetime
 * @property {string} revision_builder - adi, editor
 * @property {GUID} msid - msid
 * @return {LogObject<revisionsFlagRevisionParams>} LogObject<revisionsFlagRevisionParams>
 */
export function revisionsFlagRevision(params) {
    return { evid: 265, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revisionsRenameRevision' event (evid: 266)
 *
 * Event description: rename a revision
 *
 * @param {revisionsRenameRevisionParams} params - The parameters for this event
 * @property {number} c2 - referrer
 * @property {number} g1 - revision
 * @property {string} version - app version
 * @property {GUID} c1 - site id
 * @property {GUID} i1 - msid
 * @property {string} sessionId - session id generated when the page starts loading
 * @property {DateTime} revisionDateCreated - revision creation datetime
 * @property {GUID} msid - msid
 * @return {LogObject<revisionsRenameRevisionParams>} LogObject<revisionsRenameRevisionParams>
 */
export function revisionsRenameRevision(params) {
    return { evid: 266, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revisionsRevisionViewSuccess' event (evid: 267)
 *
 * Event description: view revision success
 *
 * @param {revisionsRevisionViewSuccessParams} params - The parameters for this event
 * @property {number} c2 - referrer
 * @property {number} g1 - revision
 * @property {string} version - app version
 * @property {GUID} c1 - site
 * @property {GUID} i1 - msid
 * @property {string} sessionId - session id generated when the page starts loading
 * @property {number} loadTime - time elapsed from click
 * @property {DateTime} revisionDateCreated - revision creation datetime
 * @property {string} revision_builder - adi, editor
 * @property {GUID} msid - msid
 * @property {number} active_revision - the current active site revision
 * @return {LogObject<revisionsRevisionViewSuccessParams>} LogObject<revisionsRevisionViewSuccessParams>
 */
export function revisionsRevisionViewSuccess(params) {
    return { evid: 267, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revisionsRestoreRevisionSuccess' event (evid: 268)
 *
 * Event description: revision restore success
 *
 * @param {revisionsRestoreRevisionSuccessParams} params - The parameters for this event
 * @property {number} c2 - referrer
 * @property {number} g1 - revision
 * @property {string} version - app version
 * @property {GUID} c1 - site id
 * @property {GUID} i1 - msid
 * @property {string} sessionId - session id generated when the page starts loading
 * @property {boolean} switch_builder - true if restoring to a different builder
 * @property {number} loadTime - time elapsed from click
 * @property {DateTime} revisionDateCreated - revision creation datetime
 * @property {string} revision_builder - adi, editor
 * @property {GUID} msid - msid
 * @property {number} active_revision - the current active site revision
 * @return {LogObject<revisionsRestoreRevisionSuccessParams>} LogObject<revisionsRestoreRevisionSuccessParams>
 */
export function revisionsRestoreRevisionSuccess(params) {
    return { evid: 268, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revisionsFilterInRevisionPage' event (evid: 269)
 *
 * Event description: any kind of filter
 *
 * @param {revisionsFilterInRevisionPageParams} params - The parameters for this event
 * @property {number} c2 - referrer
 * @property {number} g1 - revision
 * @property {string} version - version
 * @property {GUID} c1 - site id
 * @property {GUID} i1 - msid
 * @property {string} sessionId - session id generated when the page starts loading
 * @property {string} filter_type - published, starred, all
 * @property {GUID} msid - msid
 * @return {LogObject<revisionsFilterInRevisionPageParams>} LogObject<revisionsFilterInRevisionPageParams>
 */
export function revisionsFilterInRevisionPage(params) {
    return { evid: 269, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesSwitchToMobile' event (evid: 27)
 *
 * Event description: templates -> switch to mobile.
 *
 * @param {templatesSwitchToMobileParams} params - The parameters for this event
 * @property {number} page_index - the category index of the template
 * @property {Url} originappurl - only html template viewer send this property
 * @property {number} siteType - site_type
 * @property {string} category - the create page category
 * @property {Url} http_referrer - http_referrer
 * @property {string} platform - platform
 * @property {GUID} openingSiteID - template_id
 * @property {string} product - create page product filter
 * @return {LogObject<templatesSwitchToMobileParams>} LogObject<templatesSwitchToMobileParams>
 */
export function templatesSwitchToMobile(params) {
    return { evid: 27, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revisionsReportPagePerformance' event (evid: 270)
 *
 * Event description: this event reports when possible the time load of server & client.
 * server time + client time will represent entire page load time
 *
 * @param {revisionsReportPagePerformanceParams} params - The parameters for this event
 * @property {number} c2 - referrer
 * @property {number} g1 - revision
 * @property {string} version - version
 * @property {GUID} c1 - site id
 * @property {GUID} i1 - msid
 * @property {string} sessionId - session id generated when the page starts loading
 * @property {GUID} msid - msid
 * @property {number} serverLoadTime - server load time
 * @property {number} clientProcessTime - DOM processing time (clientPageProcessingTime)
 * @return {LogObject<revisionsReportPagePerformanceParams>} LogObject<revisionsReportPagePerformanceParams>
 */
export function revisionsReportPagePerformance(params) {
    return { evid: 270, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesSwitchToDesktop' event (evid: 28)
 *
 * Event description: templates -> switch to desktop.
 *
 * @param {templatesSwitchToDesktopParams} params - The parameters for this event
 * @property {number} page_index - the category index of the template
 * @property {Url} originappurl - only html template viewer send this property
 * @property {number} siteType - site_type
 * @property {string} category - the create page category
 * @property {Url} http_referrer - http_referrer
 * @property {string} platform - platform
 * @property {GUID} openingSiteID - template_id
 * @property {string} product - create page product filter
 * @return {LogObject<templatesSwitchToDesktopParams>} LogObject<templatesSwitchToDesktopParams>
 */
export function templatesSwitchToDesktop(params) {
    return { evid: 28, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'flashLoginSignupFormIsOpenedTest' event (evid: 3)
 *
 * Event description: (flash login) signup form is opened.
 *
 * @param {flashLoginSignupFormIsOpenedTestParams} params - The parameters for this event
 * @property {string} template - delete me
 * @property {string} template_name - delete me
 * @property {number} page_index - page_index
 * @property {GUID} siteid
 * @property {string} origin - test
 * @property {string} platform - platform
 * @property {GUID} msid - test
 * @property {string} eventData - test
 * @property {string} product - product
 * @return {LogObject<flashLoginSignupFormIsOpenedTestParams>} LogObject<flashLoginSignupFormIsOpenedTestParams>
 */
export function flashLoginSignupFormIsOpenedTest(params) {
    return { evid: 3, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postRegPageClickOnGo' event (evid: 30)
 *
 * Event description: Top Funnel - Answer Category.
 *
 * @param {postRegPageClickOnGoParams} params - The parameters for this event
 * @property {string} structureId - structure_id
 * @property {string} location - Top, Bottom, Left etc' - Used in case of multiple buttons with the same name
 * @property {string} screen_version - screen version
 * @property {string} screenName - screen name
 * @property {number} page_index - page_index
 * @property {string} industryId - industry_id
 * @property {string} businessType - business_type
 * @property {boolean} self_declared - true= self declared by the user, false=inferred
 * @property {string} segment - segment
 * @property {string} main_industry - main_industry
 * @property {string} subcat - subcat
 * @property {string} businessSegment - business segment according to the new management  segments
 * @property {string} business_term_id - business_term_id
 * @property {string} flow - flow
 * @property {string} subIndustry - sub_industry
 * @property {string} sourceScreen - new/vertical or new/intro or second/intro
 * @property {string} target_flow - The target flow for this user in the intro
 * @property {string} platform - platform
 * @property {string} cat - category
 * @property {string} action - action
 * @property {string} product - product
 * @property {string} free_text - free_text
 * @return {LogObject<postRegPageClickOnGoParams>} LogObject<postRegPageClickOnGoParams>
 */
export function postRegPageClickOnGo(params) {
    return { evid: 30, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardLoading' event (evid: 300)
 *
 * Event description: dashboard -> loading.
 *
 * @param {dashboardLoadingParams} params - The parameters for this event
 * @property {number} g1 - ts
 * @property {boolean} c1 - is_logged_in
 * @property {string} i1 - mode
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardLoadingParams>} LogObject<dashboardLoadingParams>
 */
export function dashboardLoading(params) {
    return { evid: 300, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardLoaded' event (evid: 302)
 *
 * Event description: dashboard -> loaded.
 *
 * @param {dashboardLoadedParams} params - The parameters for this event
 * @property {number} g1 - ts
 * @property {boolean} c1 - is_logged_in
 * @property {string} i1
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardLoadedParams>} LogObject<dashboardLoadedParams>
 */
export function dashboardLoaded(params) {
    return { evid: 302, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'funnelSimulatorResults' event (evid: 3101)
 *
 * Event description: Funnel simulator results
 *
 * @param {funnelSimulatorResultsParams} params - The parameters for this event
 * @property {GUID} simulationJobId - simulation_job_id
 * @property {DateTime} simulationJobStartDate - simulation_job_start_date
 * @property {string} businessType - business_type
 * @property {string} flow - flow
 * @property {string} visitedScreens - visited_screens
 * @property {string} subIndustry - sub_industry
 * @property {GUID} flowId - flow_id
 * @property {string} enabledSpecs - enabled_specs
 * @property {GUID} snapshotId - simulation_snapshot_id
 * @property {string} mainIndustry - main_industry
 * @return {LogObject<funnelSimulatorResultsParams>} LogObject<funnelSimulatorResultsParams>
 */
export function funnelSimulatorResults(params) {
    return { evid: 3101, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'introRouter' event (evid: 3300)
 *
 * Event description: Intro Router url resolve.
 *
 * @param {introRouterParams} params - The parameters for this event
 * @property {string} post_auth_url - formerly postLogin / postSignUp
 * @property {string} redirect_to_url - redirect_to_url
 * @property {string} origin_url - origin_url
 * @property {string} precondition - SIGN_IN or SIGN_UP
 * @property {string} result_url - result_url
 * @return {LogObject<introRouterParams>} LogObject<introRouterParams>
 */
export function introRouter(params) {
    return { evid: 3300, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'topFunnelInternalRoutingSrc2Evid3301' event (evid: 3301)
 *
 * Event description: event is fired when a user is redirected from one page to another, timestamp is when we the routing started
 *
 * @param {topFunnelInternalRoutingSrc2Evid3301Params} params - The parameters for this event
 * @property {Url} referral_url - ref url
 * @property {Url} to_url - target url
 * @return {LogObject<topFunnelInternalRoutingSrc2Evid3301Params>} LogObject<topFunnelInternalRoutingSrc2Evid3301Params>
 */
export function topFunnelInternalRoutingSrc2Evid3301(params) {
    return { evid: 3301, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adoricShowLightBox' event (evid: 35)
 *
 * Event description: show adoric light box
 *
 * @param {adoricShowLightBoxParams} params - The parameters for this event
 * @property {boolean} is_visible - is_visible
 * @property {string} adoric_uuid - uuid
 * @property {string} lb_id - light box id
 * @return {LogObject<adoricShowLightBoxParams>} LogObject<adoricShowLightBoxParams>
 */
export function adoricShowLightBox(params) {
    return { evid: 35, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adoricUserClosedLightBox' event (evid: 36)
 *
 * Event description: user clicks on X in adoric light box
 *
 * @param {adoricUserClosedLightBoxParams} params - The parameters for this event
 * @property {string} lb_id - light box id
 * @property {string} adoric_uuid - uuid
 * @return {LogObject<adoricUserClosedLightBoxParams>} LogObject<adoricUserClosedLightBoxParams>
 */
export function adoricUserClosedLightBox(params) {
    return { evid: 36, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adoricClickOnCallToActionInLightBox' event (evid: 38)
 *
 * Event description: user clicked on call to action in light box
 *
 * @param {adoricClickOnCallToActionInLightBoxParams} params - The parameters for this event
 * @property {string} adoric_uuid - uuid
 * @property {string} type - call to action type (link, button, video...)
 * @property {string} value - template name, video name, form type
 * @property {string} lb_id - light box id
 * @property {string} action - open template, submit, play video...
 * @return {LogObject<adoricClickOnCallToActionInLightBoxParams>} LogObject<adoricClickOnCallToActionInLightBoxParams>
 */
export function adoricClickOnCallToActionInLightBox(params) {
    return { evid: 38, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adoricLabelCalledByPage' event (evid: 4)
 *
 * Event description: event represent that the page called adoric code to be loaded on the page - the event is helping with monitoring rather adoric code is being called each time petri label is generated for the user
 *
 * @param {adoricLabelCalledByPageParams} params - The parameters for this event
 * @property {boolean} is_visible
 * @property {string} page_name - the name corresponding to the experiment/Adoric campaign
 * @property {string} adoric_uuid - uuid
 * @property {number} label_id - petri label id
 * @property {number} event_counter - counting the number of evid 4 events in the session
 * @return {LogObject<adoricLabelCalledByPageParams>} LogObject<adoricLabelCalledByPageParams>
 */
export function adoricLabelCalledByPage(params) {
    return { evid: 4, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adoricLabelLoadingToPage' event (evid: 40)
 *
 * Event description: Adoric response with the label of the LB to be shown when triggered - for the use of AB test being managed in Adoric side
 *
 * @param {adoricLabelLoadingToPageParams} params - The parameters for this event
 * @property {boolean} is_visible - is_visible
 * @property {string} adoric_uuid - uuid
 * @property {string} lb_id - light box id
 * @return {LogObject<adoricLabelLoadingToPageParams>} LogObject<adoricLabelLoadingToPageParams>
 */
export function adoricLabelLoadingToPage(params) {
    return { evid: 40, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'splitPageStartLoad' event (evid: 401)
 *
 * Event description: Split page loads
 *
 * @param {splitPageStartLoadParams} params - The parameters for this event
 * @property {string} structureId - structure_id
 * @property {string} industryId - industry_id
 * @property {string} subcat - sub category
 * @property {string} category - category chosen before split page
 * @return {LogObject<splitPageStartLoadParams>} LogObject<splitPageStartLoadParams>
 */
export function splitPageStartLoad(params) {
    return { evid: 401, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'splitPageFinishLoad' event (evid: 402)
 *
 * Event description: Split page - page view
 *
 * @param {splitPageFinishLoadParams} params - The parameters for this event
 * @property {string} structureId - structure_id
 * @property {string} sub_type - subtype of the split
 * @property {string} industryId - industry_id
 * @property {string} subcat - sub category
 * @property {string} flow - flow
 * @property {number} delta - time in milliseconds between load and finish
 * @property {string} category - category chosen before split page
 * @property {string} split_screen_type - {null} - old split screen. {editor/ADI/equal} - first time intro split screen.  {second site} - second site intro split.
 * @return {LogObject<splitPageFinishLoadParams>} LogObject<splitPageFinishLoadParams>
 */
export function splitPageFinishLoad(params) {
    return { evid: 402, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'splitPageEditorSelected' event (evid: 403)
 *
 * Event description: user chose to open the editor
 *
 * @param {splitPageEditorSelectedParams} params - The parameters for this event
 * @property {string} structureId - structure_id
 * @property {string} industryId - industry_id
 * @property {string} subcat - sub category
 * @property {string} flow - flow
 * @property {string} category - category chosen before split page
 * @property {string} split_screen_type - null - old split screen. editor/ADI/equal - new intro split screen
 * @return {LogObject<splitPageEditorSelectedParams>} LogObject<splitPageEditorSelectedParams>
 */
export function splitPageEditorSelected(params) {
    return { evid: 403, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'splitPageAdiSelected' event (evid: 404)
 *
 * Event description: user chose to open ADI
 *
 * @param {splitPageAdiSelectedParams} params - The parameters for this event
 * @property {string} structureId - structure_id
 * @property {string} industryId - industry_id
 * @property {string} subcat - sub category
 * @property {string} referral - referral for intro page
 * @property {string} flow - flow
 * @property {string} category - category chosen before split page
 * @property {string} split_screen_type - null - old split screen. editor/ADI/equal - new intro split screen
 * @return {LogObject<splitPageAdiSelectedParams>} LogObject<splitPageAdiSelectedParams>
 */
export function splitPageAdiSelected(params) {
    return { evid: 404, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'splitPageFullStoryStartSession' event (evid: 405)
 *
 * Event description: split page - FullStory start session
 *
 * @param {splitPageFullStoryStartSessionParams} params - The parameters for this event
 * @property {string} structureId - structure_id
 * @property {Url} fullstoryurl - FullStory recording URL
 * @property {string} industryId - industry_id
 * @property {string} subcat - sub category
 * @property {string} category - category chosen before split page
 * @return {LogObject<splitPageFullStoryStartSessionParams>} LogObject<splitPageFullStoryStartSessionParams>
 */
export function splitPageFullStoryStartSession(params) {
    return { evid: 405, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'splitPageClickOnBack' event (evid: 407)
 *
 * Event description: split page - click on "back"
 *
 * @param {splitPageClickOnBackParams} params - The parameters for this event
 * @property {string} structureId - structure_id
 * @property {string} industryId - industry_id
 * @property {string} subcat - sub category
 * @property {string} category - category chosen before split page
 * @property {string} split_screen_type - null - old split screen. editor/ADI/equal - new intro split screen
 * @return {LogObject<splitPageClickOnBackParams>} LogObject<splitPageClickOnBackParams>
 */
export function splitPageClickOnBack(params) {
    return { evid: 407, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'splitPageDifmSelected' event (evid: 408)
 *
 * Event description: user chose to hire an expert - DIFM (Do It For Me)
 *
 * @param {splitPageDifmSelectedParams} params - The parameters for this event
 * @property {string} structureId - structure_id
 * @property {string} industryId - industry_id
 * @property {string} subcat - sub category
 * @property {string} referral - referral for intro page
 * @property {string} category - category chosen before split page
 * @property {string} split_screen_type - null - old split screen. editor/ADI/equal - new intro split screen
 * @return {LogObject<splitPageDifmSelectedParams>} LogObject<splitPageDifmSelectedParams>
 */
export function splitPageDifmSelected(params) {
    return { evid: 408, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'modelPredictionSplitPage' event (evid: 409)
 *
 * Event description: This event will fire on a user level every time that the DS model predicts which split page to show. It happens when the user answers or skips the category question.
 * The output can be either ADI or Editor Split page.
 *
 * @param {modelPredictionSplitPageParams} params - The parameters for this event
 * @property {string} structureId - structure id
 * @property {GUID} uuid - uuid
 * @property {string} siteFor - site for
 * @property {string} subcategory - subcategory
 * @property {string} experience - experience
 * @property {string} category - category
 * @property {string} split_screen_type - adi or editor
 * @property {number} loading_time - time from request to model result
 * @return {LogObject<modelPredictionSplitPageParams>} LogObject<modelPredictionSplitPageParams>
 */
export function modelPredictionSplitPage(params) {
    return { evid: 409, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'splitPageEditorxSelected' event (evid: 412)
 *
 * Event description: user clicks editor x in the partners dashboard
 *
 * @param {splitPageEditorxSelectedParams} params - The parameters for this event
 * @property {string} flow - flow
 * @property {string} split_screen_type - partners split
 * @return {LogObject<splitPageEditorxSelectedParams>} LogObject<splitPageEditorxSelectedParams>
 */
export function splitPageEditorxSelected(params) {
    return { evid: 412, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adoricDidNotNotLoad' event (evid: 42)
 *
 * Event description: Event triggered when Wix calls Adoric, but Adoric doesn't load (and doesn't send events 40 or 41).
 *
 * @param {adoricDidNotNotLoadParams} params - The parameters for this event
 * @property {boolean} is_visible - Whether Petri/Adoric user is visible or hidden
 * @return {LogObject<adoricDidNotNotLoadParams>} LogObject<adoricDidNotNotLoadParams>
 */
export function adoricDidNotNotLoad(params) {
    return { evid: 42, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'introMlRequest' event (evid: 451)
 *
 * Event description: Intro ML request
 *
 * @param {introMlRequestParams} params - The parameters for this event
 * @property {boolean} isFallback - is_fallback
 * @property {string} screen_version - screen_version
 * @property {string} requestData - request_data
 * @property {string} screenName - screen_name
 * @property {string} errorMessage - error_message
 * @property {string} pageId - page_id
 * @property {string} flow - flow
 * @property {string} strategy - strategy
 * @property {string} request_id - ml_request_id
 * @property {string} answer - answer
 * @property {string} selectedScreen - The next screen that selected for the user
 * @property {number} response_time_ms - response_time
 * @property {string} subFlow - sub_flow
 * @property {GUID} msid - msid
 * @return {LogObject<introMlRequestParams>} LogObject<introMlRequestParams>
 */
export function introMlRequest(params) {
    return { evid: 451, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesSeeAllTemplates' event (evid: 46)
 *
 * Event description: When a user clicks on "see all templates" from the viewer
 * https://jira.wixpress.com/browse/MRND-2219
 *
 * @param {templatesSeeAllTemplatesParams} params - The parameters for this event
 * @property {number} page_index - page_index
 * @property {Url} originappurl - only html template viewer send this property
 * @property {string} to_category - templates page target category
 * @property {string} from_category - templates page origin category
 * @property {string} platform - platform
 * @property {string} template_id - template guid
 * @property {string} product - product
 * @return {LogObject<templatesSeeAllTemplatesParams>} LogObject<templatesSeeAllTemplatesParams>
 */
export function templatesSeeAllTemplates(params) {
    return { evid: 46, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesSawAnElement' event (evid: 47)
 *
 * Event description: templates -> saw an element
 *
 * @param {templatesSawAnElementParams} params - The parameters for this event
 * @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
 * @property {string} sub_category - Sub category clicked from
 * @property {string} element_identifier - category name for categories and template_guid for templates
 * @property {Url} openingBrowserUrl - opening_browser_url
 * @property {string} template_type - ADI template or Editor template
 * @property {number} page_index - page_index
 * @property {Url} originappurl - only html template viewer send this property
 * @property {string} book - book name
 * @property {boolean} videoThumbnail - template shows a video when hovering on the thumbnail (TRUE/FALSE)
 * @property {string} element_name - element_name
 * @property {string} header_type - the type of header (default/sticky) in which the click was performed
 * @property {number} gallerydocsperpage - gallerydocsperpage
 * @property {GUID} tpsi - Templates Page Session ID
 * @property {number} galleryDocIndex - gallery_doc_index
 * @property {number} siteType - 1=flash, 2=html, 3=mobile, 4=facebook html, 5 = facebook flash, 6=blog(old)
 * @property {string} screen_type - the type of page in which the action was performed: category / search_results / main / home
 * @property {string} category - the create page category
 * @property {string} platform - platform
 * @property {GUID} template_id - in case of click on template thumbnail
 * @property {string} product - product
 * @return {LogObject<templatesSawAnElementParams>} LogObject<templatesSawAnElementParams>
 */
export function templatesSawAnElement(params) {
    return { evid: 47, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesClickOnElement' event (evid: 48)
 *
 * Event description: templates -> click on element
 *
 * @param {templatesClickOnElementParams} params - The parameters for this event
 * @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
 * @property {string} sub_category - Sub category clicked from
 * @property {Url} openingBrowserUrl - opening_browser_url
 * @property {string} template_type - ADI template or Editor template
 * @property {number} page_index - page_index
 * @property {Url} originappurl - only html template viewer send this property
 * @property {string} book - book name
 * @property {boolean} videoThumbnail - template shows a video when hovering on the thumbnail (TRUE/FALSE)
 * @property {string} clicked_element_identifier - category name for categories and template_guid for templates
 * @property {string} header_type - the type of header (default/sticky) in which the click was performed
 * @property {string} clicked_element - the element that was clicked
 * @property {number} gallerydocsperpage - gallerydocsperpage
 * @property {GUID} tpsi - Templates Page Session ID
 * @property {number} galleryDocIndex - gallery_doc_index
 * @property {number} siteType - 1=flash, 2=html, 3=mobile, 4=facebook html, 5 = facebook flash, 6=blog(old)
 * @property {string} screen_type - the type of page in which the action was performed: category / search_results / main / home
 * @property {string} category - the create page category
 * @property {string} platform - platform
 * @property {GUID} template_id - in case of click on template thumbnail
 * @property {string} product - product
 * @property {string} micro_category - micro_category
 * @return {LogObject<templatesClickOnElementParams>} LogObject<templatesClickOnElementParams>
 */
export function templatesClickOnElement(params) {
    return { evid: 48, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesFullLoadingTimes' event (evid: 49)
 *
 * Event description: full loading times for templates page
 *
 * @param {templatesFullLoadingTimesParams} params - The parameters for this event
 * @property {number} dom_content_loaded_event_end - dom_content_loaded_event_end
 * @property {number} domain_lookup_end - domain_lookup_end
 * @property {number} page_index - page_index
 * @property {number} redirect_end - redirect_end
 * @property {number} domLoading_ts - dom_loading_ts
 * @property {number} connect_end - connect_end
 * @property {number} connect_start - connect_start
 * @property {number} domComplete_ts - domComplete_ts
 * @property {number} response_start - response_start
 * @property {number} dom_content_loaded_event_start - dom_content_loaded_event_start
 * @property {number} domain_lookup_start - domain_lookup_start
 * @property {number} request_start - request_start
 * @property {GUID} tpsi - Templates Page Session ID
 * @property {number} dom_interactive - dom_interactive
 * @property {number} screen_width - Width of client device screen
 * @property {number} fetch_start - fetch_start
 * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
 * @property {number} navigation_start - navigation_start
 * @property {number} unload_event_end - unload_event_end
 * @property {number} window_width - Initial width of client window
 * @property {number} redirect_start - redirect_start
 * @property {number} unload_event_start - unload_event_start
 * @property {number} load_event_start - load_event_start
 * @property {number} screen_height - Height of client device screen
 * @property {number} window_height - Initial height of client window
 * @property {string} platform - platform
 * @property {number} secure_connection_start - secure_connection_start
 * @property {number} avail_height - Returns the amount of vertical space in pixels available to the window
 * @property {number} load_event_end - load_event_end
 * @property {number} basic_loading_time - basic_loading_time
 * @property {number} response_end - response_end
 * @property {string} product - product
 * @return {LogObject<templatesFullLoadingTimesParams>} LogObject<templatesFullLoadingTimesParams>
 */
export function templatesFullLoadingTimes(params) {
    return { evid: 49, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesStartNowAdiBuilder' event (evid: 50)
 *
 * Event description: Clicking the "Start Now" ADI builder from no results search
 *
 * @param {templatesStartNowAdiBuilderParams} params - The parameters for this event
 * @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
 * @property {Url} openingBrowserUrl - openingBrowserUrl
 * @property {string} template_type - ADI template or Editor template
 * @property {number} page_index - page_index
 * @property {string} criteria - Criteria searched
 * @property {number} screen_width - Width of client device screen
 * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
 * @property {number} window_width - Initial width of client window
 * @property {number} total_suggested_results - total search results from external search suggestion
 * @property {number} screen_height - Height of client device screen
 * @property {number} window_height - Initial height of client window
 * @property {GUID} esi - ESI guid
 * @property {string} platform - platform
 * @property {number} avail_height - Returns the amount of vertical space in pixels available to the window
 * @property {string} product - product
 * @return {LogObject<templatesStartNowAdiBuilderParams>} LogObject<templatesStartNowAdiBuilderParams>
 */
export function templatesStartNowAdiBuilder(params) {
    return { evid: 50, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'topFunnelStartFlow' event (evid: 500)
 *
 * Event description: Top Funnel - Start Flow
 *
 * @param {topFunnelStartFlowParams} params - The parameters for this event
 * @property {string} screenVersion - screen_version
 * @property {string} referralInfo - referral_info
 * @property {string} screenName - screen_name
 * @property {number} pageIndex - The index of the screen
 * @property {string} refferalUrl - refferalUrl
 * @property {string} pageId - page_id
 * @property {string} flow - flow
 * @property {string} subFlow - sub_flow
 * @property {string} previousScreenVersion - The version of the previous screen in the user flow
 * @property {string} flowTheme - original, light, dark
 * @return {LogObject<topFunnelStartFlowParams>} LogObject<topFunnelStartFlowParams>
 */
export function topFunnelStartFlow(params) {
    return { evid: 500, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroScreenView' event (evid: 501)
 *
 * Event description: main funnel intro - screen view
 *
 * @param {mainFunnelIntroScreenViewParams} params - The parameters for this event
 * @property {boolean} isFallback - is_fallback
 * @property {string} user_msid - the real msid of the user
 * @property {string} introGuid - not in use
 * @property {string} browser_language - browser_language, only reporting this for the screen_name='split'
 * @property {string} referral_name - referral_name
 * @property {string} screen_version - the screen sub type
 * @property {string} initial_data - initial_data when the page loaded
 * @property {string} screenName - screen name
 * @property {string} widget_name - widget_name
 * @property {string} additional_info - additional_info
 * @property {number} pageIndex - The index of the screen
 * @property {string} screenResolution - user's screen resolution
 * @property {string} pageId - page_id
 * @property {string} previousScreen - The name of the previous screen in the user flow
 * @property {string} userInfo - current user info from previous selections (json)
 * @property {string} intro_type - old vs new_velo vs new_edix
 * @property {string} flow - old intro, new intro or new site
 * @property {string} question_name - question name inside the screen
 * @property {string} introVariant - marketing intro version
 * @property {string} split_screen_type - for split screen - editor/ADI/equal
 * @property {string} platform - which platform renders the screen
 * @property {string} resolved_language - resolved language
 * @property {string} subFlow - sub_flow
 * @property {string} previousScreenVersion - The version of the previous screen in the user flow
 * @return {LogObject<mainFunnelIntroScreenViewParams>} LogObject<mainFunnelIntroScreenViewParams>
 */
export function mainFunnelIntroScreenView(params) {
    return { evid: 501, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroWelcomeScreenClickOnOk' event (evid: 502)
 *
 * Event description: main funnel intro - welcome screen click on “ok”
 *
 * @param {mainFunnelIntroWelcomeScreenClickOnOkParams} params - The parameters for this event
 * @property {string} screen_version - the screen sub type
 * @property {string} screenName - welcome
 * @property {string} flow - intro vs new site
 * @return {LogObject<mainFunnelIntroWelcomeScreenClickOnOkParams>} LogObject<mainFunnelIntroWelcomeScreenClickOnOkParams>
 */
export function mainFunnelIntroWelcomeScreenClickOnOk(params) {
    return { evid: 502, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroClickOnSkip' event (evid: 503)
 *
 * Event description: main funnel intro - click on “skip”
 *
 * @param {mainFunnelIntroClickOnSkipParams} params - The parameters for this event
 * @property {string} screen_version - the screen sub type
 * @property {string} screenName - screen name where users clicked on "skip"
 * @property {string} flow - flow
 * @return {LogObject<mainFunnelIntroClickOnSkipParams>} LogObject<mainFunnelIntroClickOnSkipParams>
 */
export function mainFunnelIntroClickOnSkip(params) {
    return { evid: 503, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroDropdownOpen' event (evid: 504)
 *
 * Event description: main funnel intro - dropdown open
 *
 * @param {mainFunnelIntroDropdownOpenParams} params - The parameters for this event
 * @property {string} screenName - screen name
 * @property {string} dropdownName - dropdown name
 * @property {string} trigger - open trigger {user, auto}
 * @return {LogObject<mainFunnelIntroDropdownOpenParams>} LogObject<mainFunnelIntroDropdownOpenParams>
 */
export function mainFunnelIntroDropdownOpen(params) {
    return { evid: 504, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroSiteForSelected' event (evid: 505)
 *
 * Event description: main funnel intro - “site for” selected
 *
 * @param {mainFunnelIntroSiteForSelectedParams} params - The parameters for this event
 * @property {string} siteFor - site for {client / myself / someone / company}
 * @return {LogObject<mainFunnelIntroSiteForSelectedParams>} LogObject<mainFunnelIntroSiteForSelectedParams>
 */
export function mainFunnelIntroSiteForSelected(params) {
    return { evid: 505, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroCategorySelected' event (evid: 506)
 *
 * Event description: main funnel intro - category selected
 *
 * @param {mainFunnelIntroCategorySelectedParams} params - The parameters for this event
 * @property {string} structureId - structure_id
 * @property {string} screen_version - the screen sub type
 * @property {string} screenName - screen name
 * @property {string} industryId - industry_id
 * @property {string} segment - segment
 * @property {string} subcat - sub category
 * @property {string} userInfo - current user info from previous selections (json)
 * @property {string} category - category
 * @return {LogObject<mainFunnelIntroCategorySelectedParams>} LogObject<mainFunnelIntroCategorySelectedParams>
 */
export function mainFunnelIntroCategorySelected(params) {
    return { evid: 506, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroClickOnSeeRecommendation' event (evid: 507)
 *
 * Event description: main funnel intro - intro finish. happens either automatically when user answered all questions and is redirected to the split screen, or when users clicks on "see recommendation" button (when it's displayed).
 *
 * @param {mainFunnelIntroClickOnSeeRecommendationParams} params - The parameters for this event
 * @property {boolean} profDesigner - profession designer (true/false)
 * @property {string} structureId - structure_id
 * @property {string} companySize - company size
 * @property {boolean} agencyWebDesign - agency web design (true/false)
 * @property {string} industryId - industry_id
 * @property {boolean} agencyWebDevelopment - agency web development (true/false)
 * @property {boolean} agencySEO - agency SEO (true/false)
 * @property {string} siteFor - site for {client / myself / someone / company}
 * @property {string} subcat - sub category
 * @property {boolean} profMarketer - profession marketer (true/false)
 * @property {string} userInfo - current user info from previous selections (json)
 * @property {string} experience - experience
 * @property {boolean} agencyMarketing - agency marketing (true/false)
 * @property {boolean} agencyFullService - agency full service (true/false)
 * @property {string} category - category
 * @property {boolean} agencyBranding - agency branding (true/false)
 * @property {string} introVariant - marketing intro version
 * @property {boolean} agencyOther - agency other(true/false)
 * @property {boolean} profOther - profession other (true/false)
 * @property {boolean} profDeveloper - profession developer (true/false)
 * @property {string} workAt - "work at" selection (agency/freelancer)
 * @property {string} trigger - trigger {user, auto}
 * @return {LogObject<mainFunnelIntroClickOnSeeRecommendationParams>} LogObject<mainFunnelIntroClickOnSeeRecommendationParams>
 */
export function mainFunnelIntroClickOnSeeRecommendation(params) {
    return { evid: 507, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroExpertTypeDropdownClick' event (evid: 508)
 *
 * Event description: main intro funnel - expert type dropdown click (for users that chose "site for a client")
 *
 * @param {mainFunnelIntroExpertTypeDropdownClickParams} params - The parameters for this event
 * @property {string} expertType - designer/developer/marketer/other: {true/false} (json)
 * @return {LogObject<mainFunnelIntroExpertTypeDropdownClickParams>} LogObject<mainFunnelIntroExpertTypeDropdownClickParams>
 */
export function mainFunnelIntroExpertTypeDropdownClick(params) {
    return { evid: 508, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroExpertTypeClickOnDone' event (evid: 509)
 *
 * Event description: main intro funnel - expert type dropdown selection. user - when user clicks on “done”, or automatic if users clicks elsewhere and his selection was saved.
 *
 * @param {mainFunnelIntroExpertTypeClickOnDoneParams} params - The parameters for this event
 * @property {string} expertType - designer/developer/marketer/other: {true/false} (json)
 * @property {string} trigger - trigger {user, auto}
 * @return {LogObject<mainFunnelIntroExpertTypeClickOnDoneParams>} LogObject<mainFunnelIntroExpertTypeClickOnDoneParams>
 */
export function mainFunnelIntroExpertTypeClickOnDone(params) {
    return { evid: 509, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPagePageFullyRendered' event (evid: 51)
 *
 * Event description: Templates page interaction is fully rendered and interactive to user
 *
 * @param {templatesPagePageFullyRenderedParams} params - The parameters for this event
 * @property {string} referralInfo - -
 * @property {string} interaction_type - Type of templates page interaction
 * @property {string} sub_category - List of subcategory filters
 * @property {string} event_data - data about templates loaded
 * @property {number} page_index - page_index
 * @property {string} book - book
 * @property {string} features - list of selected features
 * @property {number} gallerydocsperpage - Number of thumbnails on page
 * @property {string} styles - list of selected styles
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} layouts - list of selected layouts
 * @property {string} colors - list of selected colors
 * @property {string} sorting - selected sorting
 * @property {number} loadingTime - Time to full rendering (interactive)
 * @property {string} origin - origin page
 * @property {string} category - the create page category
 * @property {string} platform - platform
 * @property {string} product - product
 * @return {LogObject<templatesPagePageFullyRenderedParams>} LogObject<templatesPagePageFullyRenderedParams>
 */
export function templatesPagePageFullyRendered(params) {
    return { evid: 51, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroNonExpertExperienceSelected' event (evid: 510)
 *
 * Event description: main funnel intro - non expert (users that chose "site for myself") dropdown selection of experience
 *
 * @param {mainFunnelIntroNonExpertExperienceSelectedParams} params - The parameters for this event
 * @property {string} nonExpertExperience - {built sites professionally / created many websites / built a few websites / never done this before}
 * @property {string} screenName - screen name
 * @return {LogObject<mainFunnelIntroNonExpertExperienceSelectedParams>} LogObject<mainFunnelIntroNonExpertExperienceSelectedParams>
 */
export function mainFunnelIntroNonExpertExperienceSelected(params) {
    return { evid: 510, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroFullStoryStartSession' event (evid: 511)
 *
 * Event description: main funnel intro - FullStory start session
 *
 * @param {mainFunnelIntroFullStoryStartSessionParams} params - The parameters for this event
 * @property {Url} fullstoryurl - FullStory recording URL
 * @return {LogObject<mainFunnelIntroFullStoryStartSessionParams>} LogObject<mainFunnelIntroFullStoryStartSessionParams>
 */
export function mainFunnelIntroFullStoryStartSession(params) {
    return { evid: 511, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroCategoryUserTyping' event (evid: 512)
 *
 * Event description: main funnel intro - category selection - user typing
 *
 * @param {mainFunnelIntroCategoryUserTypingParams} params - The parameters for this event
 * @property {string} screen_version - the screen sub type
 * @property {string} screenName - the screen in which the text was typed
 * @property {number} returnedResults - how many results the user sees, 0 for zero matches
 * @property {string} text - searched text
 * @property {string} flow - old intro, new intro or new site
 * @property {string} platform - which platform renders the screen
 * @return {LogObject<mainFunnelIntroCategoryUserTypingParams>} LogObject<mainFunnelIntroCategoryUserTypingParams>
 */
export function mainFunnelIntroCategoryUserTyping(params) {
    return { evid: 512, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroCompanySizeSelected' event (evid: 513)
 *
 * Event description: main funnel intro - company size selected
 *
 * @param {mainFunnelIntroCompanySizeSelectedParams} params - The parameters for this event
 * @property {string} companySize - company size
 * @return {LogObject<mainFunnelIntroCompanySizeSelectedParams>} LogObject<mainFunnelIntroCompanySizeSelectedParams>
 */
export function mainFunnelIntroCompanySizeSelected(params) {
    return { evid: 513, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroWorkAtSelected' event (evid: 514)
 *
 * Event description: main funnel intro - "work at" selection (for users who chose "site for a client")
 *
 * @param {mainFunnelIntroWorkAtSelectedParams} params - The parameters for this event
 * @property {string} workAt - "work at" selection (agency/freelancer)
 * @return {LogObject<mainFunnelIntroWorkAtSelectedParams>} LogObject<mainFunnelIntroWorkAtSelectedParams>
 */
export function mainFunnelIntroWorkAtSelected(params) {
    return { evid: 514, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroAgencyTypeDropdownClick' event (evid: 515)
 *
 * Event description: main funnel intro - agency type dropdown click (for users who chose "site for a client" and "work at agency..")
 *
 * @param {mainFunnelIntroAgencyTypeDropdownClickParams} params - The parameters for this event
 * @property {string} agencyType - json with all values (web design / marketing / seo etc) with true/false
 * @return {LogObject<mainFunnelIntroAgencyTypeDropdownClickParams>} LogObject<mainFunnelIntroAgencyTypeDropdownClickParams>
 */
export function mainFunnelIntroAgencyTypeDropdownClick(params) {
    return { evid: 515, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroAgencyTypeSelected' event (evid: 516)
 *
 * Event description: main funnel intro - agency type dropdown click (for users who chose "site for a client" and "work at agency..")
 *
 * @param {mainFunnelIntroAgencyTypeSelectedParams} params - The parameters for this event
 * @property {string} screenName - client agencyType / client freelancerType
 * @property {string} agencyType - json with all values (web design / marketing / seo etc) with true/false
 * @property {string} trigger - trigger {user, auto}
 * @return {LogObject<mainFunnelIntroAgencyTypeSelectedParams>} LogObject<mainFunnelIntroAgencyTypeSelectedParams>
 */
export function mainFunnelIntroAgencyTypeSelected(params) {
    return { evid: 516, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroClickOnProgressBar' event (evid: 517)
 *
 * Event description: main funnel intro - click on one of the steps in intro's progress bar.
 *
 * @param {mainFunnelIntroClickOnProgressBarParams} params - The parameters for this event
 * @property {string} screenName - the screen in which the button was clicked
 * @property {number} originStep - the step in which the button was clicked
 * @property {string} destinationScreen - the screen which the button leads to
 * @property {number} destinationStep - the step which the button leads to
 * @return {LogObject<mainFunnelIntroClickOnProgressBarParams>} LogObject<mainFunnelIntroClickOnProgressBarParams>
 */
export function mainFunnelIntroClickOnProgressBar(params) {
    return { evid: 517, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroHoverOn' event (evid: 518)
 *
 * Event description: main funnel intro - users hover on a button
 *
 * @param {mainFunnelIntroHoverOnParams} params - The parameters for this event
 * @property {string} screen_version - screen_version
 * @property {string} hoverButton - the button on which the user's hover
 * @property {string} screenName - screen name
 * @property {number} hoverTime - hover time (milliseconds)
 * @property {string} flow - flow
 * @return {LogObject<mainFunnelIntroHoverOnParams>} LogObject<mainFunnelIntroHoverOnParams>
 */
export function mainFunnelIntroHoverOn(params) {
    return { evid: 518, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroClickBack' event (evid: 519)
 *
 * Event description: main funnel intro - click back to previous step
 *
 * @param {mainFunnelIntroClickBackParams} params - The parameters for this event
 * @property {string} screen_version - the screen sub type
 * @property {string} screenName - the screen in which the button was clicked
 * @property {number} originStep - the step in which the button was clicked
 * @property {string} destinationScreen - the screen which the button leads to
 * @property {string} flow - flow
 * @property {number} destinationStep - the step which the button leads to
 * @return {LogObject<mainFunnelIntroClickBackParams>} LogObject<mainFunnelIntroClickBackParams>
 */
export function mainFunnelIntroClickBack(params) {
    return { evid: 519, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesTemplateAboveTheFoldImpression' event (evid: 52)
 *
 * Event description: When a user has a template above the fold on the Templates Page or clicks any component on the thumbnail
 *
 * @param {templatesTemplateAboveTheFoldImpressionParams} params - The parameters for this event
 * @property {number} page_view_index - Page Index
 * @property {string} sub_category - List of subcategory filters
 * @property {number} galleryDocsPerPage - gallery doc page
 * @property {number} page_index - page_index
 * @property {string} book - book
 * @property {string} features - list of selected features
 * @property {string} styles - list of selected styles
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} layouts - list of selected layouts
 * @property {number} screen_width - Width of client device screen
 * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
 * @property {string} colors - list of selected colors
 * @property {number} window_width - Initial width of client window
 * @property {string} sorting - selected sorting
 * @property {number} galleryDocIndex - gallery doc index
 * @property {number} siteType - site type
 * @property {number} screen_height - Height of client device screen
 * @property {string} category - category
 * @property {number} window_height - Initial height of client window
 * @property {string} platform - platform
 * @property {number} avail_height - Returns the amount of horizontal space in pixels vertical to the window
 * @property {GUID} template_id - template guid
 * @property {string} product - product
 * @property {boolean} is_recommended - shown in recommended section
 * @property {string} template_description - template description
 * @property {string} badgeDescription - badge description
 * @return {LogObject<templatesTemplateAboveTheFoldImpressionParams>} LogObject<templatesTemplateAboveTheFoldImpressionParams>
 */
export function templatesTemplateAboveTheFoldImpression(params) {
    return { evid: 52, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroSkillSetSelected' event (evid: 520)
 *
 * Event description: main intro funnel - skill set selection - for users with high experience that chose "someone else"  (fires when user clicks “done"/"next”)
 *
 * @param {mainFunnelIntroSkillSetSelectedParams} params - The parameters for this event
 * @property {string} skill - desig/web development/marketing/other: {true/false} (json)
 * @return {LogObject<mainFunnelIntroSkillSetSelectedParams>} LogObject<mainFunnelIntroSkillSetSelectedParams>
 */
export function mainFunnelIntroSkillSetSelected(params) {
    return { evid: 520, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroCompanyRoleSelected' event (evid: 521)
 *
 * Event description: main funnel intro - users selected their role in the company (for users who chose "site for a company")
 *
 * @param {mainFunnelIntroCompanyRoleSelectedParams} params - The parameters for this event
 * @property {string} companyRole - user's role in the company
 * @return {LogObject<mainFunnelIntroCompanyRoleSelectedParams>} LogObject<mainFunnelIntroCompanyRoleSelectedParams>
 */
export function mainFunnelIntroCompanyRoleSelected(params) {
    return { evid: 521, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroClickAnAnswer' event (evid: 522)
 *
 * Event description: main funnel intro - answer button click (before clicking next)
 *
 * @param {mainFunnelIntroClickAnAnswerParams} params - The parameters for this event
 * @property {boolean} suggested_option - true if its suggested button
 * @property {string} screen_version - the screen sub type
 * @property {string} screenName - the screen in which the button was clicked
 * @property {string} button_name - the button that was clicked
 * @property {DateTime} scheduledTime - date (if time is 00:00) or datetime user clicked on
 * @property {number} pageIndex - The index of the screen
 * @property {string} pageId - page_id
 * @property {string} previousScreen - The name of the previous screen in the user flow
 * @property {string} flow - old intro, new intro or new site
 * @property {string} question_name - question_name
 * @property {string} answer - the answer that was clicked
 * @property {number} position - position
 * @property {string} platform - which platform renders the screen
 * @property {string} subFlow - sub_flow
 * @property {string} previousScreenVersion - The version of the previous screen in the user flow
 * @property {string} free_text - free text
 * @property {boolean} final_answer - true for final answer of the screen (one option)
 * @return {LogObject<mainFunnelIntroClickAnAnswerParams>} LogObject<mainFunnelIntroClickAnAnswerParams>
 */
export function mainFunnelIntroClickAnAnswer(params) {
    return { evid: 522, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroAgencyFormClickSubmit' event (evid: 523)
 *
 * Event description: main funnel intro - user clicked submit in agency form (not necessarily passed validation and moved to next page)
 *
 * @param {mainFunnelIntroAgencyFormClickSubmitParams} params - The parameters for this event
 * @property {string} companyWebsite - user's site url (not on wix)
 * @property {string} sitesBuilt - answer to how many sites the user built
 * @property {string} agencyRole - user's role
 * @return {LogObject<mainFunnelIntroAgencyFormClickSubmitParams>} LogObject<mainFunnelIntroAgencyFormClickSubmitParams>
 */
export function mainFunnelIntroAgencyFormClickSubmit(params) {
    return { evid: 523, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroAgencyThankYouPageClick' event (evid: 524)
 *
 * Event description: main funnel intro - click on "get started" in thank you page (after agency form submitted properly)
 *
 * @param {mainFunnelIntroAgencyThankYouPageClickParams} params - The parameters for this event
 * @return {LogObject<mainFunnelIntroAgencyThankYouPageClickParams>} LogObject<mainFunnelIntroAgencyThankYouPageClickParams>
 */
export function mainFunnelIntroAgencyThankYouPageClick(params) {
    return { evid: 524, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroSubCategorySelected' event (evid: 525)
 *
 * Event description: sub-category selected in main funnel intro
 *
 * @param {mainFunnelIntroSubCategorySelectedParams} params - The parameters for this event
 * @property {string} structureId - structure_id
 * @property {string} screenName - screen name
 * @property {string} industryId - industry_id
 * @property {string} subcat - sub category
 * @property {string} userInfo - current user info from previous selections (json)
 * @property {string} category - category
 * @return {LogObject<mainFunnelIntroSubCategorySelectedParams>} LogObject<mainFunnelIntroSubCategorySelectedParams>
 */
export function mainFunnelIntroSubCategorySelected(params) {
    return { evid: 525, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroSendFormToDb' event (evid: 526)
 *
 * Event description: main funnel intro - fired when form information is being sent to external database and indicates its success
 *
 * @param {mainFunnelIntroSendFormToDbParams} params - The parameters for this event
 * @property {boolean} isCompleted - indicates success
 * @property {string} screenName - the screen in which the button was clicked
 * @property {string} appName - app name
 * @property {string} info - info
 * @return {LogObject<mainFunnelIntroSendFormToDbParams>} LogObject<mainFunnelIntroSendFormToDbParams>
 */
export function mainFunnelIntroSendFormToDb(params) {
    return { evid: 526, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroMultipleAnswers' event (evid: 527)
 *
 * Event description: main intro funnel - multiple answers - users answered a question with multiple answers  (fires when user clicks done/next/submit)
 *
 * @param {mainFunnelIntroMultipleAnswersParams} params - The parameters for this event
 * @property {string} subflow - sub_flow
 * @property {string} user_msid - the real msid of the user
 * @property {string} screen_version - the screen sub type
 * @property {string} initial_data - initial_data
 * @property {string} screenName - screen name containing the question
 * @property {string} payload - payload
 * @property {string} additional_info - additional_info
 * @property {number} pageIndex - The index of the screen
 * @property {string} answer_type - single, multi or typed
 * @property {string} pageId - page_id
 * @property {string} previousScreen - The name of the previous screen in the user flow
 * @property {string} error - fallback error description
 * @property {string} flow - old intro, new intro or new site
 * @property {string} question_name - question name inside the screen
 * @property {string} answer - {true/false} (json)
 * @property {number} position - position
 * @property {string} platform - which platform renders the screen
 * @property {string} previousScreenVersion - The version of the previous screen in the user flow
 * @property {string} action - action
 * @property {string} free_text - free text
 * @return {LogObject<mainFunnelIntroMultipleAnswersParams>} LogObject<mainFunnelIntroMultipleAnswersParams>
 */
export function mainFunnelIntroMultipleAnswers(params) {
    return { evid: 527, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroStoresCallBooked' event (evid: 528)
 *
 * Event description: main funnel intro - user filled out all the information in the form (book a call with a stores expert) and clicked "book call"
 *
 * @param {mainFunnelIntroStoresCallBookedParams} params - The parameters for this event
 * @property {DateTime} scheduledTime - scheduled date and time for the call
 * @property {string} agentEmail - email of the agent that was assigned to this call
 * @return {LogObject<mainFunnelIntroStoresCallBookedParams>} LogObject<mainFunnelIntroStoresCallBookedParams>
 */
export function mainFunnelIntroStoresCallBooked(params) {
    return { evid: 528, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroSubflowStarted' event (evid: 529)
 *
 * Event description: fires when user gets into a subflow in the wix intro. For example, bookings flow.
 *
 * @param {mainFunnelIntroSubflowStartedParams} params - The parameters for this event
 * @property {string} subflow - subflow name
 * @return {LogObject<mainFunnelIntroSubflowStartedParams>} LogObject<mainFunnelIntroSubflowStartedParams>
 */
export function mainFunnelIntroSubflowStarted(params) {
    return { evid: 529, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPagePerformanceTimingClient' event (evid: 53)
 *
 * Event description: Performance timing of segments
 *
 * @param {templatesPagePerformanceTimingClientParams} params - The parameters for this event
 * @property {number} page_index - page_index
 * @property {string} segment_name - Segment name
 * @property {string} context_param - (Optional) Additional info related to segment
 * @property {number} time - Time taken to execute segment
 * @property {string} platform - platform
 * @property {string} product - product
 * @return {LogObject<templatesPagePerformanceTimingClientParams>} LogObject<templatesPagePerformanceTimingClientParams>
 */
export function templatesPagePerformanceTimingClient(params) {
    return { evid: 53, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroFinishSubflow' event (evid: 530)
 *
 * Event description: every time users finishes a subflow in the intro. For example: booking subflow, stores subflow, etc.
 *
 * @param {mainFunnelIntroFinishSubflowParams} params - The parameters for this event
 * @property {string} userInfo - json with answers
 * @property {string} subflow - Name of the subflow: booking for example
 * @return {LogObject<mainFunnelIntroFinishSubflowParams>} LogObject<mainFunnelIntroFinishSubflowParams>
 */
export function mainFunnelIntroFinishSubflow(params) {
    return { evid: 530, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroElegibleForSubflowevent' event (evid: 531)
 *
 * Event description: users is elegible for having a subflow.
 * if its a test then A wont get the new subflow but they are actually elegible.
 * Its helping us to create exposure in wixer.
 *
 * @param {mainFunnelIntroElegibleForSubfloweventParams} params - The parameters for this event
 * @property {string} subflow - subflow
 * @return {LogObject<mainFunnelIntroElegibleForSubfloweventParams>} LogObject<mainFunnelIntroElegibleForSubfloweventParams>
 */
export function mainFunnelIntroElegibleForSubflowevent(params) {
    return { evid: 531, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bookingsExploreAndAppointments' event (evid: 532)
 *
 * Event description: Users who choose exploring in the bookings flow and then selected that they need the feature of appointments online.
 *
 * @param {bookingsExploreAndAppointmentsParams} params - The parameters for this event
 * @return {LogObject<bookingsExploreAndAppointmentsParams>} LogObject<bookingsExploreAndAppointmentsParams>
 */
export function bookingsExploreAndAppointments(params) {
    return { evid: 532, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroAppSuggestionNavigationClick' event (evid: 533)
 *
 * Event description: Event fires when the user clicks either skip or next in the app suggestion screen.
 * It show us which apps remained checked and what was the status of the app when the page was rendered.
 *
 * @param {mainFunnelIntroAppSuggestionNavigationClickParams} params - The parameters for this event
 * @property {string} hotels - true if selected  and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} structureId - structure id chosen in intro before visiting the app screen
 * @property {string} food_orders - true if selected  and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} screen_version - the screen sub type
 * @property {string} screenName - app suggestion main vs segmented flows
 * @property {string} music - true if selected  and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} restaurant_menus - true if selected  and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} table_reservations - true if selected  and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} groups - true if selected  and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} chat - true if selected  and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} subcat - subcategory chosen in intro before visiting the app screen
 * @property {string} stores - true if selected and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} art_store - true if selected  and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} photo_albums - true if selected  and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} blog - true if selected  and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} subscribe_form - true if selected  and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} video - true if selected  and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} flow - intro vs new site
 * @property {string} forum - true if selected  and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} forms - true if selected and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} category - post-reg chosen in intro before visiting the app screen
 * @property {string} nextView - screen after moving forward
 * @property {string} navButton - show is where the user clicked. Skip or Next
 * @property {string} instagram_feed - true if selected  and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} pricing_plans - true if selected  and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} online_scheduling - true if selected  and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} challenges - true if selected and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} events - true if selected  and status when page rendered (default, prechecked, recommend, popular)
 * @property {string} bandsintown - true if selected  and status when page rendered (default, prechecked, recommend, popular)
 * @return {LogObject<mainFunnelIntroAppSuggestionNavigationClickParams>} LogObject<mainFunnelIntroAppSuggestionNavigationClickParams>
 */
export function mainFunnelIntroAppSuggestionNavigationClick(params) {
    return { evid: 533, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickForAClientInWelcomePage' event (evid: 536)
 *
 * Event description: Users clicks for a client cta in the partners welcome page.
 *
 * @param {clickForAClientInWelcomePageParams} params - The parameters for this event
 * @property {string} screen_version - the screen sub type
 * @property {string} screenName - welcome partners
 * @property {string} flow - intro vs new site
 * @return {LogObject<clickForAClientInWelcomePageParams>} LogObject<clickForAClientInWelcomePageParams>
 */
export function clickForAClientInWelcomePage(params) {
    return { evid: 536, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fitnessMainScreenAnswered' event (evid: 537)
 *
 * Event description: event fires when clicking next in the work screen.
 * It records all the answers giving in that page.
 *
 * @param {fitnessMainScreenAnsweredParams} params - The parameters for this event
 * @property {string} services_offered_answer - string with all answers
 * @property {boolean} clientele_trainers - true/false
 * @property {boolean} members_gyms - true/false
 * @property {string} screenName - screen_name
 * @property {boolean} services_offered - true/false
 * @property {string} clientele_members_answer - 1 answer
 * @property {boolean} services_how - true/false
 * @property {string} services_how_answer - 1 answer
 * @property {boolean} multiple_locations - true/false
 * @return {LogObject<fitnessMainScreenAnsweredParams>} LogObject<fitnessMainScreenAnsweredParams>
 */
export function fitnessMainScreenAnswered(params) {
    return { evid: 537, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'typedTextInIntro' event (evid: 538)
 *
 * Event description: Users types an answer in one of the wix intro screens
 *
 * @param {typedTextInIntroParams} params - The parameters for this event
 * @property {string} text - text
 * @property {string} screenName - screen name
 * @return {LogObject<typedTextInIntroParams>} LogObject<typedTextInIntroParams>
 */
export function typedTextInIntro(params) {
    return { evid: 538, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPagination' event (evid: 54)
 *
 * Event description: User browsing through paginations
 *
 * @param {templatesPaginationParams} params - The parameters for this event
 * @property {number} page_index - page_index
 * @property {GUID} tpsi - Templates Page Session ID
 * @property {string} pagination_type - Page Click/Load More Button/Infinite Scroll
 * @property {number} page_clicked_index - Next page's index chosen by user
 * @property {string} category - Templates Page Category
 * @property {string} platform - platform
 * @property {string} product - product
 * @return {LogObject<templatesPaginationParams>} LogObject<templatesPaginationParams>
 */
export function templatesPagination(params) {
    return { evid: 54, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickNeedHelp' event (evid: 541)
 *
 * Event description: fire when the user clicks on the need help button on each screen in the intro
 *
 * @param {clickNeedHelpParams} params - The parameters for this event
 * @property {string} screenName - screen name where users clicked on "need help"
 * @return {LogObject<clickNeedHelpParams>} LogObject<clickNeedHelpParams>
 */
export function clickNeedHelp(params) {
    return { evid: 541, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroGeneralAction' event (evid: 542)
 *
 * Event description: general action on the intro
 *
 * @param {mainFunnelIntroGeneralActionParams} params - The parameters for this event
 * @property {string} user_msid - the real msid of the user
 * @property {string} screen_version - the screen sub type
 * @property {string} screenName - the screen in which the action happened
 * @property {string} payload - payload
 * @property {number} pageIndex - The index of the screen
 * @property {string} targetScreen - The screen that user is targeting to go
 * @property {string} pageId - page_id
 * @property {string} previousScreen - The name of the previous screen in the user flow
 * @property {string} error - fallback error description
 * @property {string} flow - old intro, new intro or new site
 * @property {string} question_name - question_name
 * @property {string} platform - which platform renders the screen
 * @property {string} subFlow - sub_flow
 * @property {string} value - button value
 * @property {string} previousScreenVersion - The version of the previous screen in the user flow
 * @property {string} action - skip, back or any other action
 * @property {string} additional_info - additional_info
 * @return {LogObject<mainFunnelIntroGeneralActionParams>} LogObject<mainFunnelIntroGeneralActionParams>
 */
export function mainFunnelIntroGeneralAction(params) {
    return { evid: 542, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageMainCategoryMenu' event (evid: 55)
 *
 * Event description: Usage of the main category menu
 *
 * @param {templatesPageMainCategoryMenuParams} params - The parameters for this event
 * @property {string} sub_category - Current sub-category performed in
 * @property {string} click_source - header/tags/mobile_menu
 * @property {number} page_index - page_index
 * @property {string} book - CMS book name
 * @property {string} header_type - the type of header (default/sticky) in which the click/hover was performed
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} category_group - Category group (Business & Org, Store, etc.)
 * @property {string} selected_value - (Optional) chosen category
 * @property {string} category - Current main category performed in
 * @property {string} selected_sub_category - (Optional) chosen sub-category
 * @property {string} platform - platform
 * @property {string} action - Open/Close/Select
 * @property {string} product - product
 * @return {LogObject<templatesPageMainCategoryMenuParams>} LogObject<templatesPageMainCategoryMenuParams>
 */
export function templatesPageMainCategoryMenu(params) {
    return { evid: 55, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'topFunnelAppsSelected' event (evid: 550)
 *
 * Event description: Top Funnel - Apps Selected
 *
 * @param {topFunnelAppsSelectedParams} params - The parameters for this event
 * @property {string} app_id_prompt - list of apps id - from prompt
 * @property {string} app_id_hardcoded - list of apps id - from hardcoded
 * @property {string} built_in_app_id - built in apps ids
 * @property {string} uuid - uuid
 * @property {string} flow - flow (intro or new site)
 * @property {string} app_name - list of all apps name
 * @property {string} app_id - list of all apps id
 * @property {GUID} msid - msid
 * @property {string} action - action (next or skip)
 * @return {LogObject<topFunnelAppsSelectedParams>} LogObject<topFunnelAppsSelectedParams>
 */
export function topFunnelAppsSelected(params) {
    return { evid: 550, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageSubCategoryFilter' event (evid: 56)
 *
 * Event description: Usage of the sub-category filter
 *
 * @param {templatesPageSubCategoryFilterParams} params - The parameters for this event
 * @property {string} previous_value - Previous list before the update
 * @property {number} page_index - page_index
 * @property {string} book - CMS book name
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} selected_value - (Optional) Subcategory clicked on
 * @property {string} category - Current main category performed in
 * @property {string} platform - platform
 * @property {string} action - add/remove/clear all
 * @property {string} product - product
 * @return {LogObject<templatesPageSubCategoryFilterParams>} LogObject<templatesPageSubCategoryFilterParams>
 */
export function templatesPageSubCategoryFilter(params) {
    return { evid: 56, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageTemplatesFilterPane' event (evid: 57)
 *
 * Event description: Usage of the templates filter pane
 *
 * @param {templatesPageTemplatesFilterPaneParams} params - The parameters for this event
 * @property {string} previous_value - Previous list before the update
 * @property {number} page_index - page_index
 * @property {string} book - CMS book name
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} selected_value - (Optional) feature/color/layout/style checked or cleared list
 * @property {string} category - Current main category performed in
 * @property {string} platform - platform
 * @property {string} filter_type - feature/color/layout/style (style relevant only for select action)
 * @property {string} action - open/close/hover/select/clear all/show filters/hide filters
 * @property {string} product - product
 * @return {LogObject<templatesPageTemplatesFilterPaneParams>} LogObject<templatesPageTemplatesFilterPaneParams>
 */
export function templatesPageTemplatesFilterPane(params) {
    return { evid: 57, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pageSkippedRandomly' event (evid: 588)
 *
 * Event description: Page Skipped Randomly
 *
 * @param {pageSkippedRandomlyParams} params - The parameters for this event
 * @property {string} screen_version - screen_version
 * @property {string} screenName - screen_name
 * @property {string} flow - flow
 * @property {string} subFlow - sub_flow
 * @return {LogObject<pageSkippedRandomlyParams>} LogObject<pageSkippedRandomlyParams>
 */
export function pageSkippedRandomly(params) {
    return { evid: 588, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'topFunnelFinishFlow' event (evid: 599)
 *
 * Event description: Top Funnel - Finish Flow
 *
 * @param {topFunnelFinishFlowParams} params - The parameters for this event
 * @property {string} screenVersion - screen_version
 * @property {string} structureId - structure_id
 * @property {string} screenName - screen_name
 * @property {string} target_url - target_url
 * @property {string} industryId - industry_id
 * @property {string} businessType - business_type
 * @property {number} pageIndex - The index of the screen
 * @property {string} pageId - page_id
 * @property {string} previousScreen - The name of the previous screen in the user flow
 * @property {string} flow - flow
 * @property {string} subIndustry - sub_industry
 * @property {string} businessTerm - subcat
 * @property {string} answer - answer
 * @property {string} category - category
 * @property {string} subFlow - sub_flow
 * @property {string} previousScreenVersion - The version of the previous screen in the user flow
 * @property {string} mainIndustry - main_industry
 * @property {boolean} isPotentialPartner - is_potential_partner
 * @return {LogObject<topFunnelFinishFlowParams>} LogObject<topFunnelFinishFlowParams>
 */
export function topFunnelFinishFlow(params) {
    return { evid: 599, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'secondSiteIntroScreenView' event (evid: 600)
 *
 * Event description: second site intro - screen view
 *
 * @param {secondSiteIntroScreenViewParams} params - The parameters for this event
 * @property {string} screenName - screen name
 * @property {string} userInfo - current user info from previous selections (json)
 * @return {LogObject<secondSiteIntroScreenViewParams>} LogObject<secondSiteIntroScreenViewParams>
 */
export function secondSiteIntroScreenView(params) {
    return { evid: 600, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'secondSiteIntroClickOnSkip' event (evid: 601)
 *
 * Event description: second site intro - click on "skip"
 *
 * @param {secondSiteIntroClickOnSkipParams} params - The parameters for this event
 * @property {string} screenName - screen name where users clicked on "skip"
 * @return {LogObject<secondSiteIntroClickOnSkipParams>} LogObject<secondSiteIntroClickOnSkipParams>
 */
export function secondSiteIntroClickOnSkip(params) {
    return { evid: 601, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'secondSiteIntroDropdownOpen' event (evid: 602)
 *
 * Event description: main funnel intro - dropdown open
 *
 * @param {secondSiteIntroDropdownOpenParams} params - The parameters for this event
 * @property {string} screenName - screen name
 * @property {string} dropdownName - dropdown name
 * @property {string} trigger - open trigger {user, auto}
 * @return {LogObject<secondSiteIntroDropdownOpenParams>} LogObject<secondSiteIntroDropdownOpenParams>
 */
export function secondSiteIntroDropdownOpen(params) {
    return { evid: 602, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'secondSiteIntroCategorySelected' event (evid: 603)
 *
 * Event description: second site intro - category selected
 *
 * @param {secondSiteIntroCategorySelectedParams} params - The parameters for this event
 * @property {string} category - category
 * @return {LogObject<secondSiteIntroCategorySelectedParams>} LogObject<secondSiteIntroCategorySelectedParams>
 */
export function secondSiteIntroCategorySelected(params) {
    return { evid: 603, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'secondSiteIntroAdiEditorSelected' event (evid: 604)
 *
 * Event description: second site intro - adi/editor selected
 *
 * @param {secondSiteIntroAdiEditorSelectedParams} params - The parameters for this event
 * @property {string} platform - adi / editor
 * @return {LogObject<secondSiteIntroAdiEditorSelectedParams>} LogObject<secondSiteIntroAdiEditorSelectedParams>
 */
export function secondSiteIntroAdiEditorSelected(params) {
    return { evid: 604, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'secondSiteIntroFinish' event (evid: 605)
 *
 * Event description: second site intro - finish.
 * platform is null (question was not displayed) if category was non-ADI.
 *
 * @param {secondSiteIntroFinishParams} params - The parameters for this event
 * @property {string} category - category
 * @property {string} platform - adi / editor
 * @property {string} trigger - trigger {user, auto}
 * @return {LogObject<secondSiteIntroFinishParams>} LogObject<secondSiteIntroFinishParams>
 */
export function secondSiteIntroFinish(params) {
    return { evid: 605, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesWidgetAboveTheFoldImpression' event (evid: 61)
 *
 * Event description: When a user has the Templates Page widget above the fold
 *
 * @param {templatesWidgetAboveTheFoldImpressionParams} params - The parameters for this event
 * @property {string} sub_category - List of subcategory filters
 * @property {number} page_index - page_index
 * @property {string} widget_name - The vertical presented in the Widget (Blog, Online Store, etc.)
 * @property {string} book - book
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {number} screen_width - Width of client device screen
 * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
 * @property {number} window_width - Initial width of client window
 * @property {number} screen_height - Height of client device screen
 * @property {string} category - Main category name
 * @property {number} window_height - Initial height of client window
 * @property {string} platform - platform
 * @property {number} avail_height - Returns the amount of horizontal space in pixels vertical to the window
 * @property {string} product - product
 * @return {LogObject<templatesWidgetAboveTheFoldImpressionParams>} LogObject<templatesWidgetAboveTheFoldImpressionParams>
 */
export function templatesWidgetAboveTheFoldImpression(params) {
    return { evid: 61, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteBriefSiteBriefActionsClickSrc2Evid612' event (evid: 612)
 *
 * Event description: Site Brief - Actions Click
 *
 * @param {siteBriefSiteBriefActionsClickSrc2Evid612Params} params - The parameters for this event
 * @property {string} screenName - screen name
 * @property {string} screenVersion - screen version
 * @property {string} location - mockup, review
 * @property {string} value - value of object
 * @property {string} flow - main_intro_allinone, new_site_allinone
 * @property {string} msid - msid
 * @property {string} buttonName - buttonName
 * @return {LogObject<siteBriefSiteBriefActionsClickSrc2Evid612Params>} LogObject<siteBriefSiteBriefActionsClickSrc2Evid612Params>
 */
export function siteBriefSiteBriefActionsClickSrc2Evid612(params) {
    return { evid: 612, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteBriefHoverInSiteBriefSrc2Evid614' event (evid: 614)
 *
 * Event description: Site Brief - Hover in Site Brief
 *
 * @param {siteBriefHoverInSiteBriefSrc2Evid614Params} params - The parameters for this event
 * @property {string} objectType - object type
 * @property {string} screenName - screen name
 * @property {string} screenVersion - screen version
 * @property {string} flow - main_intro_allinone, new_site_allinone
 * @property {string} value - value shown in hover
 * @property {number} hoverTime - hover time (Milliseconds)
 * @return {LogObject<siteBriefHoverInSiteBriefSrc2Evid614Params>} LogObject<siteBriefHoverInSiteBriefSrc2Evid614Params>
 */
export function siteBriefHoverInSiteBriefSrc2Evid614(params) {
    return { evid: 614, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteBriefInfoShownSrc2Evid615' event (evid: 615)
 *
 * Event description: Site Brief Info Shown
 *
 * @param {siteBriefInfoShownSrc2Evid615Params} params - The parameters for this event
 * @property {string} screenName - screen name
 * @property {string} screenVersion - sceren version
 * @property {boolean} isDisplayed - for future use
 * @property {string} objectType - type of object shown
 * @property {string} flow - main_intro_allinone, new_site_allinone
 * @property {string} msid - msid
 * @property {string} value - content of the object
 * @property {string} location - site brief, mockup
 * @return {LogObject<siteBriefInfoShownSrc2Evid615Params>} LogObject<siteBriefInfoShownSrc2Evid615Params>
 */
export function siteBriefInfoShownSrc2Evid615(params) {
    return { evid: 615, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteBriefInfoClickSrc2Evid616' event (evid: 616)
 *
 * Event description: Site Brief - Info Click
 *
 * @param {siteBriefInfoClickSrc2Evid616Params} params - The parameters for this event
 * @property {string} screenName - screen name
 * @property {string} screenVersion - sceren version
 * @property {boolean} isDisplayed - for future use
 * @property {string} objectType - type of object shown
 * @property {string} flow - main_intro_allinone, new_site_allinone
 * @property {string} msid - msid
 * @property {string} value - content of the object
 * @property {string} location - site brief, mockup
 * @return {LogObject<siteBriefInfoClickSrc2Evid616Params>} LogObject<siteBriefInfoClickSrc2Evid616Params>
 */
export function siteBriefInfoClickSrc2Evid616(params) {
    return { evid: 616, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteBriefModalOpenedSrc2Evid617' event (evid: 617)
 *
 * Event description: Site Brief - Modal opened
 *
 * @param {siteBriefModalOpenedSrc2Evid617Params} params - The parameters for this event
 * @property {string} screenName - screen_name
 * @property {string} flow - flow
 * @property {string} modal_name - modal_name
 * @property {string} modal_version_name - modal_version_name
 * @property {string} profileId - the Id of the user session
 * @property {string} content - content of modal
 * @property {string} screenVersion - screen version
 * @property {string} location - site brief, mockup
 * @return {LogObject<siteBriefModalOpenedSrc2Evid617Params>} LogObject<siteBriefModalOpenedSrc2Evid617Params>
 */
export function siteBriefModalOpenedSrc2Evid617(params) {
    return { evid: 617, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteBriefAnyClickInModalSrc2Evid618' event (evid: 618)
 *
 * Event description: Site Brief - Any click in Modal
 *
 * @param {siteBriefAnyClickInModalSrc2Evid618Params} params - The parameters for this event
 * @property {string} button_name - button_name, e.g. close/done/slide
 * @property {string} modal_version_name - modal_version_name
 * @property {string} modal_name - modal_name
 * @property {string} screenName - screen_name
 * @property {string} flow - flow
 * @property {string} profileId - the Id of the user session
 * @property {string} screenVersion - screen version
 * @property {string} location - site brief, mockup
 * @property {string} action - skip, check, uncheck
 * @return {LogObject<siteBriefAnyClickInModalSrc2Evid618Params>} LogObject<siteBriefAnyClickInModalSrc2Evid618Params>
 */
export function siteBriefAnyClickInModalSrc2Evid618(params) {
    return { evid: 618, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteBriefModalAnswerCopySrc2Evid619' event (evid: 619)
 *
 * Event description: Site Brief - Modal answer
 *
 * @param {siteBriefModalAnswerCopySrc2Evid619Params} params - The parameters for this event
 * @property {string} button_name - button_name, e.g. close/done/slide
 * @property {string} modal_version_name - modal_version_name
 * @property {string} modal_name - modal_name
 * @property {string} screenName - screen_name
 * @property {string} flow - flow
 * @property {string} answer - answer
 * @property {string} profileId - the Id of the user session
 * @property {string} screenVersion - screen version
 * @property {string} location - site brief, mockup
 * @return {LogObject<siteBriefModalAnswerCopySrc2Evid619Params>} LogObject<siteBriefModalAnswerCopySrc2Evid619Params>
 */
export function siteBriefModalAnswerCopySrc2Evid619(params) {
    return { evid: 619, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesWidgetActions' event (evid: 62)
 *
 * Event description: User engagement with the Templates Page widget
 *
 * @param {templatesWidgetActionsParams} params - The parameters for this event
 * @property {string} sub_category - List of subcategory filters
 * @property {number} tool_index - (optional)  Tool index number (1..4)
 * @property {number} page_index - page_index
 * @property {string} widget_name - The vertical presented in the Widget (Blog, Online Store, etc.)
 * @property {string} book - book
 * @property {string} clicked_element - Clicked Element: Thumbnail, Title, etc.
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {number} screen_width - Width of client device screen
 * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
 * @property {number} window_width - Initial width of client window
 * @property {number} tool_index_selected - (optional) Tool number to be presented
 * @property {number} screen_height - Height of client device screen
 * @property {string} category - Main category name
 * @property {number} window_height - Initial height of client window
 * @property {string} platform - platform
 * @property {number} avail_height - Returns the amount of horizontal space in pixels vertical to the window
 * @property {string} product - product
 * @return {LogObject<templatesWidgetActionsParams>} LogObject<templatesWidgetActionsParams>
 */
export function templatesWidgetActions(params) {
    return { evid: 62, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mockupLoadedSrc2Evid620' event (evid: 620)
 *
 * Event description: Mockup finished loading
 *
 * @param {mockupLoadedSrc2Evid620Params} params - The parameters for this event
 * @property {string} flow - flow
 * @property {string} screenName - screen name
 * @property {string} screen_version - screen version
 * @property {number} loadingTime - time to fully loaded
 * @return {LogObject<mockupLoadedSrc2Evid620Params>} LogObject<mockupLoadedSrc2Evid620Params>
 */
export function mockupLoadedSrc2Evid620(params) {
    return { evid: 620, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mockupStartLoadingSrc2Evid621' event (evid: 621)
 *
 * Event description: Mockup start loading - can occur on several different pages
 *
 * @param {mockupStartLoadingSrc2Evid621Params} params - The parameters for this event
 * @property {string} flow - flow
 * @property {string} screenName - screen name
 * @property {string} screen_version - screen version
 * @return {LogObject<mockupStartLoadingSrc2Evid621Params>} LogObject<mockupStartLoadingSrc2Evid621Params>
 */
export function mockupStartLoadingSrc2Evid621(params) {
    return { evid: 621, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesVideoPreviewOpen' event (evid: 65)
 *
 * Event description: user clicked on a thumbnail with a video which opened the preview pop up
 *
 * @param {templatesVideoPreviewOpenParams} params - The parameters for this event
 * @property {boolean} is_search_result - Is result from suggestion ("like you")
 * @property {number} search_rank - External ("like you") suggestion ranking
 * @property {string} sub_category - List of subcategory filters
 * @property {number} total_search_results - total search results from external ("like you") search suggestion
 * @property {number} page_index - page_index
 * @property {string} book - book
 * @property {string} features - list of selected features
 * @property {number} gallerydocsperpage - gallery docs per page
 * @property {string} styles - list of selected styles
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} layouts - list of selected layouts
 * @property {number} screen_width - Width of client device screen
 * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
 * @property {string} colors - list of selected colors
 * @property {GUID} search_guid - (optional) If from search results, GUID of matching search
 * @property {number} window_width - Initial width of client window
 * @property {string} sorting - selected sorting
 * @property {string} screen_type - the type of page in which the action was performed: category / search_results / main / home
 * @property {number} screen_height - Height of client device screen
 * @property {string} category - the create page category
 * @property {number} window_height - Initial height of client window
 * @property {string} platform - platform
 * @property {GUID} openingSiteID - template_id
 * @property {number} avail_height - Returns the amount of vertical space in pixels available to the window
 * @property {string} product - product
 * @return {LogObject<templatesVideoPreviewOpenParams>} LogObject<templatesVideoPreviewOpenParams>
 */
export function templatesVideoPreviewOpen(params) {
    return { evid: 65, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'secondSiteIntroFullStoryStartSession' event (evid: 650)
 *
 * Event description: second site intro - FullStory start session
 *
 * @param {secondSiteIntroFullStoryStartSessionParams} params - The parameters for this event
 * @property {Url} fullstoryurl - FullStory recording URL
 * @return {LogObject<secondSiteIntroFullStoryStartSessionParams>} LogObject<secondSiteIntroFullStoryStartSessionParams>
 */
export function secondSiteIntroFullStoryStartSession(params) {
    return { evid: 650, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesCloseVideoPreview' event (evid: 69)
 *
 * Event description: user clicked on 'x' to close the video preview pop up or just moved out of the thumbnail
 *
 * @param {templatesCloseVideoPreviewParams} params - The parameters for this event
 * @property {boolean} is_search_result - Is result from suggestion ("like you")
 * @property {number} search_rank - External ("like you") suggestion ranking
 * @property {string} sub_category - List of subcategory filters
 * @property {number} total_search_results - total search results from external ("like you") search suggestion
 * @property {number} page_index - page_index
 * @property {string} book - book
 * @property {string} features - list of selected features
 * @property {number} gallerydocsperpage - gallery docs per page
 * @property {string} styles - list of selected styles
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} layouts - list of selected layouts
 * @property {number} screen_width - Width of client device screen
 * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
 * @property {number} video_full_duration - video_full_duration
 * @property {string} colors - list of selected colors
 * @property {GUID} search_guid - (optional) If from search results, GUID of matching search
 * @property {number} window_width - Initial width of client window
 * @property {string} sorting - selected sorting
 * @property {DateTime} video_end_time - video end time
 * @property {string} screen_type - the type of page in which the action was performed: category / search_results / main / home
 * @property {number} screen_height - Height of client device screen
 * @property {string} category - the create page category
 * @property {string} video_status - 'have_nothing', 'have_metadata', 'have_current_data', 'have_future_data', 'have_enough_data'
 * @property {number} window_height - Initial height of client window
 * @property {string} platform - platform
 * @property {DateTime} video_start_time - video start time
 * @property {number} video_playback_position - video_playback_position
 * @property {GUID} openingSiteID - template_id
 * @property {number} avail_height - Returns the amount of vertical space in pixels available to the window
 * @property {string} product - product
 * @return {LogObject<templatesCloseVideoPreviewParams>} LogObject<templatesCloseVideoPreviewParams>
 */
export function templatesCloseVideoPreview(params) {
    return { evid: 69, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantBusinessProfileView' event (evid: 700)
 *
 * Event description: AI Assistant - Business Profile View
 *
 * @param {aiAssistantBusinessProfileViewParams} params - The parameters for this event
 * @property {string} screenVersion - screen_version
 * @property {string} screenName - screen_name
 * @property {string} pageId - page_id
 * @property {string} flow - flow_name
 * @return {LogObject<aiAssistantBusinessProfileViewParams>} LogObject<aiAssistantBusinessProfileViewParams>
 */
export function aiAssistantBusinessProfileView(params) {
    return { evid: 700, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantContentShownOnBusinessProfile' event (evid: 701)
 *
 * Event description: AI Assistant - Site Profile Extractions, either they were presented to the user or not.
 *
 * @param {aiAssistantContentShownOnBusinessProfileParams} params - The parameters for this event
 * @property {string} screen_version - screen version
 * @property {boolean} is_displayed - true= content shown, false= content set but not shown
 * @property {string} screenName - screen name
 * @property {string} modifyed_by - if the data was modified by the Chat or the User edited it
 * @property {string} objectType - which object is presented to the user
 * @property {string} flow - flow
 * @property {GUID} msid - msid
 * @property {string} value - the content presented in this object
 * @property {number} order_index - order of the object in the business profile
 * @return {LogObject<aiAssistantContentShownOnBusinessProfileParams>} LogObject<aiAssistantContentShownOnBusinessProfileParams>
 */
export function aiAssistantContentShownOnBusinessProfile(params) {
    return { evid: 701, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantClickOnEdit' event (evid: 702)
 *
 * Event description: AI Assistant - Click in Site Profile
 *
 * @param {aiAssistantClickOnEditParams} params - The parameters for this event
 * @property {string} screen_version - screen version
 * @property {string} screenName - screen name
 * @property {string} objectType - object type
 * @property {string} flow - flow
 * @property {string} currentValue - current value
 * @property {GUID} msid - msid
 * @property {number} order_index - order index
 * @property {string} click_type - view, edit
 * @return {LogObject<aiAssistantClickOnEditParams>} LogObject<aiAssistantClickOnEditParams>
 */
export function aiAssistantClickOnEdit(params) {
    return { evid: 702, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantEditClicksInBusinessProfile' event (evid: 703)
 *
 * Event description: AI Assistant - Edit Clicks in Business Profile
 *
 * @param {aiAssistantEditClicksInBusinessProfileParams} params - The parameters for this event
 * @property {string} screen_version - screen version
 * @property {string} screenName - screen name
 * @property {string} clickType - click type - cancel/done/typing console/open dropdown/ in dropdown/etc.
 * @property {string} objectType - object type
 * @property {string} flow - flow
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @property {number} order_index - order index
 * @return {LogObject<aiAssistantEditClicksInBusinessProfileParams>} LogObject<aiAssistantEditClicksInBusinessProfileParams>
 */
export function aiAssistantEditClicksInBusinessProfile(params) {
    return { evid: 703, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantHoverInSiteProfile' event (evid: 704)
 *
 * Event description: AI Assistant - Hover in Site Profile
 *
 * @param {aiAssistantHoverInSiteProfileParams} params - The parameters for this event
 * @property {string} screen_version - screen version
 * @property {string} screenName - screen name
 * @property {string} hover_type - Information, Hover on Text, Edit
 * @property {number} hoverTime - hover time (Milliseconds)
 * @property {string} objectType - object type
 * @property {string} flow - flow
 * @property {string} currentValue - current value
 * @property {GUID} msid - msid
 * @property {number} order_index - order index
 * @return {LogObject<aiAssistantHoverInSiteProfileParams>} LogObject<aiAssistantHoverInSiteProfileParams>
 */
export function aiAssistantHoverInSiteProfile(params) {
    return { evid: 704, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myAccountEditSite' event (evid: 71)
 *
 * Event description: my account -> Edit site.
 *
 * @param {myAccountEditSiteParams} params - The parameters for this event
 * @property {GUID} site_id - site id
 * @property {string} view_type - view_type
 * @property {string} ds_origin - adi/editor
 * @property {string} origin - msid if was inside a site dashboard, 'my-sites' if was in my-sites page
 * @property {string} place - button/left-nav/my-sites
 * @property {number} site_type_enriched - site_type
 * @property {GUID} esi -  the editing session guid
 * @property {string} platform - platform
 * @property {string} hosting - hosting
 * @property {GUID} msid - msid
 * @return {LogObject<myAccountEditSiteParams>} LogObject<myAccountEditSiteParams>
 */
export function myAccountEditSite(params) {
    return { evid: 71, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantChatContentViewSrc2Evid710' event (evid: 710)
 *
 * Event description: User saw content in AI Assistant Chat
 *
 * @param {aiAssistantChatContentViewSrc2Evid710Params} params - The parameters for this event
 * @property {string} screen_version - screen version
 * @property {string} provider - either by chat or user
 * @property {string} screenName - screen name
 * @property {string} contentSection - the specific section in the chat
 * @property {string} contentVersion - the version of the hardcoded widget
 * @property {string} contentType - what form of content the message includes - text, button, component, etc
 * @property {string} keepers - which keepers triggered the message
 * @property {string} flow - flow
 * @property {string} content - the content of the message in chat
 * @property {GUID} msid - msid
 * @property {number} order_index - message order index in chat
 * @property {string} initial_data - initial data
 * @return {LogObject<aiAssistantChatContentViewSrc2Evid710Params>} LogObject<aiAssistantChatContentViewSrc2Evid710Params>
 */
export function aiAssistantChatContentViewSrc2Evid710(params) {
    return { evid: 710, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantActionInTypingConsole' event (evid: 711)
 *
 * Event description: General actions the user did in the AI Assistant chat
 *
 * @param {aiAssistantActionInTypingConsoleParams} params - The parameters for this event
 * @property {string} screen_version - screen version
 * @property {string} screenName - screen name
 * @property {boolean} clicked_send - user clicked enter in keyboard or the "button". true if button and false if keyboard. only for cases when the action is answer
 * @property {string} flow - flow
 * @property {GUID} msid - msid
 * @property {string} questionContent - the content of the question before the action
 * @property {string} value - the answer that the user typed
 * @property {string} action - action in chat
 * @return {LogObject<aiAssistantActionInTypingConsoleParams>} LogObject<aiAssistantActionInTypingConsoleParams>
 */
export function aiAssistantActionInTypingConsole(params) {
    return { evid: 711, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantGeneralClicksInChatContent' event (evid: 712)
 *
 * Event description: Any click within the content.
 * For example: clicks on widgets
 *
 * @param {aiAssistantGeneralClicksInChatContentParams} params - The parameters for this event
 * @property {string} screenVersion - screen version
 * @property {string} screenName - screen name
 * @property {boolean} isAnswer - for example: done message or continue
 * @property {string} contentSection - content's section
 * @property {string} contentVersion - the version of the hardcoded widget
 * @property {string} contentType - what form of content the message includes - text, button, component, etc
 * @property {string} flow - flow
 * @property {string} content - widget's name - for example: Bookings working hours
 * @property {number} orderIndex - message order index in chat
 * @property {string} answer - the answer in the widget
 * @property {string} buttonName - the name of the button the user clicked on
 * @property {GUID} msid - msid
 * @return {LogObject<aiAssistantGeneralClicksInChatContentParams>} LogObject<aiAssistantGeneralClicksInChatContentParams>
 */
export function aiAssistantGeneralClicksInChatContent(params) {
    return { evid: 712, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myAccountViewSite' event (evid: 72)
 *
 * Event description: my account -> View site.
 *
 * @param {myAccountViewSiteParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @return {LogObject<myAccountViewSiteParams>} LogObject<myAccountViewSiteParams>
 */
export function myAccountViewSite(params) {
    return { evid: 72, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantStartDemoDataInjectionAttempt' event (evid: 720)
 *
 * Event description: Attempt for injecting demo data with app
 *
 * @param {aiAssistantStartDemoDataInjectionAttemptParams} params - The parameters for this event
 * @property {string} request_id - request id
 * @property {string} app_id - which app we inject demo data to
 * @property {GUID} msid - msid
 * @return {LogObject<aiAssistantStartDemoDataInjectionAttemptParams>} LogObject<aiAssistantStartDemoDataInjectionAttemptParams>
 */
export function aiAssistantStartDemoDataInjectionAttempt(params) {
    return { evid: 720, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantFailedDemoDataInjectionAttempt' event (evid: 728)
 *
 * Event description: AI Assistant - Failed Demo Data Injection Attempt
 *
 *
 * @param {aiAssistantFailedDemoDataInjectionAttemptParams} params - The parameters for this event
 * @property {string} app_id - app we injected demo data into
 * @property {number} work_time - time from request start to completion in ms
 * @property {string} request_id - request id
 * @property {string} failure_reason - why the attempt failed
 * @property {GUID} msid - metasite id
 * @return {LogObject<aiAssistantFailedDemoDataInjectionAttemptParams>} LogObject<aiAssistantFailedDemoDataInjectionAttemptParams>
 */
export function aiAssistantFailedDemoDataInjectionAttempt(params) {
    return { evid: 728, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantCompletedDemoDataInjectionAttempt' event (evid: 729)
 *
 * Event description: AI Assistant - Completed Demo Data Injection Attempt
 *
 * @param {aiAssistantCompletedDemoDataInjectionAttemptParams} params - The parameters for this event
 * @property {number} work_time - time from request start to completion in ms
 * @property {string} app_id - app we injected demo data into
 * @property {string} service_id - service_id
 * @property {GUID} msid - metasite id
 * @property {string} request_id - request_id
 * @return {LogObject<aiAssistantCompletedDemoDataInjectionAttemptParams>} LogObject<aiAssistantCompletedDemoDataInjectionAttemptParams>
 */
export function aiAssistantCompletedDemoDataInjectionAttempt(params) {
    return { evid: 729, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantAssetShownOnDashboardSrc2Evid730' event (evid: 730)
 *
 * Event description: AI Assistant - Asset Shown On Dashboard
 *
 * @param {aiAssistantAssetShownOnDashboardSrc2Evid730Params} params - The parameters for this event
 * @property {string} asset_id - on which asset the click was
 * @property {string} section - location of the asset
 * @property {GUID} msid - msid
 * @return {LogObject<aiAssistantAssetShownOnDashboardSrc2Evid730Params>} LogObject<aiAssistantAssetShownOnDashboardSrc2Evid730Params>
 */
export function aiAssistantAssetShownOnDashboardSrc2Evid730(params) {
    return { evid: 730, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantAnyClickInDashboard' event (evid: 731)
 *
 * Event description: AI Assistant - Clicks in Dashboard
 *
 * @param {aiAssistantAnyClickInDashboardParams} params - The parameters for this event
 * @property {string} asset_id - on which asset the click was
 * @property {string} button_name - close/open/lets go/etc
 * @return {LogObject<aiAssistantAnyClickInDashboardParams>} LogObject<aiAssistantAnyClickInDashboardParams>
 */
export function aiAssistantAnyClickInDashboard(params) {
    return { evid: 731, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantScrollActionInChat' event (evid: 732)
 *
 * Event description: Scroll in Chat (for Chat on Mobile).
 * Only "meaningful" scrolls - i.e. till the next Chat Item (answer) is fully visible.
 *
 * @param {aiAssistantScrollActionInChatParams} params - The parameters for this event
 * @property {string} screen_version - screen version
 * @property {string} screenName - screen name
 * @property {string} flow - flow
 * @property {string} targetValue - Chat Item - destination where the scroll finished
 * @property {GUID} msid - msid
 * @property {string} action - scroll up/scroll down
 * @return {LogObject<aiAssistantScrollActionInChatParams>} LogObject<aiAssistantScrollActionInChatParams>
 */
export function aiAssistantScrollActionInChat(params) {
    return { evid: 732, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantSwipeActionInChat' event (evid: 733)
 *
 * Event description: Swipe in Chat (for Chat on Mobile).
 * Only "meaningful" swipes - i.e. till the next Button is fully visible.
 *
 * @param {aiAssistantSwipeActionInChatParams} params - The parameters for this event
 * @property {string} screen_version - screen version
 * @property {string} screenName - screen name
 * @property {string} flow - flow
 * @property {string} targetValue - button name - destination where the swipe finished
 * @property {GUID} msid - msid
 * @property {string} action - swipe
 * @return {LogObject<aiAssistantSwipeActionInChatParams>} LogObject<aiAssistantSwipeActionInChatParams>
 */
export function aiAssistantSwipeActionInChat(params) {
    return { evid: 733, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dropshippingOnboardingScreenView' event (evid: 7501)
 *
 * Event description: This event creates a draft msid when the users clicks on  edit a template.
 * It will let us use site profile fields in the period between open and save in the editor.
 * It will contain information such as template id, and app_ids of apps selected in the app suggestion.
 *
 * @param {dropshippingOnboardingScreenViewParams} params - The parameters for this event
 * @property {string} referralInfo - referral_info from intro
 * @property {string} insights_summary - user's insight summary from ai assistant
 * @property {GUID} uuid - uuid
 * @property {string} additional_info - additional_info
 * @property {string} origin - origin of the msid creation.
 * @property {string} flow - flow
 * @property {string} businessTerm - business_term
 * @property {string} app_id - app ids chosen contained in a string
 * @property {GUID} esi - editor session id
 * @property {string} platform - Wix vs EdiX
 * @property {GUID} msid - msid
 * @property {GUID} template_id - template id
 * @property {GUID} duplicated_msid - the msid we are duplicating if it's relevant
 * @property {string} metasite_namespace - in what namespace we create a site for User
 * @return {LogObject<dropshippingOnboardingScreenViewParams>} LogObject<dropshippingOnboardingScreenViewParams>
 */
export function dropshippingOnboardingScreenView(params) {
    return { evid: 7501, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dropshippingOnboardingClickAnAnswer' event (evid: 7502)
 *
 * Event description: Events fired in the backend when user clicks edit template in the gallery.
 * It helps tot rack performance
 *
 * @param {dropshippingOnboardingClickAnAnswerParams} params - The parameters for this event
 * @property {GUID} esi - esi
 * @property {string} platform - platform
 * @property {string} template_id - guid
 * @return {LogObject<dropshippingOnboardingClickAnAnswerParams>} LogObject<dropshippingOnboardingClickAnAnswerParams>
 */
export function dropshippingOnboardingClickAnAnswer(params) {
    return { evid: 7502, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesGenericPageView' event (evid: 78)
 *
 * Event description: page load - templates page domain
 *
 * @param {templatesGenericPageViewParams} params - The parameters for this event
 * @property {boolean} is_search_result - Is result from suggestion ("like you")
 * @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
 * @property {number} search_rank - External ("like you") suggestion ranking
 * @property {string} sub_category - List of subcategory filters
 * @property {number} total_search_results - total search results from external ("like you") search suggestion
 * @property {number} page_index - page_index
 * @property {string} criteria - search term used in search
 * @property {string} features - list of selected features
 * @property {number} gallerydocsperpage - number of templates presented on the page
 * @property {string} styles - list of selected styles
 * @property {string} previous_url - previous URL (referrer)
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} layouts - list of selected layouts
 * @property {number} screen_width - Width of client device screen
 * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
 * @property {string} colors - list of selected colors
 * @property {GUID} search_guid - If from search results, GUID of matching search
 * @property {number} window_width - Initial width of client window
 * @property {string} sorting - selected sorting
 * @property {string} origin - intro / new site / organic
 * @property {string} screen_type - category / search_results / main / home
 * @property {number} screen_height - Height of client device screen
 * @property {string} category - the create page category
 * @property {number} window_height - Initial height of client window
 * @property {string} platform - platform
 * @property {string} eventData - json with template list: returns the number of templates on the page that was loaded
 * @property {number} avail_height - Returns the amount of horizontal space in pixels vertical to the window
 * @property {number} page_number - page number
 * @property {string} product - product
 * @return {LogObject<templatesGenericPageViewParams>} LogObject<templatesGenericPageViewParams>
 */
export function templatesGenericPageView(params) {
    return { evid: 78, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesWidgetLoaded' event (evid: 79)
 *
 * Event description: Widget was loaded (not necessarily viewed)
 *
 * @param {templatesWidgetLoadedParams} params - The parameters for this event
 * @property {string} sub_category - List of subcategory filters
 * @property {number} page_index - page_index
 * @property {string} widget_name - The vertical presented in the Widget (Blog, Online Store, etc.)
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {number} screen_width - Width of client device screen
 * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
 * @property {number} window_width - Initial width of client window
 * @property {number} screen_height - Height of client device screen
 * @property {string} category - Main category name
 * @property {number} window_height - Initial height of client window
 * @property {string} platform - platform
 * @property {number} avail_height - Returns the amount of horizontal space in pixels vertical to the window
 * @property {string} product - product
 * @return {LogObject<templatesWidgetLoadedParams>} LogObject<templatesWidgetLoadedParams>
 */
export function templatesWidgetLoaded(params) {
    return { evid: 79, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc2Evid796' event (evid: 796)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc2Evid796Params} params - The parameters for this event
 * @return {LogObject<dummyNameSrc2Evid796Params>} LogObject<dummyNameSrc2Evid796Params>
 */
export function dummyNameSrc2Evid796(params) {
    return { evid: 796, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantOpenaiCall' event (evid: 797)
 *
 * Event description: AI Assistant - Prompt Usage
 *
 * @param {aiAssistantOpenaiCallParams} params - The parameters for this event
 * @property {number} duration - milliseconds between start and finish of generation request to ai gateway
 * @property {boolean} isFallback - is_fallback
 * @property {string} inputText - input to prompt
 * @property {boolean} isError - is_error
 * @property {string} promptId - prompt id
 * @property {string} vendorId - vendorID of the call
 * @property {number} orderIndex - message order index in chat that was the last one in the chat in this prompt
 * @property {string} outputText - output from prompt
 * @property {GUID} msid - msid
 * @property {string} projectId - the prompt's prorject
 * @return {LogObject<aiAssistantOpenaiCallParams>} LogObject<aiAssistantOpenaiCallParams>
 */
export function aiAssistantOpenaiCall(params) {
    return { evid: 797, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesHoverOnWidget' event (evid: 80)
 *
 * Event description: Hover on the widget
 *
 * @param {templatesHoverOnWidgetParams} params - The parameters for this event
 * @property {string} sub_category - List of subcategory filters
 * @property {number} page_index - page_index
 * @property {string} widget_name - The vertical presented in the Widget (Blog, Online Store, etc.)
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {number} screen_width - Width of client device screen
 * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
 * @property {number} hover_ms - hover duration in milliseconds
 * @property {number} window_width - Initial width of client window
 * @property {number} screen_height - Height of client device screen
 * @property {string} category - Main category name
 * @property {number} window_height - Initial height of client window
 * @property {string} platform - platform
 * @property {number} avail_height - Returns the amount of horizontal space in pixels vertical to the window
 * @property {string} product - product
 * @return {LogObject<templatesHoverOnWidgetParams>} LogObject<templatesHoverOnWidgetParams>
 */
export function templatesHoverOnWidget(params) {
    return { evid: 80, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'selectAnswer' event (evid: 801)
 *
 * Event description: Users selects an answer (not necessarily the final answer)
 *
 * @param {selectAnswerParams} params - The parameters for this event
 * @property {boolean} suggested_option - suggested_option
 * @property {string} screen_name - screen_name
 * @property {string} screen_version - screen_version
 * @property {string} flow - flow
 * @property {string} answer_name - answer name
 * @property {string} question_name - question_name
 * @property {string} platform - wix vs editorx
 * @return {LogObject<selectAnswerParams>} LogObject<selectAnswerParams>
 */
export function selectAnswer(params) {
    return { evid: 801, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitAnswer2QuestionsPage' event (evid: 802)
 *
 * Event description: Submit Answer - 2 questions page.
 *
 * @param {submitAnswer2QuestionsPageParams} params - The parameters for this event
 * @property {string} answer_1 - answer on top question
 * @property {string} screen_name - screen_name
 * @property {string} question_1 - question on top
 * @property {string} text - text the user wrote in case he choose other
 * @property {string} question_2 - second question
 * @property {string} flow - flow
 * @property {string} answer_2 - answer of second question
 * @property {string} platform - wix or edix
 * @return {LogObject<submitAnswer2QuestionsPageParams>} LogObject<submitAnswer2QuestionsPageParams>
 */
export function submitAnswer2QuestionsPage(params) {
    return { evid: 802, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'generalAction' event (evid: 803)
 *
 * Event description: Extra actions done by the user. For example: go to library, open video, etc.
 *
 * @param {generalActionParams} params - The parameters for this event
 * @property {string} screen_name - screen_name
 * @property {string} screen_version - screen version
 * @property {string} tab_name - the type of mode the user is at when doing the action {all, wireframes, templets}
 * @property {string} flow - flow
 * @property {string} platform - wix or editorx
 * @property {string} action - action
 * @return {LogObject<generalActionParams>} LogObject<generalActionParams>
 */
export function generalAction(params) {
    return { evid: 803, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesAction' event (evid: 804)
 *
 * Event description: Action in the templates: click, view, hover.
 *
 * @param {templatesActionParams} params - The parameters for this event
 * @property {string} screen_name - screen_name
 * @property {string} screen_version - screen version
 * @property {string} tab_name - templates, wireframes, all
 * @property {number} rank - The template's order. Begins with 1. rank = 0 stands for 'start creating' which leads to a blank template
 * @property {number} screen_width - screen width
 * @property {number} hover_ms - hover time in ms
 * @property {string} origin - the page from which the user was redirected to the current page
 * @property {string} flow - flow
 * @property {number} screen_height - screen height
 * @property {GUID} esi - expressions page esi (original_esi in editorx events)
 * @property {string} platform - wix or edix
 * @property {string} action - hover, edit, view, impression (above the fold)
 * @property {GUID} template_id - template guid
 * @return {LogObject<templatesActionParams>} LogObject<templatesActionParams>
 */
export function templatesAction(params) {
    return { evid: 804, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newEvent' event (evid: 805)
 *
 * Event description: any screen view
 *
 * @param {newEventParams} params - The parameters for this event
 * @property {string} screen_name - screen_name
 * @property {string} screen_version - screen version
 * @property {string} screen_resolution - screen_resolution
 * @property {string} ref - entry point
 * @property {string} flow - flow
 * @property {string} platform - wix vs edix
 * @return {LogObject<newEventParams>} LogObject<newEventParams>
 */
export function newEvent(params) {
    return { evid: 805, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'typeIn' event (evid: 806)
 *
 * Event description: User types an answer
 *
 * @param {typeInParams} params - The parameters for this event
 * @property {string} screen_name - screen_name
 * @property {string} screen_version - screen version
 * @property {number} returnedResults - numbers of results
 * @property {string} text - type in text
 * @property {string} flow - flow
 * @property {string} platform - wix or edix
 * @return {LogObject<typeInParams>} LogObject<typeInParams>
 */
export function typeIn(params) {
    return { evid: 806, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'notificationShownOnTemplatesPage' event (evid: 807)
 *
 * Event description: notification on tamplate page
 *
 * @param {notificationShownOnTemplatesPageParams} params - The parameters for this event
 * @property {string} name - name of banner
 * @property {string} tab_name - templates, wireframes, all
 * @property {string} text - text on banner
 * @property {string} workspace - yes/no
 * @return {LogObject<notificationShownOnTemplatesPageParams>} LogObject<notificationShownOnTemplatesPageParams>
 */
export function notificationShownOnTemplatesPage(params) {
    return { evid: 807, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnNotificationOnTemplatesPage' event (evid: 808)
 *
 * Event description: Click on Notification on Templates page
 *
 * @param {clickOnNotificationOnTemplatesPageParams} params - The parameters for this event
 * @property {string} name - name of banner
 * @property {string} tab_name - templates, wireframes, all
 * @property {string} text - text on banner
 * @property {string} workspace - yes/no
 * @property {string} cta - text on cta
 * @return {LogObject<clickOnNotificationOnTemplatesPageParams>} LogObject<clickOnNotificationOnTemplatesPageParams>
 */
export function clickOnNotificationOnTemplatesPage(params) {
    return { evid: 808, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'closeNotificationOnTemplatesPage' event (evid: 809)
 *
 * Event description: Close Notification on Templates page
 *
 * @param {closeNotificationOnTemplatesPageParams} params - The parameters for this event
 * @property {string} name - name of banner
 * @property {string} tab_name - templates, wireframes, all
 * @property {string} text - text on banner
 * @property {string} workspace - yes/no
 * @return {LogObject<closeNotificationOnTemplatesPageParams>} LogObject<closeNotificationOnTemplatesPageParams>
 */
export function closeNotificationOnTemplatesPage(params) {
    return { evid: 809, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pageView' event (evid: 8301)
 *
 * Event description: Should be fired when a page is fully loaded (it is up to a consumer to decide when to consider a page as fully loaded)
 *
 * @param {pageViewParams} params - The parameters for this event
 * @property {string} flow - flow’s BI slug
 * @property {string} page - page’s BI slug
 * @return {LogObject<pageViewParams>} LogObject<pageViewParams>
 */
export function pageView(params) {
    return { evid: 8301, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'transitionStarted' event (evid: 8302)
 *
 * Event description: should be fired after the transition is initialized
 *
 * @param {transitionStartedParams} params - The parameters for this event
 * @property {string} direction - backward/forward
 * @property {string} origin - previous page’s BI slug
 * @property {string} flow - flow’s BI slug
 * @property {boolean} is_external - true, for external transitions only
 * @property {string} destination - destination page’s BI slug, for internal transitions only
 * @return {LogObject<transitionStartedParams>} LogObject<transitionStartedParams>
 */
export function transitionStarted(params) {
    return { evid: 8302, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'transitionFinished' event (evid: 8303)
 *
 * Event description: should be fired after the transition, that was started, is finished
 *
 * @param {transitionFinishedParams} params - The parameters for this event
 * @property {string} direction - forward/backward
 * @property {string} origin - previous page’s BI slug
 * @property {string} flow - flow’s BI slug
 * @property {boolean} is_external - true, for external transitions only
 * @property {string} destination - destination page’s BI slug, for internal transitions only
 * @return {LogObject<transitionFinishedParams>} LogObject<transitionFinishedParams>
 */
export function transitionFinished(params) {
    return { evid: 8303, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'potentialBusiness' event (evid: 8500)
 *
 * Event description: Potential business domain.
 *
 * @param {potentialBusinessParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {boolean} is_private_domain - domain is not on the list of known public domains
 * @property {boolean} isPotentialEnterprise - isPotentialEnterprise
 * @property {boolean} is_business_domain - email domain is on business domains DB
 * @property {boolean} isPotentialPartner - isPotentialPartner
 * @return {LogObject<potentialBusinessParams>} LogObject<potentialBusinessParams>
 */
export function potentialBusiness(params) {
    return { evid: 8500, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageMicroCategorySrc2Evid856' event (evid: 856)
 *
 * Event description: Usage of the micro categories
 *
 * @param {templatesPageMicroCategorySrc2Evid856Params} params - The parameters for this event
 * @property {string} micro_category - Current micro-category selected
 * @property {string} click_source - header/tags/mobile_menu
 * @property {number} page_index - page_index
 * @property {string} book - CMS book name
 * @property {string} header_type - the type of header (default/sticky) in which the click/hover was performed
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} category_group - Category group (Business & Org, Store, etc.)
 * @property {string} selected_value - (Optional) chosen category
 * @property {string} category - Current main category performed in
 * @property {string} platform - platform
 * @property {string} action - Open/Close/Select
 * @property {string} product - product
 * @property {string} sub_category - sub_category
 * @return {LogObject<templatesPageMicroCategorySrc2Evid856Params>} LogObject<templatesPageMicroCategorySrc2Evid856Params>
 */
export function templatesPageMicroCategorySrc2Evid856(params) {
    return { evid: 856, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mobileIntroRecoverySmsSent' event (evid: 8600)
 *
 * Event description: Mobile Intro - Recovery SMS Sent
 *
 * @param {mobileIntroRecoverySmsSentParams} params - The parameters for this event
 * @property {string} userGuid - uuid
 * @property {string} flow - flow name
 * @property {string} content - content of the SMS
 * @return {LogObject<mobileIntroRecoverySmsSentParams>} LogObject<mobileIntroRecoverySmsSentParams>
 */
export function mobileIntroRecoverySmsSent(params) {
    return { evid: 8600, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mobileIntroRecoverySmsSentSrc2Evid8701' event (evid: 8701)
 *
 * Event description: Mobile Intro - Recovery SMS Sent - server version.
 *
 * @param {mobileIntroRecoverySmsSentSrc2Evid8701Params} params - The parameters for this event
 * @property {string} userGuid - uuid
 * @property {string} flow - flow name
 * @property {string} content - content of the SMS
 * @return {LogObject<mobileIntroRecoverySmsSentSrc2Evid8701Params>} LogObject<mobileIntroRecoverySmsSentSrc2Evid8701Params>
 */
export function mobileIntroRecoverySmsSentSrc2Evid8701(params) {
    return { evid: 8701, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioTpPageView' event (evid: 900)
 *
 * Event description: Wix Studio TP - Page View
 *
 * @param {wixStudioTpPageViewParams} params - The parameters for this event
 * @property {string} tab_name - templates, wireframes
 * @property {string} browse_type - browse_type
 * @property {string} browse_value - browse_value
 * @property {string} origin - the src from which the user was redirected to the current page
 * @property {string} page_type - main, pitch
 * @property {string} criteria - criteria
 * @property {number} page_num - page number in pagination
 * @return {LogObject<wixStudioTpPageViewParams>} LogObject<wixStudioTpPageViewParams>
 */
export function wixStudioTpPageView(params) {
    return { evid: 900, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioTpMainAction' event (evid: 901)
 *
 * Event description: Wix Studio TP - Main Action
 *
 * @param {wixStudioTpMainActionParams} params - The parameters for this event
 * @property {number} template_index - template_index
 * @property {string} tab_name - templates, wireframes
 * @property {string} browse_type - browse_type
 * @property {string} slug_id - slug_id
 * @property {string} browse_value - browse_value
 * @property {string} origin - the src from which the user was redirected to the current page
 * @property {string} title - template title
 * @property {string} button_version - button_version
 * @property {string} page_type - main, pitch
 * @property {string} action - edit, view
 * @property {string} template_id - template_id
 * @property {number} inspirational_index - inspirational templates index
 * @property {number} page_num - page number in pagination
 * @property {string} category_id - based on CMS category
 * @property {string} criteria - criteria
 * @return {LogObject<wixStudioTpMainActionParams>} LogObject<wixStudioTpMainActionParams>
 */
export function wixStudioTpMainAction(params) {
    return { evid: 901, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioTpGeneralAction' event (evid: 902)
 *
 * Event description: Wix Studio TP - General Action
 *
 * @param {wixStudioTpGeneralActionParams} params - The parameters for this event
 * @property {boolean} is_header - is_header
 * @property {string} tab_name - templates, wireframes
 * @property {string} browse_type - browse_type
 * @property {string} browse_value - browse_value
 * @property {string} origin - the src from which the user was redirected to the current page
 * @property {string} page_type - main, pitch
 * @property {string} action - General Action
 * @property {string} action_value - action_value
 * @property {boolean} is_sticky -  true if the header is sticky at the time of the click, and false if it is at the top of the page.
 * @property {number} page_num - page number in pagination
 * @property {string} slug_id - slug_id
 * @property {string} template_id - template_id
 * @property {number} template_index - template index
 * @property {string} category_id - category ID based on CMS
 * @property {string} criteria - criteria
 * @return {LogObject<wixStudioTpGeneralActionParams>} LogObject<wixStudioTpGeneralActionParams>
 */
export function wixStudioTpGeneralAction(params) {
    return { evid: 902, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioTpHover' event (evid: 903)
 *
 * Event description: Wix Studio TP - When a user has a template above the fold on the Studio Templates Page
 *
 * @param {wixStudioTpHoverParams} params - The parameters for this event
 * @property {number} template_index - template_index
 * @property {string} tab_name - templates, wireframes
 * @property {string} browse_type - browse_type
 * @property {string} slug_id - slug_id
 * @property {string} browse_value - browse_value
 * @property {number} window_width - Initial width of client window
 * @property {string} origin - the src from which the user was redirected to the current page
 * @property {string} title - template title
 * @property {number} window_height - Initial height of client window
 * @property {string} page_type - main, pitch
 * @property {string} template_id - template_id
 * @property {string} category_id - category Id based on CMS
 * @property {string} criteria - criteria
 * @return {LogObject<wixStudioTpHoverParams>} LogObject<wixStudioTpHoverParams>
 */
export function wixStudioTpHover(params) {
    return { evid: 903, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixStudioTpSearchSrc2Evid904' event (evid: 904)
 *
 * Event description: Studio templates -> search
 *
 * @param {wixStudioTpSearchSrc2Evid904Params} params - The parameters for this event
 * @property {string} criteria - criteria
 * @property {number} numberOfTemplates - templates_cnt
 * @property {boolean} is_sticky - true if the header is sticky at the time of the click, and false if it is at the top of the page.
 * @return {LogObject<wixStudioTpSearchSrc2Evid904Params>} LogObject<wixStudioTpSearchSrc2Evid904Params>
 */
export function wixStudioTpSearchSrc2Evid904(params) {
    return { evid: 904, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'enterpriseDemoDashboardPageView' event (evid: 9501)
 *
 * Event description: Enterprise Demo Dashboard - Page View
 *
 * @param {enterpriseDemoDashboardPageViewParams} params - The parameters for this event
 * @property {string} pageName - page_name
 * @return {LogObject<enterpriseDemoDashboardPageViewParams>} LogObject<enterpriseDemoDashboardPageViewParams>
 */
export function enterpriseDemoDashboardPageView(params) {
    return { evid: 9501, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'enterpriseDemoDashboardSawWidget' event (evid: 9502)
 *
 * Event description:  Enterprise Demo Dashboard - Saw Widget
 *
 * @param {enterpriseDemoDashboardSawWidgetParams} params - The parameters for this event
 * @property {string} widgetname - widget_name
 * @property {string} platformName - platform_name
 * @property {string} additional_info - additional_info
 * @return {LogObject<enterpriseDemoDashboardSawWidgetParams>} LogObject<enterpriseDemoDashboardSawWidgetParams>
 */
export function enterpriseDemoDashboardSawWidget(params) {
    return { evid: 9502, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'enterpriseDemoDashboardWidgetActions' event (evid: 9503)
 *
 * Event description: Enterprise Demo Dashboard - Widget Actions
 *
 * @param {enterpriseDemoDashboardWidgetActionsParams} params - The parameters for this event
 * @property {string} widgetname - widget_name
 * @property {string} action - action
 * @return {LogObject<enterpriseDemoDashboardWidgetActionsParams>} LogObject<enterpriseDemoDashboardWidgetActionsParams>
 */
export function enterpriseDemoDashboardWidgetActions(params) {
    return { evid: 9503, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'enterpriseDemoDashboardGeneralClick' event (evid: 9542)
 *
 * Event description: Enterprise Demo Dashboard - General click
 *
 * @param {enterpriseDemoDashboardGeneralClickParams} params - The parameters for this event
 * @property {string} name - the button name
 * @property {string} targetUrl - target_url
 * @property {string} section - sidebar/page
 * @property {string} pageName - current page_name
 * @return {LogObject<enterpriseDemoDashboardGeneralClickParams>} LogObject<enterpriseDemoDashboardGeneralClickParams>
 */
export function enterpriseDemoDashboardGeneralClick(params) {
    return { evid: 9542, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfTemplatesSwitchToTablet' event (evid: 98)
 *
 * Event description: user switched to tablet view
 *
 * @param {copyOfTemplatesSwitchToTabletParams} params - The parameters for this event
 * @property {number} page_index - page_index
 * @property {Url} originappurl - only html template viewer send this property
 * @property {number} siteType - site type
 * @property {string} category - the create page category
 * @property {string} platform - platform
 * @property {GUID} openingSiteID - template id
 * @property {string} product - product
 * @return {LogObject<copyOfTemplatesSwitchToTabletParams>} LogObject<copyOfTemplatesSwitchToTabletParams>
 */
export function copyOfTemplatesSwitchToTablet(params) {
    return { evid: 98, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'templatesPageGalleryFilterPane' event (evid: 99)
 *
 * Event description: Usage of the templates page filter pane
 *
 * @param {templatesPageGalleryFilterPaneParams} params - The parameters for this event
 * @property {string} updated_layouts - List of selected layouts after the update
 * @property {number} page_index - page_index
 * @property {string} updated_sorting - Applied sorting after the update
 * @property {string} book - CMS book name
 * @property {string} updated_features - List of selected features after the update
 * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
 * @property {string} updated_colors - List of selected colors after the update
 * @property {string} subcategory - Current sub-category performed in
 * @property {string} updated_styles - List of selected styles after the update
 * @property {string} menu_name - features / colors / layouts / styles / sort / all
 * @property {string} category - Current main category performed in
 * @property {string} clicked_value - the filter/sort value on which the user clicked (either to select or unselect)
 * @property {string} platform - platform
 * @property {string} previous_values - Previous list of values before the update
 * @property {string} action - open / close / select / unselect / hover / clear / show / hide
 * @property {string} updated_values - List of selected values after the update
 * @property {string} product - product
 * @return {LogObject<templatesPageGalleryFilterPaneParams>} LogObject<templatesPageGalleryFilterPaneParams>
 */
export function templatesPageGalleryFilterPane(params) {
    return { evid: 99, src: 2, endpoint: '', params };
}
/**
 * A function to create a log object for the 'microActionAdditionalInfo' event (evid: 1895)
 *
 * Event description: Micro Action - Additional Info
 *
 * @param {microActionAdditionalInfoParams} params - The parameters for this event
 * @property {string} asset_version - asset_version
 * @property {string} offering_name - offering_name
 * @property {string} info_value - info_value
 * @property {string} asset_location_on_page - (0,1,2,3)
 * @property {string} info_origin - info_origin
 * @property {string} offering_guid - offering_guid
 * @property {string} info_type - info_type
 * @property {string} origin - sidebar / dashboard
 * @property {GUID} msid - msid
 * @property {string} campaign_id - campaign_id
 * @property {string} placement_id - placement_id
 * @return {LogObject<microActionAdditionalInfoParams>} LogObject<microActionAdditionalInfoParams>
 */
export function microActionAdditionalInfo(params) {
    return { evid: 1895, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyName' event (evid: 2600)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameParams} params - The parameters for this event
 * @return {LogObject<dummyNameParams>} LogObject<dummyNameParams>
 */
export function dummyName(params) {
    return { evid: 2600, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'modalPageLoaded' event (evid: 2700)
 *
 * Event description: Any Focus Widget Modal - Page Loaded
 *
 * @param {modalPageLoadedParams} params - The parameters for this event
 * @property {string} initial_data - installed apps, recommended apps
 * @property {string} site_type - site's type
 * @property {string} error_type - error type
 * @property {string} modal_name - modal name
 * @property {string} business_term_id - business_term_id
 * @property {string} modal_version_name - modal_version_name
 * @property {string} site_goal - site_goal
 * @property {boolean} is_error - did the page load with an error?
 * @return {LogObject<modalPageLoadedParams>} LogObject<modalPageLoadedParams>
 */
export function modalPageLoaded(params) {
    return { evid: 2700, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'modalAnyClick' event (evid: 2701)
 *
 * Event description: Any Focus Widget Modal - Any Click
 *
 * @param {modalAnyClickParams} params - The parameters for this event
 * @property {string} section_name - section name
 * @property {string} button_name - button name
 * @property {string} site_type - site's type
 * @property {string} modal_name - modal name
 * @property {string} business_term_id - business_term_id
 * @property {string} modal_version_name - modal_version_name
 * @property {string} app_name - app_name
 * @property {string} app_id - app_id
 * @property {string} value_name - value_name
 * @property {number} index - index
 * @return {LogObject<modalAnyClickParams>} LogObject<modalAnyClickParams>
 */
export function modalAnyClick(params) {
    return { evid: 2701, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantChatContentViewSrc5Evid2702' event (evid: 2702)
 *
 * Event description: AI Assistant - Chat Content View.
 *
 * @param {aiAssistantChatContentViewSrc5Evid2702Params} params - The parameters for this event
 * @return {LogObject<aiAssistantChatContentViewSrc5Evid2702Params>} LogObject<aiAssistantChatContentViewSrc5Evid2702Params>
 */
export function aiAssistantChatContentViewSrc5Evid2702(params) {
    return { evid: 2702, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'assistantChatContentView' event (evid: 2710)
 *
 * Event description: chat content view
 *
 * @param {assistantChatContentViewParams} params - The parameters for this event
 * @property {string} provider - agent / user
 * @property {string} platformName - platform name
 * @property {string} contentVersion - content_version
 * @property {string} contentType - widget / text
 * @property {GUID} conversationId - conv id
 * @property {string} content - the content itself
 * @property {number} orderIndex - order index of the message
 * @return {LogObject<assistantChatContentViewParams>} LogObject<assistantChatContentViewParams>
 */
export function assistantChatContentView(params) {
    return { evid: 2710, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantActionsInTypingConsole' event (evid: 2711)
 *
 * Event description: AI Assistant - Actions In Typing Console
 *
 * @param {aiAssistantActionsInTypingConsoleParams} params - The parameters for this event
 * @property {string} platformName - platform name
 * @property {string} section - section
 * @property {string} previousQuestionContent - the content of the question before the action
 * @property {GUID} conversationId - ConversationId
 * @property {number} orderIndex - the index of the last message
 * @property {string} value - the answer that the user typed
 * @property {string} action - action in chat
 * @return {LogObject<aiAssistantActionsInTypingConsoleParams>} LogObject<aiAssistantActionsInTypingConsoleParams>
 */
export function aiAssistantActionsInTypingConsole(params) {
    return { evid: 2711, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantGeneralClicks' event (evid: 2712)
 *
 * Event description: AI Assistant - General Clicks
 *
 * @param {aiAssistantGeneralClicksParams} params - The parameters for this event
 * @property {string} platformName - platform name
 * @property {boolean} isAnswer - is_answer
 * @property {string} targetUrl - target_url
 * @property {string} assistantName - The assistant name
 * @property {string} contentVersion - content_version
 * @property {string} previousQuestionContent - prev content
 * @property {GUID} conversationId - ConversationId
 * @property {number} orderIndex - order index of the message
 * @property {string} answer - answer
 * @property {string} buttonName - button_name
 * @property {string} value - value
 * @property {string} action - action
 * @return {LogObject<aiAssistantGeneralClicksParams>} LogObject<aiAssistantGeneralClicksParams>
 */
export function aiAssistantGeneralClicks(params) {
    return { evid: 2712, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantPlatformOpen' event (evid: 2720)
 *
 * Event description: AI Assistant - Platform Open
 *
 * @param {aiAssistantPlatformOpenParams} params - The parameters for this event
 * @property {string} uuid - uuid
 * @property {string} platformName - platform's name
 * @property {GUID} conversationID - conversation id
 * @property {string} pageName - the page in which the platform was opened on
 * @property {GUID} msid - site id
 * @return {LogObject<aiAssistantPlatformOpenParams>} LogObject<aiAssistantPlatformOpenParams>
 */
export function aiAssistantPlatformOpen(params) {
    return { evid: 2720, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantAssetShownOnDashboard' event (evid: 2730)
 *
 * Event description: Asset Shown On Dashboard - including Chat Funnel Info Strip and other tips above the FW
 *
 * @param {aiAssistantAssetShownOnDashboardParams} params - The parameters for this event
 * @property {string} section - location of the asset
 * @property {string} assetId - asset_id
 * @return {LogObject<aiAssistantAssetShownOnDashboardParams>} LogObject<aiAssistantAssetShownOnDashboardParams>
 */
export function aiAssistantAssetShownOnDashboard(params) {
    return { evid: 2730, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantClickInDashboardAsset' event (evid: 2731)
 *
 * Event description: Click In Dashboard Asset
 *
 * @param {aiAssistantClickInDashboardAssetParams} params - The parameters for this event
 * @property {string} assetId - asset_id
 * @property {string} section - location
 * @property {string} buttonName - name of the button
 * @return {LogObject<aiAssistantClickInDashboardAssetParams>} LogObject<aiAssistantClickInDashboardAssetParams>
 */
export function aiAssistantClickInDashboardAsset(params) {
    return { evid: 2731, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bizManagerFunnelWidgetSeenSrc5Evid2800' event (evid: 2800)
 *
 * Event description: User saw a Funnel widget in the Biz Mgr
 *
 * @param {bizManagerFunnelWidgetSeenSrc5Evid2800Params} params - The parameters for this event
 * @property {string} origin - origin
 * @property {GUID} msid - site guid
 * @property {string} widgetName - []
 * @property {string} widgetVersion - []
 * @property {string} pageName - []
 * @property {boolean} isSuccessful - []
 * @return {LogObject<bizManagerFunnelWidgetSeenSrc5Evid2800Params>} LogObject<bizManagerFunnelWidgetSeenSrc5Evid2800Params>
 */
export function bizManagerFunnelWidgetSeenSrc5Evid2800(params) {
    return { evid: 2800, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bizManagerFunnelWidgetClickSrc5Evid2801' event (evid: 2801)
 *
 * Event description: User clicked on a CTA in Funnel widget in the Biz Mgr
 *
 * @param {bizManagerFunnelWidgetClickSrc5Evid2801Params} params - The parameters for this event
 * @property {string} origin - origin
 * @property {GUID} msid - site guid
 * @property {string} widgetName - []
 * @property {string} widgetVersion - []
 * @property {string} pageName - []
 * @property {string} buttonName - []
 * @property {string} answer - []
 * @return {LogObject<bizManagerFunnelWidgetClickSrc5Evid2801Params>} LogObject<bizManagerFunnelWidgetClickSrc5Evid2801Params>
 */
export function bizManagerFunnelWidgetClickSrc5Evid2801(params) {
    return { evid: 2801, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bizManagerSetupPopoverOpen' event (evid: 2810)
 *
 * Event description: When the user open the setup popover
 *
 * @param {bizManagerSetupPopoverOpenParams} params - The parameters for this event
 * @property {string} pageName - page name which the popover shown over
 * @property {string} popoverType - ‘continue_with_setup’ / ‘specific_step’
 * @property {string} popoverId - specific content from the title
 * @property {string} trigger - ‘click’/’hover’/’step_completed’
 * @return {LogObject<bizManagerSetupPopoverOpenParams>} LogObject<bizManagerSetupPopoverOpenParams>
 */
export function bizManagerSetupPopoverOpen(params) {
    return { evid: 2810, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bizManagerSetupPopoverClick' event (evid: 2811)
 *
 * Event description: When the user click on a button in the setup popover
 *
 * @param {bizManagerSetupPopoverClickParams} params - The parameters for this event
 * @property {string} pageName - page name which the popover shown over
 * @property {string} popoverType - ‘continue_with_setup’ / ‘specific_step’
 * @property {string} popoverId - specific content from the title
 * @property {string} buttonName - ‘go_to_setup’/’connect_domain’/’close’
 * @return {LogObject<bizManagerSetupPopoverClickParams>} LogObject<bizManagerSetupPopoverClickParams>
 */
export function bizManagerSetupPopoverClick(params) {
    return { evid: 2811, src: 5, endpoint: '', params };
}
//# sourceMappingURL=index.js.map